export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date custom scalar type */
  Date: { input: any; output: any; }
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: { input: any; output: any; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: any; output: any; }
};

export type AcceptRequestShiftsSuggestionsInput = {
  /** Массив идентификаторов строк откликнувшихся исполнителей в таблице request_shift_suggestions */
  acceptedSuggestionIds: Array<Scalars['String']['input']>;
  /** Идентификатор графика заявки */
  requestScheduleId: Scalars['String']['input'];
};

export type Achievement = {
  __typename?: 'Achievement';
  bonus: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  /** Дата и время создания объекта */
  createdAt: Scalars['Date']['output'];
  descr: Scalars['String']['output'];
  /** Уникальный идентификатор объекта */
  id: Scalars['ID']['output'];
  progress: Scalars['Int']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Дата и время обновления объекта */
  updatedAt: Scalars['Date']['output'];
};

export type AddReferralInput = {
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type AddResponsibleToObjectInput = {
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Идентификатор пользователя */
  userId: Scalars['ID']['input'];
};

export type AddUserModerationReportInput = {
  /** Id должности */
  positionId: Scalars['String']['input'];
  /** Id табеля */
  reportId: Scalars['String']['input'];
  /** Id сотрудника */
  userId: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  address: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Расчетное поле для расстояния от гео точки в километрах */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Объект */
  facility: Facility;
  fiasId?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Анкета */
  questionnaire: Questionnaire;
  settlement?: Maybe<Scalars['String']['output']>;
  /** Часовой пояс */
  timezone: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type AddressEntity = {
  __typename?: 'AddressEntity';
  /** Адрес */
  addressText: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Широта */
  lat: Scalars['Float']['output'];
  /** Долгота */
  lon: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Статус подписания АД и согласия на обработку ПД в Наймикс */
export enum ApAndPdStateEnum {
  NotSign = 'NOT_SIGN',
  Sign = 'SIGN',
  SigningInProgress = 'SIGNING_IN_PROGRESS'
}

/** App type */
export enum AppType {
  All = 'ALL',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type ArchiveReferralProgramInput = {
  /** Идентификатор реферальной программы */
  id: Scalars['String']['input'];
};

export type AreThereAnyFreeShiftsModel = {
  __typename?: 'AreThereAnyFreeShiftsModel';
  accepted: Scalars['Int']['output'];
  free: Scalars['Int']['output'];
  waiting: Scalars['Int']['output'];
};

export type AssignTemporaryShiftInput = {
  /** Id назначенного пользователя */
  assigneeId: Scalars['String']['input'];
  /** Id подработки */
  temporaryShiftId: Scalars['String']['input'];
};

export type Auth = {
  __typename?: 'Auth';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
  user: User;
};

/** Модель с информацией о способе входа и типе приложения для которого вход */
export type AuthOption = {
  __typename?: 'AuthOption';
  /** В для какого типа ПО вход - админка или мобилка dashboard|mobile */
  applicationType?: Maybe<Scalars['String']['output']>;
  /** Способ входа - пароль или смс (password|sms-message) */
  loginMethod?: Maybe<Scalars['String']['output']>;
  smsError?: Maybe<Scalars['String']['output']>;
};

/** Параметры для пакетного создания профессии для группы объектов */
export type BatchCasingCardInput = {
  /** Массив ID городов + ID объектов */
  citiesAndFacilitiesIds: Array<Scalars['String']['input']>;
  /** Описание ставки */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id группы объектов */
  facilityGroupId: Scalars['String']['input'];
  /** Id Объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Возможность обучения */
  hasEducation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Возможность стажировки */
  hasProbation?: Scalars['Boolean']['input'];
  /** Размер оплаты в час */
  hourRate: Scalars['Float']['input'];
  /** Проверять ли статус мед. книжки при назначении смен/графиков */
  isMedBookRequired?: Scalars['Boolean']['input'];
  /** Возможность оформления самозанятости на этой должности */
  isSelfEmployed?: Scalars['Boolean']['input'];
  /** Тип выплаты за работу */
  payout?: InputMaybe<PayoutType>;
  /** Id Должности */
  positionId: Scalars['String']['input'];
  /** Период стажировки в календарных днях */
  probationPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Ставка за смену на период стажировки */
  probationRate?: InputMaybe<Scalars['Int']['input']>;
  requiredDocuments?: Array<CasingDocumentType>;
  /** Надбавка к часовой ставке за самозанятость у работника */
  selfEmployedRate?: InputMaybe<Scalars['Int']['input']>;
  /** Единицы измерения для оплаты */
  unit?: InputMaybe<UnitType>;
};

export type BatchCreateVacancyCoverPhotoInput = {
  coverPhotoId: Scalars['ID']['input'];
  facilityId: Scalars['String']['input'];
};

export type BatchVacancyInput = {
  /** Средняя стоимость оплаты по смене */
  averageCost?: Scalars['Float']['input'];
  /** Массив ID городов + ID объектов */
  citiesAndFacilitiesIds: Array<Scalars['String']['input']>;
  /** IDs стран */
  citizenshipsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Идентификатор фотографии альбома */
  coverPhotoId?: InputMaybe<Scalars['ID']['input']>;
  coverPhotos?: InputMaybe<Array<BatchCreateVacancyCoverPhotoInput>>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Примечание к документам */
  documentsNotes?: InputMaybe<Scalars['String']['input']>;
  /** Group Id in ERP */
  erpGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор нстанса для отправки в ERP */
  erpInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Source Id in ERP */
  erpSourceId?: InputMaybe<Scalars['String']['input']>;
  facilityGroupId: Scalars['String']['input'];
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Возможность образования */
  hasEducation?: InputMaybe<Scalars['Boolean']['input']>;
  hourRate: Scalars['Float']['input'];
  isActive?: Scalars['Boolean']['input'];
  isDeleted?: Scalars['Boolean']['input'];
  /** публиковать стоимость смены */
  isPublishCostOfShift?: Scalars['Boolean']['input'];
  /** Отображать в вакансии диапазон стоимости ОТ-ДО */
  isRangeCost?: Scalars['Boolean']['input'];
  /** Длительность обеденного перерыва в минутах */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Максимальный возраст */
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  /** Минимальный возраст */
  minAge?: InputMaybe<Scalars['Int']['input']>;
  /** Примечание */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Тип выплаты за работу */
  payout?: InputMaybe<PayoutType>;
  /** Частота выплат */
  payoutFrequency?: InputMaybe<PayoutFrequency>;
  /** День / Ночь */
  period: ShiftTime;
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Кол-во дней стажировки */
  probationPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Необходимые документы */
  requiredDocuments?: Array<CasingDocumentType>;
  /** Требования */
  requirements?: InputMaybe<Scalars['String']['input']>;
  /** Обязанности */
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  /** IDs типов графиков */
  scheduleTypesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  section?: InputMaybe<Scalars['String']['input']>;
  /** Пол */
  sex?: InputMaybe<Sex>;
  /** Минимальная стоимость оплаты по смене от */
  shiftCostFrom?: Scalars['Float']['input'];
  /** Максимальная стоимость оплаты по смене до */
  shiftCostUpTo?: Scalars['Float']['input'];
  timeEnd?: InputMaybe<Scalars['String']['input']>;
  timeStart?: InputMaybe<Scalars['String']['input']>;
  /** Транспорт */
  transport?: InputMaybe<Scalars['String']['input']>;
  /** Единицы измерения для оплаты */
  unit?: InputMaybe<UnitType>;
  /** Спец. одежда */
  workwear?: Scalars['Boolean']['input'];
};

export type BonusAndRate = {
  __typename?: 'BonusAndRate';
  achievements: Array<Achievement>;
  /** заработанная сумма с начала месяца */
  amountEarned: Scalars['Float']['output'];
  bonuses: Array<Achievement>;
  /** Дата и время создания объекта */
  createdAt: Scalars['Date']['output'];
  /** Сухой прогноз заработка за весь месяц без вычетов */
  dryAmountPerMonth: Scalars['Float']['output'];
  /** Уникальный идентификатор объекта */
  id: Scalars['ID']['output'];
  payments: Array<Payment>;
  /** Должность и ставка по объекту */
  rates: Array<RatesOutput>;
  shifts: Array<Shift>;
  /** Итоговый бонус к ставке */
  totalBonus: Scalars['Float']['output'];
  /** Прогноз заработка за остающиеся смены до конца месяца */
  upcomingAmount: Scalars['Float']['output'];
  /** Дата и время обновления объекта */
  updatedAt: Scalars['Date']['output'];
  userId: Scalars['String']['output'];
};

export type BookAShiftInTheScheduleInput = {
  requestScheduleId: Scalars['ID']['input'];
  requestShiftIds: Array<Scalars['ID']['input']>;
};

export type CancelPlanCasingRateInput = {
  casingRateId: Scalars['String']['input'];
};

export type CancelPlannedObjectProfessionRateInput = {
  /** Идентификатор запланированной ставки профессии объекта */
  objectProfessionRateId: Scalars['ID']['input'];
};

/** Модель ставки (часовой оплаты по профессии на объекте) */
export type Casing = {
  __typename?: 'Casing';
  /** Галерея фотографий профессии объекта */
  casingGallery?: Maybe<Array<CasingGalleryEntity>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentProbationRate?: Maybe<CasingRateEntity>;
  currentRate: CasingRateEntity;
  description?: Maybe<Scalars['String']['output']>;
  doCheckMedBook: Scalars['Boolean']['output'];
  facility: Facility;
  facilityId: Scalars['String']['output'];
  /** Возможность образования */
  hasEducation?: Maybe<Scalars['Boolean']['output']>;
  hasProbation: Scalars['Boolean']['output'];
  /**
   * Размер оплаты в час
   * @deprecated Теперь хранится отдельной сущностью
   */
  hourRate: Scalars['Float']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Проверять ли статус мед. книжки при назначении смен/графиков */
  isMedBookRequired: Scalars['Boolean']['output'];
  isSelfEmployed?: Maybe<Scalars['Boolean']['output']>;
  payout: PayoutType;
  plannedProbationRate?: Maybe<CasingRateEntity>;
  plannedRate?: Maybe<CasingRateEntity>;
  position: Position;
  positionId: Scalars['String']['output'];
  probationPeriod?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Теперь хранится отдельной сущностью */
  probationRate?: Maybe<Scalars['Int']['output']>;
  probationRateHistory?: Maybe<Array<CasingRateEntity>>;
  rateHistory?: Maybe<Array<CasingRateEntity>>;
  /** Необходимые документы */
  requiredDocuments: Array<CasingDocumentType>;
  selfEmployedRate?: Maybe<Scalars['Int']['output']>;
  unit: UnitType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workPosts?: Maybe<Array<WorkPost>>;
};

/** DTO инпутов карточки работы с моделью ставки (часовой оплаты по профессии на объекте) */
export type CasingCardInput = {
  /** Описание ставки */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id Объекта */
  facilityId: Scalars['String']['input'];
  /** Возможность обучения */
  hasEducation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Возможность стажировки */
  hasProbation?: Scalars['Boolean']['input'];
  /** Размер оплаты в час */
  hourRate: Scalars['Float']['input'];
  /** Проверять ли статус мед. книжки при назначении смен/графиков */
  isMedBookRequired?: Scalars['Boolean']['input'];
  /** Возможность оформления самозанятости на этой должности */
  isSelfEmployed?: Scalars['Boolean']['input'];
  /** Тип выплаты за работу */
  payout?: InputMaybe<PayoutType>;
  /** Id Должности */
  positionId: Scalars['String']['input'];
  /** Период стажировки в календарных днях */
  probationPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Ставка за смену на период стажировки */
  probationRate?: InputMaybe<Scalars['Int']['input']>;
  requiredDocuments?: Array<CasingDocumentType>;
  /** Надбавка к часовой ставке за самозанятость у работника */
  selfEmployedRate?: InputMaybe<Scalars['Int']['input']>;
  /** Единицы измерения для оплаты */
  unit?: InputMaybe<UnitType>;
};

/** Необходимые документы для профессии на объекте */
export enum CasingDocumentType {
  BankCard = 'BANK_CARD',
  Inn = 'INN',
  MedBook = 'MED_BOOK',
  Passport = 'PASSPORT',
  Registration = 'REGISTRATION'
}

export type CasingGalleryEntity = {
  __typename?: 'CasingGalleryEntity';
  casing: Casing;
  /** Идентификатор профессии на объекте */
  casingId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  file?: Maybe<File>;
  /** Идентификатор файла с фотографией */
  fileId?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CasingRateEntity = {
  __typename?: 'CasingRateEntity';
  authorId: Scalars['String']['output'];
  casing: Casing;
  casingId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isProbation: Scalars['Boolean']['output'];
  rate: Scalars['Float']['output'];
  startDatetime: Scalars['Date']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Подписка на событие пакетного создания профессий */
export type CasingsForemanSubscriptionOutput = {
  __typename?: 'CasingsForemanSubscriptionOutput';
  /** Массив профессий на объекте */
  casings: Array<Casing>;
  /** Id бригадира */
  foremanId: Scalars['String']['output'];
};

export type ChangeArrestedPaymentInput = {
  /** Идентификатор удержания */
  id: Scalars['String']['input'];
  /** Сумма удержания */
  sum: Scalars['Float']['input'];
};

export type ChangeModerationInput = {
  /** Причина комментария */
  cause?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий модерации */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Количество сотрудников в отчете */
  duration?: Scalars['Int']['input'];
  /** Ставка отредактированная */
  hourRate: Scalars['Float']['input'];
  /** Ставка за смену на период стажировки */
  probationRate?: InputMaybe<Scalars['Float']['input']>;
  /** Id смены для которой создана модерация */
  shiftId: Scalars['String']['input'];
  /** К оплате? */
  toPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Учитывать смену в бонусной системе? */
  toPaymentBonus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Значение выработки для сдельной формы работы */
  value: Scalars['Float']['input'];
};

export type ChangeModerationUserPosition = {
  /** Id должности */
  positionId: Scalars['String']['input'];
  /** Id сотрудника */
  userId: Scalars['String']['input'];
};

export type ChangeModerationUserRowInput = {
  /** Id табеля */
  reportId: Scalars['String']['input'];
  /** Статус оплаты, который необходимо установить */
  toPayment: Scalars['Boolean']['input'];
  /** Массив смен в дне */
  userPositions: Array<ChangeModerationUserPosition>;
};

export type ChangeObjectActivityStateInput = {
  /** Состояние активности объекта */
  isActive: Scalars['Boolean']['input'];
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
};

export type ChangePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type ChangeResolveReportUserInput = {
  /** Исключить из отчета */
  disable?: Scalars['Boolean']['input'];
  /** id */
  id: Scalars['String']['input'];
  /** Фамилия и Имя */
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeSalaryPaymentInput = {
  /** Идентификатор надбавки */
  id: Scalars['String']['input'];
  /** Сумма надбавки */
  sum: Scalars['Float']['input'];
};

export type ChangeScheduleInput = {
  /** Обязательное! время окончания графика */
  dateEnd: Scalars['DateTime']['input'];
  /** Обязательное! время начала графика */
  dateStart: Scalars['DateTime']['input'];
  /** объект на который устанавливается график */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lunch?: Scalars['Boolean']['input'];
  /** длительность обеда в минутах */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** позиция на которую устанавливается график */
  positionId?: InputMaybe<Scalars['String']['input']>;
  shiftDuration?: InputMaybe<Scalars['String']['input']>;
  /** Обязательное! Время окончания первой смены в графике для определения длительности смены */
  shiftEndDate: Scalars['DateTime']['input'];
  /** Тип графика: 1 - 2/2; 2 - 4/2; 3 - 5/2; 4 - 6/1; 5 - 7/0; 6 - 3/3; 7 - 3/4; 8 - 4/3, 9 - 3/2 (рабочих дней / выходные) */
  type?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор типа графика */
  typeId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type ChangeShiftArrestedPaymentInput = {
  /** Идентификатор удержания */
  id: Scalars['String']['input'];
  /** Сумма удержания */
  sum: Scalars['Float']['input'];
};

export type ChangeShiftSalaryPaymentInput = {
  /** Идентификатор надбавки */
  id: Scalars['String']['input'];
  /** Сумма надбавки */
  sum: Scalars['Float']['input'];
};

export type ChangeShiftStageInput = {
  /** Комментарий бригадира */
  comment?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /** новый статус смены */
  stage: ShiftStage;
};

export type ChangeUserInfoMainInput = {
  /** Дата рождения пользователя */
  birthDate: Scalars['String']['input'];
  /** Идентификатор гражданства пользователя */
  citizenshipId: Scalars['String']['input'];
  /** Имя пользователя */
  firstname: Scalars['String']['input'];
  /** Фамилия пользователя */
  lastname: Scalars['String']['input'];
  /** Отчество пользователя */
  patronymic?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeUserInfoMainModel = {
  __typename?: 'ChangeUserInfoMainModel';
  /** Дата рождения пользователя */
  birthDate: Scalars['String']['output'];
  /** Идентификатор гражданства пользователя */
  citizenshipId: Scalars['String']['output'];
  /** Имя пользователя */
  firstname: Scalars['String']['output'];
  /** Идентификатор пользователя */
  id: Scalars['String']['output'];
  /** Фамилия пользователя */
  lastname: Scalars['String']['output'];
  /** Отчество пользователя */
  patronymic?: Maybe<Scalars['String']['output']>;
};

export type ChartDataOutput = {
  __typename?: 'ChartDataOutput';
  /** it is a date */
  createdAt: Scalars['Date']['output'];
  /** it is a value */
  value: Scalars['Int']['output'];
};

export type ChartOutput = {
  __typename?: 'ChartOutput';
  /** Данные для графика */
  data: Array<ChartDataOutput>;
  /** Id группы объектов */
  facilityGroupId?: Maybe<Scalars['ID']['output']>;
  /** Id объекта */
  facilityId?: Maybe<Scalars['ID']['output']>;
  /** Тип графика */
  type: ChartType;
};

/** Тип графика для дашборда */
export enum ChartType {
  AcceptedShifts = 'ACCEPTED_SHIFTS',
  CountForemen = 'COUNT_FOREMEN',
  CountSupervisors = 'COUNT_SUPERVISORS',
  CountWorkers = 'COUNT_WORKERS',
  FinishedShifts = 'FINISHED_SHIFTS',
  GoodFinishedShiftsRatio = 'GOOD_FINISHED_SHIFTS_RATIO',
  GoodShifts = 'GOOD_SHIFTS',
  Latecomers = 'LATECOMERS',
  Registrations = 'REGISTRATIONS',
  WorkingShifts = 'WORKING_SHIFTS'
}

export type CheckNaimixContractorStatusInput = {
  inn: Scalars['String']['input'];
  /** Признак подтверждения пользователем объединения аккаунтов */
  mergeAccounts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Статусы проверки ИНН пользователя перед регистрацией в Наймикс */
export enum CheckNaimixContractorStatusResponseEnum {
  /** Пользователь может продолжить регистрацию */
  ContinueRegistration = 'CONTINUE_REGISTRATION',
  /** ИНН занят другим пользователем, но в Наймикс ИНН не зарегистрирован */
  InnIsBusyInSmena = 'INN_IS_BUSY_IN_SMENA',
  /** Аккаунты успешно объединены */
  Merged = 'MERGED',
  /** Готов к объединению профилей */
  SuccessToMerge = 'SUCCESS_TO_MERGE',
  /** Номер пользователя отличается от того, что указан в Наймикс */
  TheNumberIsDifferentFromTheNumberOfNaimix = 'THE_NUMBER_IS_DIFFERENT_FROM_THE_NUMBER_OF_NAIMIX',
  /** Пользователь уже зарегистрирован в Наймикс */
  UserIsAlreadyRegistered = 'USER_IS_ALREADY_REGISTERED'
}

export type CheckNaimixContractorStatusV2Model = {
  __typename?: 'CheckNaimixContractorStatusV2Model';
  /** Сопутствующая информация к статусу */
  message?: Maybe<Scalars['String']['output']>;
  /** Статус проверки ИНН */
  status: CheckNaimixContractorStatusResponseEnum;
};

export type City = {
  __typename?: 'City';
  /** Id of the country */
  countryId?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** id города в ERP / ФИАС ID */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Станции метро относящиеся к этому городу */
  facilities: Array<Facility>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** широта */
  latitude: Scalars['String']['output'];
  /** Долгота */
  longitude: Scalars['String']['output'];
  /** Станции метро в городе */
  metroStations: Array<Facility>;
  name: Scalars['String']['output'];
  publicConditions?: Maybe<Array<PublicCondition>>;
  /** Часовой пояс города */
  timeZone: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CityEntity = {
  __typename?: 'CityEntity';
  /** Страна к которой принадлежит город */
  country: CountryEntity;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Широта */
  lat: Scalars['Float']['output'];
  /** Долгота */
  lon: Scalars['Float']['output'];
  /** Название города */
  name: Scalars['String']['output'];
  /** Часовой пояс города */
  timeZone?: Maybe<Scalars['Int']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CityInput = {
  /** ID страны */
  countryId?: InputMaybe<Scalars['String']['input']>;
  /** ID города */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Широта */
  latitude: Scalars['String']['input'];
  /** Долгота */
  longitude: Scalars['String']['input'];
  /** Название города */
  name: Scalars['String']['input'];
  /** Часовой пояс */
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type ClientUser = {
  __typename?: 'ClientUser';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Столбец Активные Смены - есть ли у работника смена на сегодня или в будущем */
  activeShifts: Scalars['Boolean']['output'];
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** Скрывать ли рейтинг пользователя */
  hideRating: Scalars['Boolean']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

export type ClientUserListInput = {
  /** Фильтрация по активным сменам (true - только с активными сменами, false - без активных, null - без фильтра) */
  activeShifts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Статус подписания договоров */
  contractStatus?: InputMaybe<UserContractStatus>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Заполненены ли платежные данные */
  paymentInfo?: InputMaybe<PaymentInfoEnum>;
  /** Статус заполнения персональной информации */
  personalInfo?: InputMaybe<UserPersonalInfoStatus>;
  /** Фильтрация по рейтингу (в строке через запятую от,до - '0,4', null - без оценки, '' - все оценки) */
  rating?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Role>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<UserFieldsForSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Добавлено ли приложение "Мой налог" в партнеры */
  taxPartnerInfo?: InputMaybe<TaxPartnerInfo>;
};

export type CommentEntity = {
  __typename?: 'CommentEntity';
  /** Автор коммента */
  author: User;
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Смена */
  shift: Shift;
  shiftId: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ContactPhone = {
  __typename?: 'ContactPhone';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  deletedAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Номер телефона с цифры 9 (без 8 или +7) */
  phone: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Объект пользователя, к которому относится номер телефона */
  user: User;
  /** Id пользователя которому принадлежит телефон */
  userId: Scalars['String']['output'];
};

export type Country = {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  externalId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isAvailableInRegistrationNaimix: Scalars['Boolean']['output'];
  isSelfEmployed: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  users: Array<User>;
};

export enum CountryCodeEnum {
  /** Андорра */
  Ad = 'AD',
  /** ОАЭ (Объединённые Арабские Эмираты) */
  Ae = 'AE',
  /** Афганистан */
  Af = 'AF',
  /** Антигуа и Барбуда */
  Ag = 'AG',
  /** Ангилья */
  Ai = 'AI',
  /** Албания */
  Al = 'AL',
  /** Армения */
  Am = 'AM',
  /** Антильские острова */
  An = 'AN',
  /** Ангола */
  Ao = 'AO',
  /** Антарктика */
  Aq = 'AQ',
  /** Аргентина */
  Ar = 'AR',
  /** Американское Самоа */
  As = 'AS',
  /** Австрия */
  At = 'AT',
  /** Австралия */
  Au = 'AU',
  /** Аруба */
  Aw = 'AW',
  /** Азербайджан */
  Az = 'AZ',
  /** Барбадос */
  Bb = 'BB',
  /** Бангладеш */
  Bd = 'BD',
  /** Бельгия */
  Be = 'BE',
  /** Буркина-Фасо */
  Bf = 'BF',
  /** Болгария */
  Bg = 'BG',
  /** Бахрейн */
  Bh = 'BH',
  /** Бурунди */
  Bi = 'BI',
  /** Бенин */
  Bj = 'BJ',
  /** Бермудские острова */
  Bm = 'BM',
  /** Бруней */
  Bn = 'BN',
  /** Боливия */
  Bo = 'BO',
  /** Бразилия */
  Br = 'BR',
  /** Багамские острова */
  Bs = 'BS',
  /** Бутан */
  Bt = 'BT',
  /** Остров Буве */
  Bv = 'BV',
  /** Ботсвана */
  Bw = 'BW',
  /** Беларусь */
  By = 'BY',
  /** Белиз */
  Bz = 'BZ',
  /** Канада */
  Ca = 'CA',
  /** Кокосовые острова */
  Cc = 'CC',
  /** ЦАР (Центральноафриканская Республика) */
  Cf = 'CF',
  /** Конго */
  Cg = 'CG',
  /** Швейцария */
  Ch = 'CH',
  /** Кот-д’Ивуар */
  Ci = 'CI',
  /** Острова Кука */
  Ck = 'CK',
  /** Чили */
  Cl = 'CL',
  /** Камерун */
  Cm = 'CM',
  /** Китай */
  Cn = 'CN',
  /** Колумбия */
  Co = 'CO',
  /** Коста-Рика */
  Cr = 'CR',
  /** Куба */
  Cu = 'CU',
  /** Кабо-Верде */
  Cv = 'CV',
  /** Остров Рождества */
  Cx = 'CX',
  /** Кипр */
  Cy = 'CY',
  /** Чехия */
  Cz = 'CZ',
  /** Германия */
  De = 'DE',
  /** Джибути */
  Dj = 'DJ',
  /** Дания */
  Dk = 'DK',
  /** Доминика */
  Dm = 'DM',
  /** Доминиканская Республика */
  Do = 'DO',
  /** Алжир */
  Dz = 'DZ',
  /** Эквадор */
  Ec = 'EC',
  /** Эстония */
  Ee = 'EE',
  /** Египет */
  Eg = 'EG',
  /** Западная Сахара */
  Eh = 'EH',
  /** Испания */
  Es = 'ES',
  /** Эфиопия */
  Et = 'ET',
  /** Финляндия */
  Fi = 'FI',
  /** Фиджи */
  Fj = 'FJ',
  /** Фолклендские острова */
  Fk = 'FK',
  /** Микронезия */
  Fm = 'FM',
  /** Фарерские острова */
  Fo = 'FO',
  /** Франция */
  Fr = 'FR',
  /** Габон */
  Ga = 'GA',
  /** Великобритания */
  Gb = 'GB',
  /** Гренада */
  Gd = 'GD',
  /** Грузия */
  Ge = 'GE',
  /** Французская Гвиана */
  Gf = 'GF',
  /** Гана */
  Gh = 'GH',
  /** Гибралтар */
  Gi = 'GI',
  /** Гренландия */
  Gl = 'GL',
  /** Гамбия */
  Gm = 'GM',
  /** Гвинея */
  Gn = 'GN',
  /** Гваделупа */
  Gp = 'GP',
  /** Экваториальная Гвинея */
  Gq = 'GQ',
  /** Греция */
  Gr = 'GR',
  /** Гватемала */
  Gt = 'GT',
  /** Гуам */
  Gu = 'GU',
  /** Гвинея-Бисау */
  Gw = 'GW',
  /** Гайана */
  Gy = 'GY',
  /** Сянган (Гонконг) */
  Hk = 'HK',
  /** Херд и Макдональд */
  Hm = 'HM',
  /** Гондурас */
  Hn = 'HN',
  /** Гаити */
  Ht = 'HT',
  /** Венгрия */
  Hu = 'HU',
  /** Индонезия */
  Id = 'ID',
  /** Ирландия */
  Ie = 'IE',
  /** Израиль */
  Il = 'IL',
  /** Остров Мэн */
  Im = 'IM',
  /** Индия */
  In = 'IN',
  /** Британская территория в Индийском океане */
  Io = 'IO',
  /** Ирак */
  Iq = 'IQ',
  /** Иран */
  Ir = 'IR',
  /** Исландия */
  Is = 'IS',
  /** Италия */
  It = 'IT',
  /** Ямайка */
  Jm = 'JM',
  /** Иордания */
  Jo = 'JO',
  /** Япония */
  Jp = 'JP',
  /** Джонстон (атолл) */
  Jt = 'JT',
  /** Кения */
  Ke = 'KE',
  /** Кыргызстан */
  Kg = 'KG',
  /** Камбоджа */
  Kh = 'KH',
  /** Кирибати */
  Ki = 'KI',
  /** Коморские острова */
  Km = 'KM',
  /** Сент-Китс и Невис */
  Kn = 'KN',
  /** КНДР (Корейская Народно-Демократическая Республика) */
  Kp = 'KP',
  /** Республика Корея */
  Kr = 'KR',
  /** Кувейт */
  Kw = 'KW',
  /** Каймановы острова */
  Ky = 'KY',
  /** Казахстан */
  Kz = 'KZ',
  /** Лаос */
  La = 'LA',
  /** Ливан */
  Lb = 'LB',
  /** Сент-Люсия */
  Lc = 'LC',
  /** Лихтенштейн */
  Li = 'LI',
  /** Шри-Ланка */
  Lk = 'LK',
  /** Либерия */
  Lr = 'LR',
  /** Лесото */
  Ls = 'LS',
  /** Литва */
  Lt = 'LT',
  /** Люксембург */
  Lu = 'LU',
  /** Латвия */
  Lv = 'LV',
  /** Ливия */
  Ly = 'LY',
  /** Марокко */
  Ma = 'MA',
  /** Монако */
  Mc = 'MC',
  /** Молдова */
  Md = 'MD',
  /** Мадагаскар */
  Mg = 'MG',
  /** Маршалловы острова */
  Mh = 'MH',
  /** Острова Мидуэй */
  Mi = 'MI',
  /** Мали */
  Ml = 'ML',
  /** Мьянма */
  Mm = 'MM',
  /** Монголия */
  Mn = 'MN',
  /** Аомынь (Макао) */
  Mo = 'MO',
  /** Марианские острова */
  Mp = 'MP',
  /** Мартиника */
  Mq = 'MQ',
  /** Мавритания */
  Mr = 'MR',
  /** Монтсеррат */
  Ms = 'MS',
  /** Мальта */
  Mt = 'MT',
  /** Маврикий */
  Mu = 'MU',
  /** Мальдивы */
  Mv = 'MV',
  /** Малави */
  Mw = 'MW',
  /** Мексика */
  Mx = 'MX',
  /** Малайзия */
  My = 'MY',
  /** Мозамбик */
  Mz = 'MZ',
  /** Намибия */
  Na = 'NA',
  /** Новая Каледония */
  Nc = 'NC',
  /** Нигер */
  Ne = 'NE',
  /** Остров Норфолк */
  Nf = 'NF',
  /** Нигерия */
  Ng = 'NG',
  /** Никарагуа */
  Ni = 'NI',
  /** Нидерланды */
  Nl = 'NL',
  /** Норвегия */
  No = 'NO',
  /** Непал */
  Np = 'NP',
  /** Науру */
  Nr = 'NR',
  /** Разделённая зона */
  Nt = 'NT',
  /** Ниуэ */
  Nu = 'NU',
  /** Новая Зеландия */
  Nz = 'NZ',
  /** Оман */
  Om = 'OM',
  /** Панама */
  Pa = 'PA',
  /** Перу */
  Pe = 'PE',
  /** Французская Полинезия */
  Pf = 'PF',
  /** Папуа — Новая Гвинея */
  Pg = 'PG',
  /** Филиппины */
  Ph = 'PH',
  /** Пакистан */
  Pk = 'PK',
  /** Польша */
  Pl = 'PL',
  /** Сен-Пьер и Микелон */
  Pm = 'PM',
  /** Питкэрн */
  Pn = 'PN',
  /** Пуэрто-Рико */
  Pr = 'PR',
  /** Португалия */
  Pt = 'PT',
  /** Палау */
  Pw = 'PW',
  /** Парагвай */
  Py = 'PY',
  /** Катар */
  Qa = 'QA',
  /** Реюньон */
  Re = 'RE',
  /** Румыния */
  Ro = 'RO',
  /** Россия */
  Ru = 'RU',
  /** Руанда */
  Rw = 'RW',
  /** Саудовская Аравия */
  Sa = 'SA',
  /** Соломоновы острова */
  Sb = 'SB',
  /** Сейшельские острова */
  Sc = 'SC',
  /** Судан */
  Sd = 'SD',
  /** Швеция */
  Se = 'SE',
  /** Сингапур */
  Sg = 'SG',
  /** Остров Святой Елены */
  Sh = 'SH',
  /** Шпицберген и Ян-Майен */
  Sj = 'SJ',
  /** Словакия */
  Sk = 'SK',
  /** Сьерра-Леоне */
  Sl = 'SL',
  /** Сан-Марино */
  Sm = 'SM',
  /** Сенегал */
  Sn = 'SN',
  /** Сомали */
  So = 'SO',
  /** Суринам */
  Sr = 'SR',
  /** Сан-Томе и Принсипи */
  St = 'ST',
  /** Сальвадор */
  Sv = 'SV',
  /** Сирия */
  Sy = 'SY',
  /** Эсватини (Свазиленд) */
  Sz = 'SZ',
  /** Теркс и Кайкос */
  Tc = 'TC',
  /** Чад */
  Td = 'TD',
  /** Французские Южные Территории */
  Tf = 'TF',
  /** Того */
  Tg = 'TG',
  /** Таиланд */
  Th = 'TH',
  /** Таджикистан */
  Tj = 'TJ',
  /** Токелау */
  Tk = 'TK',
  /** Туркменистан */
  Tm = 'TM',
  /** Тунис */
  Tn = 'TN',
  /** Тонга */
  To = 'TO',
  /** Восточный Тимор */
  Tp = 'TP',
  /** Турция */
  Tr = 'TR',
  /** Тринидад и Тобаго */
  Tt = 'TT',
  /** Тувалу */
  Tv = 'TV',
  /** Тайвань */
  Tw = 'TW',
  /** Танзания */
  Tz = 'TZ',
  /** Украина */
  Ua = 'UA',
  /** Уганда */
  Ug = 'UG',
  /** Малые Тихоокеанские острова */
  Um = 'UM',
  /** США */
  Us = 'US',
  /** Уругвай */
  Uy = 'UY',
  /** Узбекистан */
  Uz = 'UZ',
  /** Ватикан */
  Va = 'VA',
  /** Сент-Винсент и Гренадины */
  Vc = 'VC',
  /** Венесуэла */
  Ve = 'VE',
  /** Виргинские острова (Британские) */
  Vg = 'VG',
  /** Виргинские острова (США) */
  Vi = 'VI',
  /** Вьетнам */
  Vn = 'VN',
  /** Вануату */
  Vu = 'VU',
  /** Уоллис и Футуна */
  Wf = 'WF',
  /** Остров Уэйк */
  Wk = 'WK',
  /** Самоа */
  Ws = 'WS',
  /** Йемен */
  Ye = 'YE',
  /** Югославия */
  Yu = 'YU',
  /** ЮАР (Южно-Африканская Республика) */
  Za = 'ZA',
  /** Замбия */
  Zm = 'ZM',
  /** Заир */
  Zr = 'ZR',
  /** Зимбабве */
  Zw = 'ZW'
}

export type CountryEntity = {
  __typename?: 'CountryEntity';
  /** Двухбуквенный код страны */
  code: CountryCodeEnum;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Нужно ли добавить эту страну в регистрацию в Наймикс? */
  isAvailableInRegistrationNaimix: Scalars['Boolean']['output'];
  /** Название страны */
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type CreateArrestedPaymentInput = {
  /** Причина */
  cause: Scalars['String']['input'];
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Идентификатор модерации */
  moderationId: Scalars['String']['input'];
  /** Сумма */
  sum: Scalars['Float']['input'];
};

export type CreateArrestedSalaryPaymentInput = {
  /** Причина */
  cause: Scalars['String']['input'];
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Сумма */
  sum: Scalars['Float']['input'];
};

export type CreateCityInput = {
  /** Идентификатор страны к которой принадлежит город */
  countryId: Scalars['ID']['input'];
  /** Идентификатор в hrms */
  hrmsId?: InputMaybe<Scalars['Int']['input']>;
  /** Широта */
  lat: Scalars['Float']['input'];
  /** Долгота */
  lon: Scalars['Float']['input'];
  /** Название города */
  name: Scalars['String']['input'];
  /** Часовой пояс города */
  timeZone: Scalars['Float']['input'];
};

export type CreateDailyReportInput = {
  /** Дата в формате YYYY-MM-DD */
  date: Scalars['String']['input'];
};

export type CreateDraftReferralProgramInput = {
  /** Идентификатор реферальной программы */
  id: Scalars['String']['input'];
};

export type CreateDraftStoryInput = {
  referralProgramId: Scalars['String']['input'];
};

export type CreateHrmsProfessionInput = {
  /** Краткое описание профессии HRMS */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор профессии в HRMS */
  hrmsId: Scalars['Int']['input'];
  /** Название профессии HRMS */
  name: Scalars['String']['input'];
};

export type CreateManyReferralProgramsInput = {
  /** Описание реферальной программы */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время окончания реферальной программы */
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  /** Название реферальной программы */
  name: Scalars['String']['input'];
  /** Количество хороших смен */
  numberOfGoodShifts: Scalars['Int']['input'];
  /** Идентификаторы объектов, к которым будет привязана реферальная программа */
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Сумма выплаты пригласившему */
  rewardForTheReferrer: Scalars['Int']['input'];
  /** Дата и время старта реферальной программы */
  startDatetime: Scalars['String']['input'];
};

export type CreateMarkInput = {
  /** Точность координат, в метрах */
  accuracy?: InputMaybe<Scalars['Float']['input']>;
  /** Широта */
  latitude: Scalars['String']['input'];
  /** Долгота */
  longitude: Scalars['String']['input'];
  /** Id смены */
  shiftId: Scalars['String']['input'];
  /** Тип отметки: чекин или чекаут */
  type: MarkType;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateModerationInput = {
  /** Массив новых удержаний */
  arrestedPayments?: InputMaybe<Array<CreateArrestedSalaryPaymentInput>>;
  /** Причина комментария */
  cause?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий модерации */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Количество сотрудников в отчете */
  duration?: Scalars['Int']['input'];
  /** Ставка отредактированная */
  hourRate: Scalars['Float']['input'];
  /** Ставка за смену на период стажировки */
  probationRate?: InputMaybe<Scalars['Float']['input']>;
  /** Массив новых надбавок */
  salaryPayments?: InputMaybe<Array<CreateArrestedSalaryPaymentInput>>;
  /** К оплате? */
  toPayment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Учитывать смену в бонусной системе? */
  toPaymentBonus?: InputMaybe<Scalars['Boolean']['input']>;
  /** Значение выработки для сдельной формы работы */
  value: Scalars['Float']['input'];
};

export type CreateModerationReportInput = {
  /** Дата конца периода модерации */
  dateEnd: Scalars['DateTime']['input'];
  /** Дата начала периода модерации */
  dateStart: Scalars['DateTime']['input'];
  /** Id объекта на который создан период */
  facilityId: Scalars['String']['input'];
  /** Тип периода (WEEK, Неделя / TWO_WEEK, Две недели / MONTH, Месяц) */
  periodType: PeriodType;
  /** Статус модерации */
  status?: ModerationStatus;
};

export type CreateNewAddressInput = {
  /** Адрес */
  addressText: Scalars['String']['input'];
  /** Широта */
  lat: Scalars['Float']['input'];
  /** Долгота */
  lon: Scalars['Float']['input'];
};

export type CreateNewObjectInput = {
  /** Идентификатор объекта в HRMS */
  hrmsId?: InputMaybe<Scalars['Int']['input']>;
  /** Название объекта */
  name: Scalars['String']['input'];
  /** Идентификатор родительского объекта */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Настройки объекта */
  settings: CreateNewObjectSettingsInput;
};

export type CreateNewObjectPromotionInput = {
  /** Количество плохих смен для аннулирования */
  badShiftCount: Scalars['Int']['input'];
  /** Дата и время окончания бонусной программы */
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  /** Название бонусной программы */
  name: Scalars['String']['input'];
  /** Идентификатор объекта, которому принадлежит бонусная программа */
  objectId: Scalars['String']['input'];
  /** Тип повтора бонусной программы (условия запуска бонусной программы с нуля) */
  repeatCondition: ObjectPromotionRepeatConditionEnum;
  /** Количество смен для выполнения условий получения бонуса */
  requirementShiftCount: Scalars['Int']['input'];
  /** Сумма вознаграждения */
  rewardSum: Scalars['Int']['input'];
  /** Тип вознаграждения */
  rewardType: ObjectPromotionRewardTypeEnum;
  /** Дата и время начала бонусной программы */
  startDatetime: Scalars['String']['input'];
};

export type CreateNewObjectSettingsInput = {
  /** Адрес объекта */
  address?: InputMaybe<CreateNewAddressInput>;
  /** Аватар объекта */
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  /** Погрешность при чекине */
  checkInMeasurement: Scalars['Int']['input'];
  /** Погрешность при чекауте */
  checkOutMeasurement: Scalars['Int']['input'];
  /** Идентификатор города объекта */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  /** Разрешить наследоваться от этого объекта? */
  isAllowInheritanceFromThisObject: Scalars['Boolean']['input'];
  /** По умолчанию разрешать исполнителям работу без Наймикс? */
  isDefaultAllowWorkWithoutNaimix: Scalars['Boolean']['input'];
  /** Отображать исполнителям бонусы? */
  isDisplayBonusesWorkers: Scalars['Boolean']['input'];
  /** Отображать доход до модерации */
  isDisplayIncomeBeforeModeration: Scalars['Boolean']['input'];
  /** Отображать исполнителям выплаты? */
  isDisplayPaymentsWorkers: Scalars['Boolean']['input'];
  /** Отображать табель в этом объекте? */
  isShowWorkSheetInThisObject: Scalars['Boolean']['input'];
  /** Идентификаторы станций метро */
  metroStationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Идентификатор юридического лица объекта в Наймикс */
  naimixLegalEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** Погрешность при чекине/чекауте в метрах */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** Часовой пояс объекта */
  timeZone?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateNewWorkPostInput = {
  /** Зачесть пробный период, пройденный в рамках родительского объекта */
  isRecountProbation: Scalars['Boolean']['input'];
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
  /** Идентификатор пользователя */
  userId: Scalars['ID']['input'];
};

export type CreateNotificationInput = {
  /** Текст пуша */
  body: Scalars['String']['input'];
  /** Роут пуша */
  route: Scalars['String']['input'];
  /** Id роута */
  routeId: Scalars['String']['input'];
  /** Заголовок пуша */
  title: Scalars['String']['input'];
  /** Id пользователя */
  userId: Scalars['String']['input'];
};

export type CreateNotifyLetterInput = {
  referralProgramId: Scalars['String']['input'];
};

export type CreateObjectProfessionInput = {
  /** Обучение */
  hasEducation: Scalars['Boolean']['input'];
  /** Есть пробный период? */
  hasProbation: Scalars['Boolean']['input'];
  /** Идентификатор профессии HRMS */
  hrmsProfessionId: Scalars['ID']['input'];
  /** Медицинская книжка */
  isMedBookRequired: Scalars['Boolean']['input'];
  /** Это самозанятый? */
  isSelfEmployed: Scalars['Boolean']['input'];
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Тип периода */
  payoutType: PayoutTypeEnum;
  /** Единица измерения типа периода */
  payoutTypeUnit: PayoutTypeUnitEnum;
  /** Тип вознаграждения пробного периода */
  probationPayoutType?: InputMaybe<ProbationPayoutTypeEnum>;
  /** Количество типа периода пробного периода */
  probationPayoutValue?: InputMaybe<Scalars['Int']['input']>;
  /** Тип периода пробного периода */
  probationPeriodType?: InputMaybe<ProbationPeriodTypeEnum>;
  /** Ставка пробного периода */
  probationRate?: InputMaybe<Scalars['Float']['input']>;
  /** Ставка */
  rate: Scalars['Float']['input'];
};

export type CreateObjectVacancyInput = {
  /** Максимальный возраст */
  ageMax?: InputMaybe<Scalars['Int']['input']>;
  /** Минимальный возраст */
  ageMin?: InputMaybe<Scalars['Int']['input']>;
  /** Средняя стоимость смены */
  averageRate?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификаторы гражданств */
  citizenshipIds: Array<Scalars['ID']['input']>;
  /** Идентификатор фотографии обложки */
  coverId?: InputMaybe<Scalars['ID']['input']>;
  /** Отдел или секция */
  departmentOrSection?: InputMaybe<Scalars['String']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID группы в ERP */
  erpGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** ID источника в ERP */
  erpSourceId?: InputMaybe<Scalars['Int']['input']>;
  /** Пол */
  gender?: InputMaybe<GenderEnum>;
  /** Есть обучение? */
  hasEducation: Scalars['Boolean']['input'];
  /** Есть пробный период? */
  hasProbation: Scalars['Boolean']['input'];
  /** Есть спец. одежда? */
  hasWorkwear: Scalars['Boolean']['input'];
  /** Состояние активности вакансии */
  isActive: Scalars['Boolean']['input'];
  /** Публиковать стоимость смены? */
  isPublishShiftRate: Scalars['Boolean']['input'];
  /** Обед */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Название */
  name: Scalars['String']['input'];
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание к документам */
  noteToDocuments?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор объекта, на котором создаётся вакансия */
  objectId: Scalars['ID']['input'];
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
  /** Частота выплат */
  payoutFrequency: PayoutFrequencyEnum;
  /** Тип оплаты */
  payoutType: PayoutTypeEnum;
  /** Единица измерения типа оплаты */
  payoutTypeUnit: PayoutTypeUnitEnum;
  /** Продолжительность пробного периода */
  probationValue?: InputMaybe<Scalars['Int']['input']>;
  /** Стоимость смены до */
  rangeRateMax?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость смены от */
  rangeRateMin?: InputMaybe<Scalars['Float']['input']>;
  /** Ставка */
  rate: Scalars['Float']['input'];
  /** Тип отображения стоимости смены */
  rateType?: InputMaybe<RateTypeEnum>;
  /** Обязательные документы */
  requiredDocuments: Array<RequiredDocumentEnum>;
  /** Окончание смены */
  shiftEndTime: Scalars['String']['input'];
  /** Начало смены */
  shiftStartTime: Scalars['String']['input'];
  /** Транспорт */
  transport?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartInput = {
  /** Дата и время начала смены в формате ISO */
  dateFrom: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  /** id объекта, на который ставится смена */
  facilityId: Scalars['String']['input'];
  lunch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Длительность обеда в минутах */
  lunchDuration: Scalars['Int']['input'];
  /** id должности на которую ставится смена */
  positionId: Scalars['String']['input'];
  /** Дата и время окончания смены в формате ISO */
  shiftEndDate: Scalars['DateTime']['input'];
  /** id пользователя, на которого создается смена */
  userId: Scalars['String']['input'];
};

export type CreatePollsReportInput = {
  /** Id объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Месяц */
  month: Scalars['Int']['input'];
};

export type CreateSalaryPaymentInput = {
  /** Причина */
  cause: Scalars['String']['input'];
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Идентификатор модерации */
  moderationId: Scalars['String']['input'];
  /** Сумма */
  sum: Scalars['Float']['input'];
};

export type CreateShiftArrestedPaymentInput = {
  /** Причина */
  cause: Scalars['String']['input'];
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Идентификатор модерации */
  shiftId: Scalars['String']['input'];
  /** Сумма */
  sum: Scalars['Float']['input'];
};

export type CreateShiftCommentInput = {
  /** Текст сообщения к смене на модерацию */
  message: Scalars['String']['input'];
  /** Идентификатор смены */
  shiftId: Scalars['String']['input'];
};

export type CreateShiftInput = {
  /** Дата и время окончания смены */
  endDatetime: Scalars['String']['input'];
  /** Продолжительность обеда */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время начала смены */
  startDatetime: Scalars['String']['input'];
  /** Идентификатор должности пользователя на объекте */
  workPostId: Scalars['ID']['input'];
};

export type CreateShiftMarkInput = {
  /** Точность координат в метрах */
  accuracy?: InputMaybe<Scalars['Int']['input']>;
  /** Зачекаутиться на остальных сменах? */
  isCheckOutAnotherShifts: Scalars['Boolean']['input'];
  /** Широта */
  lat: Scalars['Float']['input'];
  /** Долгота */
  lon: Scalars['Float']['input'];
  /** Идентификатор смены */
  shiftId: Scalars['ID']['input'];
  /** Тип отметки */
  type: ShiftMarkTypeEnum;
};

export type CreateShiftPenaltyInput = {
  /** Причина */
  cause?: InputMaybe<Scalars['String']['input']>;
  /** Комментарий */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Стоимость */
  cost?: InputMaybe<Scalars['Int']['input']>;
  /** Id смены */
  shiftId: Scalars['String']['input'];
  /** Статус */
  shiftPenaltyStatus: ShiftPenaltyStatus;
};

export type CreateShiftSalaryPaymentInput = {
  /** Причина */
  cause: Scalars['String']['input'];
  /** Комментарий */
  comment: Scalars['String']['input'];
  /** Идентификатор модерации */
  shiftId: Scalars['String']['input'];
  /** Сумма */
  sum: Scalars['Float']['input'];
};

export type CreateTemporaryShiftInput = {
  /** Id автора смены */
  authorId?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время конца */
  dateEnd: Scalars['DateTime']['input'];
  /** Дата начала смены */
  dateFrom: Scalars['DateTime']['input'];
  /** Массив Id Объектов смены для отправки уведломления */
  facilityIds: Array<Scalars['String']['input']>;
  /** длительность обеда в минутах */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Тип выплаты за работу */
  payout?: InputMaybe<PayoutType>;
  /** Id позиции смены */
  positionId: Scalars['String']['input'];
  /** Id объекта смены */
  shiftFacilityId: Scalars['String']['input'];
  /** Единицы измерения для оплаты */
  unit?: InputMaybe<UnitType>;
};

export type CreateTimesheetByMonthAndFacilityGroupInput = {
  /** Id города */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Id группы объектов */
  facilityGroupId: Scalars['String']['input'];
  /** Начало месяца в формате YYYY-MM-DD */
  startOfMonth: Scalars['String']['input'];
};

export type CreateTimesheetByMonthAndFacilityInput = {
  /** Id объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Начало месяца в формате YYYY-MM-DD */
  startOfMonth: Scalars['String']['input'];
};

export type CreateUserByPersonalInfoMainInput = {
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix?: InputMaybe<Scalars['Boolean']['input']>;
  /** Идентификатор страны, гражданином которой является пользователь */
  citizenshipId?: InputMaybe<Scalars['String']['input']>;
  /** Имя пользователя */
  firstname: Scalars['String']['input'];
  /** Фамилия пользователя */
  lastname: Scalars['String']['input'];
  /** Отчество пользователя */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона пользователя */
  phone: Scalars['String']['input'];
};

export type CreateUserErpInput = {
  citizenshipId?: InputMaybe<Scalars['String']['input']>;
  /** id города пользователя */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Id Пользователя в ERP */
  externalId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Массив id объектов на которые должен быть назначен пользователь */
  facilityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  firstname: Scalars['String']['input'];
  lastname: Scalars['String']['input'];
  patronymic?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  /** Id основной должности пользователя */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Массив id должностей которые пользователь выбрал при регистрации */
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  role: Role;
  sendDownloadSms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateUserGradeInput = {
  character: Scalars['Int']['input'];
  facilityId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
  responsiveness: Scalars['Int']['input'];
  speed: Scalars['Int']['input'];
  userId: Scalars['String']['input'];
};

export type CreateUserReviewInput = {
  facilityId: Scalars['String']['input'];
  isGood?: InputMaybe<Scalars['Boolean']['input']>;
  positionId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CronDashboardStatisticInput = {
  /** Период сбора статистики */
  period: StatsAggregationPeriod;
};

export type CropDataInput = {
  height: Scalars['Int']['input'];
  left: Scalars['Int']['input'];
  top: Scalars['Int']['input'];
  width: Scalars['Int']['input'];
};

export type DashBoardDataModel = {
  __typename?: 'DashBoardDataModel';
  /** it is a date */
  createdAt: Scalars['Date']['output'];
  /** it is a value */
  value: Scalars['Int']['output'];
};

export type DeclineRequestShiftSuggestionsInput = {
  /** Массив идентификаторов строк откликнувшихся исполнителей в таблице request_shift_suggestions */
  declinedSuggestionIds: Array<Scalars['String']['input']>;
  /** Идентификатор графика заявки */
  requestScheduleId: Scalars['String']['input'];
};

export type DeleteArrestedPaymentInput = {
  id: Scalars['String']['input'];
};

export type DeleteMeInput = {
  phone: Scalars['String']['input'];
};

export type DeleteObjectProfessionInput = {
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
};

export type DeleteObjectPromotionInput = {
  /** Идентификатор бонусной программы */
  objectPromotionId: Scalars['ID']['input'];
};

export type DeleteReferralProgramInput = {
  /** Идентификатор реферальной программы */
  id: Scalars['String']['input'];
};

export type DeleteSalaryPaymentInput = {
  id: Scalars['String']['input'];
};

export type DeleteShiftArrestedPaymentInput = {
  id: Scalars['String']['input'];
};

export type DeleteShiftSalaryPaymentInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserInput = {
  userId: Scalars['ID']['input'];
};

/** Варианты фильтрации смен, которые не нужно отображать в табеле супервайзера */
export enum DoNotShowShiftEnum {
  InFuture = 'IN_FUTURE',
  Refused = 'REFUSED',
  ToPayment = 'TO_PAYMENT',
  UserWithoutShifts = 'USER_WITHOUT_SHIFTS',
  Wasted = 'WASTED',
  WithoutPayment = 'WITHOUT_PAYMENT'
}

export type DocumentReview = {
  __typename?: 'DocumentReview';
  /** Комментарий при отклонение документов */
  comment?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  rejectReason: RejectReason;
  reviewer: User;
  /** ID владельца документов */
  reviewerId: Scalars['String']['output'];
  /** Статус проверки документа */
  status: DocumentStatus;
  /** Тип документа на проверку */
  type: ReviewType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  /** ID владельца документов */
  userId: Scalars['String']['output'];
};

export type DocumentReviewInput = {
  /** Комментарий при отклонение документов */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Причина отклонения документов */
  rejectReason?: InputMaybe<RejectReason>;
  /** Статус проверки документа */
  status: DocumentStatus;
  /** Тип документа на проверку */
  type: ReviewType;
  /** ID владельца документов */
  userId: Scalars['String']['input'];
};

/** Статус проверки документа */
export enum DocumentStatus {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

/** Статус проверки документов */
export enum DocumentsStatus {
  Accepted = 'ACCEPTED',
  InProgress = 'IN_PROGRESS',
  NoDocuments = 'NO_DOCUMENTS',
  PartlyAccepted = 'PARTLY_ACCEPTED',
  Rejected = 'REJECTED'
}

export type EditCityInput = {
  /** Идентификатор города */
  cityId: Scalars['ID']['input'];
  /** Идентификатор страны к которой принадлежит город */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  /** Идентификатор в hrms */
  hrmsId?: InputMaybe<Scalars['Int']['input']>;
  /** Широта */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** Долгота */
  lon?: InputMaybe<Scalars['Float']['input']>;
  /** Название города */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Часовой пояс города */
  timeZone?: InputMaybe<Scalars['Float']['input']>;
};

export type EditHrmsProfessionInput = {
  /** Краткое описание профессии HRMS */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор профессии в HRMS */
  hrmsId?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор профессии HRMS */
  id: Scalars['ID']['input'];
  /** Название профессии из HRMS */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EditObjectAddressInput = {
  /** Адрес */
  addressText?: InputMaybe<Scalars['String']['input']>;
  /** Широта */
  lat?: InputMaybe<Scalars['Float']['input']>;
  /** Долгота */
  lon?: InputMaybe<Scalars['Float']['input']>;
};

export type EditObjectInput = {
  /** Название объекта */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Настройки объекта */
  settings?: InputMaybe<EditObjectSettingsInput>;
};

export type EditObjectProfessionInput = {
  /** Обучение */
  hasEducation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Есть пробный период? */
  hasProbation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Идентификатор профессии HRMS */
  hrmsProfessionId?: InputMaybe<Scalars['ID']['input']>;
  /** Медицинская книжка */
  isMedBookRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
  /** Тип периода */
  payoutType?: InputMaybe<PayoutTypeEnum>;
  /** Единица измерения типа периода */
  payoutTypeUnit?: InputMaybe<PayoutTypeUnitEnum>;
  /** Тип вознаграждения пробного периода */
  probationPayoutType?: InputMaybe<ProbationPayoutTypeEnum>;
  /** Количество типа периода пробного периода */
  probationPayoutValue?: InputMaybe<Scalars['Int']['input']>;
  /** Тип периода пробного периода */
  probationPeriodType?: InputMaybe<ProbationPeriodTypeEnum>;
  /** Ставка пробного периода */
  probationRate?: InputMaybe<Scalars['Float']['input']>;
  /** Ставка */
  rate?: InputMaybe<Scalars['Float']['input']>;
};

export type EditObjectPromotionInput = {
  /** Количество плохих смен для аннулирования */
  badShiftCount?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время окончания бонусной программы */
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  /** Название бонусной программы */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор дочернего объекта, в котором хотим отредактировать бонусную программу */
  objectId?: InputMaybe<Scalars['ID']['input']>;
  /** Идентификатор бонусной программы */
  objectPromotionId: Scalars['ID']['input'];
  /** Тип повтора бонусной программы (условия запуска бонусной программы с нуля) */
  repeatCondition?: InputMaybe<ObjectPromotionRepeatConditionEnum>;
  /** Количество смен для выполнения условий получения бонуса */
  requirementShiftCount?: InputMaybe<Scalars['Int']['input']>;
  /** Сумма вознаграждения */
  rewardSum?: InputMaybe<Scalars['Int']['input']>;
  /** Тип вознаграждения */
  rewardType?: InputMaybe<ObjectPromotionRewardTypeEnum>;
  /** Дата и время начала бонусной программы */
  startDatetime?: InputMaybe<Scalars['String']['input']>;
};

export type EditObjectSettingsInput = {
  /** Адрес объекта */
  address?: InputMaybe<EditObjectAddressInput>;
  /** Аватар объекта */
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  /** Сумма удержания при отмене смены, в рублях */
  cancelShiftHoldAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Порог срабатывания при отмене смены, в часах */
  cancelShiftHoldThresholdHours?: InputMaybe<Scalars['Int']['input']>;
  /** Погрешность при чекине */
  checkInMeasurement?: InputMaybe<Scalars['Int']['input']>;
  /** Погрешность при чекауте */
  checkOutMeasurement?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор города объекта */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  /** Удержание при отмене смены включено? */
  isCancelShiftHoldEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** По умолчанию разрешать исполнителям работу без Наймикс? */
  isDefaultAllowWorkWithoutNaimix?: InputMaybe<Scalars['Boolean']['input']>;
  /** Отображать исполнителям бонусы? */
  isDisplayBonusesWorkers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Отображать доход до модерации */
  isDisplayIncomeBeforeModeration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Отображать исполнителям выплаты? */
  isDisplayPaymentsWorkers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ожидание мед. книжки включено? */
  isMedicalBookWaitingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Количество дней ожидания */
  medicalCertificateAllowedDays?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификаторы станций метро */
  metroStationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Идентификатор юридического лица объекта в Наймикс */
  naimixLegalEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** Погрешность при чекине/чекаута в метрах */
  radius?: InputMaybe<Scalars['Int']['input']>;
};

export type EditObjectVacancyInput = {
  /** Максимальный возраст */
  ageMax?: InputMaybe<Scalars['Int']['input']>;
  /** Минимальный возраст */
  ageMin?: InputMaybe<Scalars['Int']['input']>;
  /** Средняя стоимость смены */
  averageRate?: InputMaybe<Scalars['Float']['input']>;
  /** Идентификаторы гражданств */
  citizenshipIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Идентификатор фотографии обложки */
  coverId?: InputMaybe<Scalars['ID']['input']>;
  /** Отдел или секция */
  departmentOrSection?: InputMaybe<Scalars['String']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** ID группы в ERP */
  erpGroupId?: InputMaybe<Scalars['Int']['input']>;
  /** ID источника в ERP */
  erpSourceId?: InputMaybe<Scalars['Int']['input']>;
  /** Пол */
  gender?: InputMaybe<GenderEnum>;
  /** Есть обучение? */
  hasEducation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Есть пробный период? */
  hasProbation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Есть спец. одежда? */
  hasWorkwear?: InputMaybe<Scalars['Boolean']['input']>;
  /** Состояние активности вакансии */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Публиковать стоимость смены? */
  isPublishShiftRate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Обед */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Название */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Примечание */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Примечание к документам */
  noteToDocuments?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор профессии объекта */
  objectProfessionId?: InputMaybe<Scalars['ID']['input']>;
  /** Идентификатор вакансии объекта */
  objectVacancyId: Scalars['ID']['input'];
  /** Частота выплат */
  payoutFrequency?: InputMaybe<PayoutFrequencyEnum>;
  /** Тип оплаты */
  payoutType?: InputMaybe<PayoutTypeEnum>;
  /** Единица измерения типа оплаты */
  payoutTypeUnit?: InputMaybe<PayoutTypeUnitEnum>;
  /** Продолжительность пробного периода */
  probationValue?: InputMaybe<Scalars['Int']['input']>;
  /** Стоимость смены до */
  rangeRateMax?: InputMaybe<Scalars['Float']['input']>;
  /** Стоимость смены от */
  rangeRateMin?: InputMaybe<Scalars['Float']['input']>;
  /** Ставка */
  rate?: InputMaybe<Scalars['Float']['input']>;
  /** Тип отображения стоимости смены */
  rateType?: InputMaybe<RateTypeEnum>;
  /** Обязательные документы */
  requiredDocuments?: InputMaybe<Array<RequiredDocumentEnum>>;
  /** Окончание смены */
  shiftEndTime?: InputMaybe<Scalars['String']['input']>;
  /** Начало смены */
  shiftStartTime?: InputMaybe<Scalars['String']['input']>;
  /** Транспорт */
  transport?: InputMaybe<Scalars['String']['input']>;
};

export type EditReferralProgramInput = {
  /** Описание реферальной программы */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Дата и время окончания реферальной программы */
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор реферальной программы */
  id: Scalars['ID']['input'];
  /** Подтверждение изменения в случае пересечения дат с другими реферальными программами */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Подтверждение публикации реферальной программы */
  isPublication?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название реферальной программы */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Количество хороших смен */
  numberOfGoodShifts?: InputMaybe<Scalars['Int']['input']>;
  /** Сумма выплаты пригласившему */
  rewardForTheReferrer?: InputMaybe<Scalars['Int']['input']>;
  /** Дата и время старта реферальной программы */
  startDatetime?: InputMaybe<Scalars['String']['input']>;
};

/** DTO для редактирования смены */
export type EditShiftInput = {
  /** Дата и время начала смены в формате timestamp */
  dateFrom: Scalars['String']['input'];
  /** ID смены */
  id: Scalars['ID']['input'];
  /** Длительность обеда в минутах */
  lunchDuration: Scalars['Int']['input'];
  /** Дата и время окончания смены в формате timestamp */
  shiftEndDate: Scalars['String']['input'];
};

export type EmptyQueueInput = {
  /** Repeat interval */
  interval?: InputMaybe<Scalars['Int']['input']>;
  type: JobName;
};

/** По какой сущности отображать доступные города? */
export enum EntityFilterEnum {
  /** По метро */
  Metro = 'METRO',
  /** По объектам */
  Object = 'OBJECT',
  /** По пользователям */
  User = 'USER'
}

export type ErpInstanceEntity = {
  __typename?: 'ErpInstanceEntity';
  /** Ссылка на api */
  apiUrl: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Название */
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** DTO с набором данных необходимых при создании/редактировании группы */
export type EverythingIsPossibleBonusInput = {
  /** Включен или выключен "Всё Возможно Бонус" на объекте */
  everythingIsPossibleBonus?: Scalars['Boolean']['input'];
  /** ID группы */
  facilityId: Scalars['String']['input'];
  /** Сумма для выплат с учетом % налога "Всё Возможно Бонус" на объекте */
  possibleBonusPaymentSum?: Scalars['Int']['input'];
  /** Количество смен для достижения бонуса "Всё Возможно Бонус" на объекте */
  possibleBonusShiftCount?: Scalars['Int']['input'];
  /** Сумма которая отображается на баннере "Всё Возможно Бонус" на объекте */
  possibleBonusViewSum?: Scalars['Int']['input'];
};

/** Тип Файла который загружаем для импорта данных в модерацию */
export enum ExcelVariant {
  CourierOzon = 'COURIER_OZON',
  OzonPickerNative = 'OZON_PICKER_NATIVE',
  PickerOzon = 'PICKER_OZON'
}

export type Facility = {
  __typename?: 'Facility';
  /** Адрес объекта */
  address?: Maybe<Address>;
  /** @deprecated Адрес храним в поле addressString */
  addressId?: Maybe<Scalars['String']['output']>;
  /** Адрес объекта */
  addressString?: Maybe<Scalars['String']['output']>;
  /** Массив содержащий список профессий на объекте со ставками по ним */
  casings?: Maybe<Array<Casing>>;
  checkInMeasurement: Scalars['Int']['output'];
  checkOutMeasurement: Scalars['Int']['output'];
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  /** Менеджеры объекта */
  clientManagers?: Maybe<Array<User>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Расчетное поле для расстояния от гео точки в километрах */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Включен или выключен "Всё Возможно Бонус" на объекте */
  everythingIsPossibleBonus: Scalars['Boolean']['output'];
  /** Id объекта в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Галерея фотографий профессии объекта */
  facilityGallery?: Maybe<Array<FacilityGalleryEntity>>;
  facilityGroup?: Maybe<FacilityGroup>;
  facilityGroupId?: Maybe<Scalars['String']['output']>;
  facilitySupervisors: Array<Supervisors>;
  foremen?: Maybe<Array<User>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Есть ли на объекте возможность работать по справке без мед.книжки n-дней */
  isMedInvoiceAllowed: Scalars['Boolean']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** Показывать ли пользователям на объекте бонусы */
  is_bonus_active: Scalars['Boolean']['output'];
  /** Показывать ли пользователям на объекте начисления */
  is_finance_active: Scalars['Boolean']['output'];
  latitude: Scalars['String']['output'];
  legalEntity?: Maybe<LegalEntity>;
  /** Идетнтификатор юр. лица */
  legalEntityId?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['String']['output'];
  manualAccruals: Array<ManualAccrual>;
  metro?: Maybe<Scalars['String']['output']>;
  /** Станции метро */
  metroStations?: Maybe<Array<MetroStation>>;
  /** IDs станций метро */
  metroStationsIds?: Maybe<Array<Scalars['String']['output']>>;
  moderationReports: Array<ModerationReport>;
  /** Идентификатор объекта в Наймикс */
  naimixObjectId?: Maybe<Scalars['String']['output']>;
  /** Название объекта в Наймикс */
  naimixObjectName?: Maybe<Scalars['String']['output']>;
  /** Номер сценария Наймикс */
  naimixScenarioNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** количество дней ожидания медицинской книжки (количество дней действия справки о прохождении осмотра перед получением медицинской книжки) */
  numberDaysWaitMedical: Scalars['Int']['output'];
  /** Массив содержащий список штрафов на объекте */
  penalty?: Maybe<Array<Penalty>>;
  /** Сумма для выплат с учетом % налога 'Всё Возможно Бонус' на объекте */
  possibleBonusPaymentSum: Scalars['Float']['output'];
  /** Количество смен для достижения бонуса "Всё Возможно Бонус" на объекте */
  possibleBonusShiftCount: Scalars['Float']['output'];
  /** Сумма для выплат с учетом % налога "Всё Возможно Бонус" на объекте */
  possibleBonusViewSum: Scalars['Float']['output'];
  publicConditions?: Maybe<Array<PublicCondition>>;
  radius: Scalars['Int']['output'];
  /** Реферальные программы привязанные к объекту */
  referralPrograms?: Maybe<Array<ReferralProgramEntity>>;
  schedules: Array<Schedule>;
  shifts: Array<Shift>;
  /** Показывать ли пользователям заработок до модерации */
  showSalaryBeforeModeration: Scalars['Boolean']['output'];
  subscribers?: Maybe<Array<User>>;
  supervisors?: Maybe<Array<User>>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userExperiences: Array<UserExperience>;
  userGrades: Array<UserGrade>;
  userReviews: Array<UserReview>;
  vacancies?: Maybe<Array<Vacancy>>;
  workPosts?: Maybe<Array<WorkPost>>;
  /** Список заблокированных периодов на объекте */
  workSheetLockedPeriods?: Maybe<Array<WorkSheetLockedPeriodEntity>>;
  zayavkaSchedules: Array<ZayavkaSchedule>;
  zayavkaShifts: Array<ZayavkaShift>;
  zayavkas: Array<Zayavka>;
};

/** Dto с набором данных необходимых при создании/редактировании объекта */
export type FacilityCardInput = {
  /** Адрес объекта */
  addressString?: InputMaybe<Scalars['String']['input']>;
  /** Разрешённая погрешность при чекине */
  checkInMeasurement?: InputMaybe<Scalars['Int']['input']>;
  /** Разрешённая погрешность при чекауте */
  checkOutMeasurement?: InputMaybe<Scalars['Int']['input']>;
  /** Fias ID города объекта */
  cityFiasId?: InputMaybe<Scalars['String']['input']>;
  /** ID города объекта */
  cityId: Scalars['String']['input'];
  /** Id объекта в ERP */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** id группы объекта */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Название объекта */
  id?: InputMaybe<Scalars['String']['input']>;
  is_active?: Scalars['Boolean']['input'];
  is_bonus_active?: Scalars['Boolean']['input'];
  is_finance_active?: Scalars['Boolean']['input'];
  /** Широта */
  latitude: Scalars['String']['input'];
  /** ID юр. лица */
  legalEntityId?: InputMaybe<Scalars['String']['input']>;
  /** Долгота */
  longitude: Scalars['String']['input'];
  metro?: InputMaybe<Scalars['String']['input']>;
  /** IDs станций метро */
  metroStationsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID объекта в Наймикс */
  naimixObjectId?: InputMaybe<Scalars['String']['input']>;
  /** Название объекта в Наймикс */
  naimixObjectName?: InputMaybe<Scalars['String']['input']>;
  /** Номер сценария Наймикс */
  naimixScenarioNumber?: InputMaybe<Scalars['String']['input']>;
  /** Название объекта */
  name: Scalars['String']['input'];
  /** Радиус объекта для проверки CheckIn / CheckOut в метрах */
  radius: Scalars['Int']['input'];
  /** Показывать ли пользователям заработок до модерации */
  showSalaryBeforeModeration?: Scalars['Boolean']['input'];
};

/** поле по которому будет работать сортировка */
export enum FacilityFieldsSorting {
  Metro = 'metro',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type FacilityGalleryEntity = {
  __typename?: 'FacilityGalleryEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facility: Facility;
  /** Идентификатор объекта */
  facilityId: Scalars['String']['output'];
  file?: Maybe<File>;
  /** Идентификатор файла с фотографией */
  fileId?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FacilityGroup = {
  __typename?: 'FacilityGroup';
  /** Баланс клиента по группе объектов */
  balance: Scalars['Float']['output'];
  /** Директора группы объектов */
  clientDirectors?: Maybe<Array<User>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facilities: Array<Facility>;
  /** Менеджеры группы объектов */
  groupManagers?: Maybe<Array<User>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** информация о файле с изображением группы */
  logo?: Maybe<File>;
  /** id файла который указан как логотип */
  logoId?: Maybe<Scalars['String']['output']>;
  /** Наименование группы объектов */
  name: Scalars['String']['output'];
  publicConditions?: Maybe<Array<PublicCondition>>;
  /** Реферальные программы привязанные к группе объектов */
  referralPrograms?: Maybe<Array<ReferralProgramEntity>>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** DTO с набором данных необходимых при создании/редактировании группы */
export type FacilityGroupCardInput = {
  /** ID группы */
  id?: InputMaybe<Scalars['String']['input']>;
  /** ID лого группы */
  logoId?: InputMaybe<Scalars['String']['input']>;
  /** Название группы */
  name: Scalars['String']['input'];
};

/** Параметры поиска профессий группы объектов */
export type FacilityGroupCasingsInput = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** id группы объектов */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** id объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** id профессии */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<FacilityGroupCasingsSorting>;
  sortWay?: InputMaybe<SortingWay>;
};

/** Поля сортировки списка профессий группы объектов */
export enum FacilityGroupCasingsSorting {
  City = 'city',
  Facility = 'facility',
  Position = 'position'
}

export type FacilityListInput = {
  cityId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID объекта в Наймикс */
  naimixObjectId?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<FacilityFieldsSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
};

export type File = {
  __typename?: 'File';
  casingGallery: CasingGalleryEntity;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  document: UserDocumentEntity;
  facilityGroups: Array<FacilityGroup>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  mimetype: Scalars['String']['output'];
  originalName?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  story: Story;
  storySlide: StorySlide;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type FindUserShiftsInput = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Скрывать отмененные смены */
  hideRefused?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ForemanShift = {
  __typename?: 'ForemanShift';
  /** Id автора */
  authorId: Scalars['String']['output'];
  /** комментарий к смене */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарии бригадиров к смене */
  comments: Array<CommentEntity>;
  /** Размер оплаты по смене */
  cost: Scalars['Float']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время конца */
  dateEnd: Scalars['Date']['output'];
  /** Дата и время начала */
  dateFrom: Scalars['Date']['output'];
  deletedDate: Scalars['Date']['output'];
  /** Длительность смены в минутах */
  duration: Scalars['String']['output'];
  empty: Scalars['Boolean']['output'];
  /** Объект */
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** Id Бригадира, которому по подписке должна придти информация */
  foremanId?: Maybe<Scalars['String']['output']>;
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Является ли смена стажировочной */
  isProbation: Scalars['Boolean']['output'];
  /** длительность обеда в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Чекины/Чекауты */
  marks: Array<Mark>;
  /** Объект модерации */
  moderation?: Maybe<Moderation>;
  /** Тип выплаты за работу */
  payout: PayoutType;
  /** Штраф на смене */
  penalties?: Maybe<Array<ShiftPenaltyEntity>>;
  /** Объект должности */
  position?: Maybe<Position>;
  /** Id должности на смене */
  positionId: Scalars['String']['output'];
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  rejectedById?: Maybe<Scalars['String']['output']>;
  /** График */
  schedule?: Maybe<Schedule>;
  /** Id графика */
  scheduleId?: Maybe<Scalars['String']['output']>;
  selfEmployedRate?: Maybe<Scalars['Int']['output']>;
  stage: ShiftStage;
  status: ShiftStatus;
  /** Единицы измерения для оплаты */
  unit: UnitType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  /** Значение для смен по сдельной оплате */
  value?: Maybe<Scalars['Float']['output']>;
  /** Заявка, если смена относится к Заявке */
  zayavka?: Maybe<Zayavka>;
  /** Id заявки если смена привязана к заявке */
  zayavkaId?: Maybe<Scalars['String']['output']>;
  zayavkaShifts: Array<ZayavkaShift>;
};

/** Пол */
export enum GenderEnum {
  /** Женский */
  Female = 'FEMALE',
  /** Мужской */
  Male = 'MALE'
}

export type GetCitiesInput = {
  /** Поиск по названию города */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
};

export type GetCitiesModel = {
  __typename?: 'GetCitiesModel';
  /** Города */
  cities: Array<CityEntity>;
  /** Количество записей городов */
  count: Scalars['Int']['output'];
};

export type GetCitiesV2Input = {
  /** Отображать только доступные */
  entityFilter?: InputMaybe<EntityFilterEnum>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Город, который был выбран в инпуте */
  selectedCityId?: InputMaybe<Scalars['ID']['input']>;
  /** Часовой пояс города */
  timeZone?: InputMaybe<Scalars['Float']['input']>;
};

export type GetCityInput = {
  /** Идентификатор города */
  cityId: Scalars['ID']['input'];
};

export type GetCountriesInput = {
  /** Отображать только доступные */
  entityFilter?: InputMaybe<EntityFilterEnum>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Страна, которая была выбран в инпуте */
  selectedCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetCountriesModel = {
  __typename?: 'GetCountriesModel';
  /** Количество записей стран */
  count: Scalars['Int']['output'];
  /** Страны */
  countries: Array<CountryEntity>;
};

export type GetDemoAgencyContractNaimixModel = {
  __typename?: 'GetDemoAgencyContractNaimixModel';
  /** Файл в base64 */
  fileContent: Scalars['String']['output'];
};

export type GetDemoFrameContractNaimixModel = {
  __typename?: 'GetDemoFrameContractNaimixModel';
  /** Файл в base64 */
  fileContent: Scalars['String']['output'];
};

export type GetDemoPdContractNaimixModel = {
  __typename?: 'GetDemoPdContractNaimixModel';
  /** Файл в base64 */
  fileContent: Scalars['String']['output'];
};

export type GetErpInstanceInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Выбранный инстанс ERP */
  selectedErpInstanceId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetErpInstancesModel = {
  __typename?: 'GetErpInstancesModel';
  /** Общее количество записей */
  count: Scalars['Int']['output'];
  /** Инстансы ERP */
  erpInstances: Array<ErpInstanceEntity>;
};

export type GetFacilitiesByFacilityGroupOfFacilityIdInput = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GetFreeRequestShiftsForCalendarInput = {
  requestScheduleId: Scalars['ID']['input'];
};

export type GetHrmsProfessionInput = {
  /** Идентификатор профессии HRMS */
  id: Scalars['ID']['input'];
};

export type GetHrmsProfessionsInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetHrmsProfessionsModel = {
  __typename?: 'GetHrmsProfessionsModel';
  /** Количество записей всего */
  count: Scalars['Int']['output'];
  /** Массив профессий HRMS */
  hrmsProfessions: Array<HrmsProfessionEntity>;
};

export type GetLeadsV2Model = {
  __typename?: 'GetLeadsV2Model';
  /** Всего элементов' */
  count: Scalars['Int']['output'];
  /** Лиды */
  leads: Array<Lead>;
  /** Количество страниц */
  pages: Scalars['Int']['output'];
};

export type GetListVacanciesInput = {
  /** Фильтрация по группе объектов */
  facilityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Нижняя граница широты */
  latBottom: Scalars['Float']['input'];
  /** Верхняя граница широты */
  latTop: Scalars['Float']['input'];
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Левая граница долготы */
  lonLeft: Scalars['Float']['input'];
  /** Правая граница долготы */
  lonRight: Scalars['Float']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Список идентификаторов профессий */
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetLockedPeriodInput = {
  /** Идентификатор периода */
  id: Scalars['String']['input'];
  order?: InputMaybe<OrderDirection>;
  orderBy?: InputMaybe<GetSupervisorWorkSheetOrderByEnum>;
  /** Фильтрация по профессии */
  positionId?: InputMaybe<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetLockedPeriodModel = {
  __typename?: 'GetLockedPeriodModel';
  /** Заблокированный период */
  lockedPeriod: WorkSheetLockedPeriodEntity;
  positions: Array<Position>;
};

export type GetLockedPeriodsInput = {
  /** Дата создания */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Дата исполнения */
  dateOfExecution?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор группы объектов */
  facilityGroupId: Scalars['String']['input'];
  /** Идентификатор объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Возможные сортировки */
  orderBy?: InputMaybe<Array<GetLockedPeriodsOrderByInput>>;
  /** Поиск по номеру периода и автору */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Статус заблокированного периода */
  status?: InputMaybe<WorkSheetLockedPeriodStatusEnum>;
};

export type GetLockedPeriodsModel = {
  __typename?: 'GetLockedPeriodsModel';
  count: Scalars['Int']['output'];
  data: Array<WorkSheetLockedPeriodEntity>;
};

/** Название полей для сортировки */
export enum GetLockedPeriodsOrderByField {
  /** Дата создания */
  CreatedAt = 'createdAt',
  /** Дата исполнения */
  DateOfExecution = 'dateOfExecution',
  /** Номер из ERP */
  ErpId = 'erpId',
  /** Статус */
  Status = 'status'
}

export type GetLockedPeriodsOrderByInput = {
  /** Название поля по которому будет идти сортировка */
  fieldName: GetLockedPeriodsOrderByField;
  /** Тип сортировки */
  orderDirection: OrderDirection;
};

export type GetMetroLinesWithStationsInput = {
  /** Идентификатор города */
  cityId: Scalars['ID']['input'];
};

export type GetNaimixContractNaimixModel = {
  __typename?: 'GetNaimixContractNaimixModel';
  /** Файл в base64 */
  fileContent: Scalars['String']['output'];
};

export type GetNaimixLegalEntitiesInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetNaimixLegalEntitiesModel = {
  __typename?: 'GetNaimixLegalEntitiesModel';
  /** Количество записей юридических лиц в Наймикс */
  count: Scalars['Int']['output'];
  /** Юридические лица в Наймикс */
  naimixLegalEntities: Array<NaimixLegalEntityEntity>;
};

export type GetObjectInput = {
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
};

export type GetObjectPhotoGalleryWithParentInput = {
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
};

export type GetObjectProfessionInput = {
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
};

export type GetObjectProfessionPhotoGalleryInput = {
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
};

export type GetObjectProfessionsInput = {
  /** Идентификатор профессии HRMS */
  hrmsProfessionId?: InputMaybe<Scalars['ID']['input']>;
  /** Фильтрация по активности профессии объекта */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Сортировка по названию */
  orderByName?: InputMaybe<OrderDirection>;
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор профессии объекта */
  selectedObjectProfessionId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetObjectProfessionsModel = {
  __typename?: 'GetObjectProfessionsModel';
  /** Общее количество профессий объекта */
  count: Scalars['Int']['output'];
  /** Профессии объекта */
  objectProfessions: Array<ObjectProfessionEntity>;
};

export type GetObjectVacanciesInput = {
  /** Идентификатор профессии */
  hrmsProfessionId?: InputMaybe<Scalars['ID']['input']>;
  /** Статус активности */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Сортировка по названию профессии HRMS */
  orderByHrmsProfessionName?: InputMaybe<OrderDirection>;
  /** Период вакансии (день/ночь) */
  period?: InputMaybe<PeriodEnum>;
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetObjectVacanciesModel = {
  __typename?: 'GetObjectVacanciesModel';
  /** Общее количество вакансий объекта */
  count: Scalars['Int']['output'];
  /** Вакансии объекта */
  objectVacancies: Array<ObjectVacancyEntity>;
};

export type GetObjectVacanciesOnMapInput = {
  /** Список идентификаторов профессий */
  hrmsProfessionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Нижняя граница широты */
  latBottom: Scalars['Float']['input'];
  /** Верхняя граница широты */
  latTop: Scalars['Float']['input'];
  /** Левая граница долготы */
  lonLeft: Scalars['Float']['input'];
  /** Правая граница долготы */
  lonRight: Scalars['Float']['input'];
};

export type GetObjectVacancyInput = {
  /** Идентификатор вакансии */
  objectVacancyId: Scalars['ID']['input'];
};

export type GetObjectsForCreateWorkpostInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetObjectsInput = {
  /** Идентификатор города */
  cityId?: InputMaybe<Scalars['ID']['input']>;
  /** Идентификатор бригадира */
  foremanId?: InputMaybe<Scalars['ID']['input']>;
  /** Фильтрация по активности объекта */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Идентификатор юридического лица в Наймикс */
  naimixLegalEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Идентификатор родительского объекта */
  parentId?: InputMaybe<Scalars['ID']['input']>;
  /** Поиск по названию */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор супервайзера */
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetObjectsModel = {
  __typename?: 'GetObjectsModel';
  /** Общее количество объектов */
  count: Scalars['Int']['output'];
  /** Объекты */
  objects: Array<ObjectEntity>;
};

export type GetParentObjectsForCreateNewObjectInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по объектам */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetParentObjectsForCreateNewObjectModel = {
  __typename?: 'GetParentObjectsForCreateNewObjectModel';
  /** Количество найденных объектов */
  count: Scalars['Int']['output'];
  /** Объекты */
  objects: Array<ObjectEntity>;
};

export type GetReferralProgramInput = {
  /** Идентификатор реферальной программы */
  id: Scalars['String']['input'];
};

export type GetReferralProgramsPaginatedInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Идентификатор объекта */
  objectId?: InputMaybe<Scalars['String']['input']>;
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Поиск по тексту */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор объекта */
  status?: InputMaybe<ReferralProgramStatusEnum>;
};

export type GetReferralProgramsPaginatedModel = {
  __typename?: 'GetReferralProgramsPaginatedModel';
  /** Общее количество */
  count: Scalars['Int']['output'];
  /** Реферальные программы */
  referralPrograms: Array<NewReferralProgramEntity>;
};

export type GetSchedulerReferralProgramsInput = {
  /** Идентификатор реферальной программы */
  referralProgramId?: InputMaybe<Scalars['String']['input']>;
};

export type GetStatisticInput = {
  /** группа объектов */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** объект */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Период фильтрации статистики */
  period: StatisticPeriod;
  /** Тип графика */
  types: Array<ChartType>;
};

export type GetSupervisorWorkSheetDataAnalyticsModel = {
  __typename?: 'GetSupervisorWorkSheetDataAnalyticsModel';
  arrestedPayment: Scalars['Float']['output'];
  bonusPayment: Scalars['Float']['output'];
  pieceFact: Scalars['Float']['output'];
  piecePlan: Scalars['Float']['output'];
  pointFact: Scalars['Float']['output'];
  pointPlan: Scalars['Float']['output'];
  salaryPayment: Scalars['Float']['output'];
  shiftsPayment: Scalars['Float']['output'];
  toPaymentCount: Scalars['Int']['output'];
  unit: UnitType;
  workTimeFact: Scalars['Float']['output'];
  workTimePlan: Scalars['Float']['output'];
};

export type GetSupervisorWorkSheetDataModel = {
  __typename?: 'GetSupervisorWorkSheetDataModel';
  analytics: GetSupervisorWorkSheetDataAnalyticsModel;
  shifts?: Maybe<Array<GetSupervisorWorkSheetShiftModel>>;
  user: User;
  workPost: WorkPost;
};

export type GetSupervisorWorkSheetFilterDataModel = {
  __typename?: 'GetSupervisorWorkSheetFilterDataModel';
  users: Array<User>;
  workPosts: Array<WorkPost>;
};

export type GetSupervisorWorkSheetInput = {
  doNotShowShifts?: InputMaybe<Array<DoNotShowShiftEnum>>;
  facilityId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  order?: InputMaybe<OrderDirection>;
  orderBy?: InputMaybe<GetSupervisorWorkSheetOrderByEnum>;
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  year: Scalars['Int']['input'];
};

export type GetSupervisorWorkSheetModel = {
  __typename?: 'GetSupervisorWorkSheetModel';
  count: Scalars['Int']['output'];
  data: Array<GetSupervisorWorkSheetDataModel>;
  filterData: GetSupervisorWorkSheetFilterDataModel;
  lockedPeriods: Array<WorkSheetLockedPeriodEntity>;
};

export enum GetSupervisorWorkSheetOrderByEnum {
  Lastname = 'LASTNAME',
  Position = 'POSITION'
}

export type GetSupervisorWorkSheetShiftModel = {
  __typename?: 'GetSupervisorWorkSheetShiftModel';
  /** Id автора */
  authorId: Scalars['String']['output'];
  bonusForThisShift: Scalars['Float']['output'];
  /** комментарий к смене */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарии бригадиров к смене */
  comments: Array<CommentEntity>;
  /** Размер оплаты по смене */
  cost: Scalars['Float']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время конца */
  dateEnd: Scalars['Date']['output'];
  /** Дата и время начала */
  dateFrom: Scalars['Date']['output'];
  deletedDate: Scalars['Date']['output'];
  /** Длительность смены в минутах */
  duration: Scalars['String']['output'];
  durationFact: Scalars['Int']['output'];
  durationPlan: Scalars['Int']['output'];
  empty: Scalars['Boolean']['output'];
  /** Объект */
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Является ли смена стажировочной */
  isProbation: Scalars['Boolean']['output'];
  /** длительность обеда в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Чекины/Чекауты */
  marks: Array<Mark>;
  /** Объект модерации */
  moderation?: Maybe<Moderation>;
  newCommentsNum: Scalars['Int']['output'];
  payment: Scalars['Int']['output'];
  /** Тип выплаты за работу */
  payout: PayoutType;
  /** Штраф на смене */
  penalties?: Maybe<Array<ShiftPenaltyEntity>>;
  pieceFact: Scalars['Int']['output'];
  piecePlan: Scalars['Int']['output'];
  pointFact: Scalars['Int']['output'];
  pointPlan: Scalars['Int']['output'];
  /** Объект должности */
  position?: Maybe<Position>;
  /** Id должности на смене */
  positionId: Scalars['String']['output'];
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  promotionResults?: Maybe<Array<PromotionResult>>;
  rejectedById?: Maybe<Scalars['String']['output']>;
  /** График */
  schedule?: Maybe<Schedule>;
  /** Id графика */
  scheduleId?: Maybe<Scalars['String']['output']>;
  selfEmployedRate?: Maybe<Scalars['Int']['output']>;
  stage: ShiftStage;
  status: ShiftStatus;
  /** Единицы измерения для оплаты */
  unit: UnitType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  /** Значение для смен по сдельной оплате */
  value?: Maybe<Scalars['Float']['output']>;
  /** Заявка, если смена относится к Заявке */
  zayavka?: Maybe<Zayavka>;
  /** Id заявки если смена привязана к заявке */
  zayavkaId?: Maybe<Scalars['String']['output']>;
  zayavkaShifts: Array<ZayavkaShift>;
};

export type GetUserDemoFrameContractInput = {
  userContractId: Scalars['String']['input'];
};

export type GetUserNaimixContractInput = {
  userContractId: Scalars['String']['input'];
};

export type GetUserNaimixContractsInput = {
  /** Дата создания */
  createdAt?: InputMaybe<Scalars['String']['input']>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** По какому полю сортировать */
  orderBy?: InputMaybe<GetUserNaimixContractsOrderByEnum>;
  /** Направление сортировки */
  orderDirection?: InputMaybe<OrderDirectionEnum>;
  /** Поиск */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Статус подписания договора */
  status?: InputMaybe<UserContractNaimixStatusEnum>;
  /** Тип договора */
  type?: InputMaybe<UserNaimixContractTypeEnum>;
};

export type GetUserNaimixContractsModel = {
  __typename?: 'GetUserNaimixContractsModel';
  /** Общее количество договоров */
  count: Scalars['Int']['output'];
  /** Договора Наймикс пользователя */
  userNaimixContracts: Array<UserNaimixContractEntity>;
};

/** Варианты сортировки списка договоров пользователей */
export enum GetUserNaimixContractsOrderByEnum {
  /** По дате создания договора (не подписания) */
  CreatedAt = 'CREATED_AT',
  /** По фамилии */
  LastName = 'LAST_NAME',
  /** По статусу подписания договора */
  Status = 'STATUS',
  /** По типу договора */
  Type = 'TYPE'
}

export type GetUsersByRoleInput = {
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Идентификатор объекта, чтобы исключить пользователей из выдачи, которые на нём уже числятся как ответственные */
  objectId?: InputMaybe<Scalars['ID']['input']>;
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Роль пользователя */
  role: Role;
  /** Поиск по ФИО */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Пользователь, который был выбран в инпуте */
  selectedUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetUsersByRoleModel = {
  __typename?: 'GetUsersByRoleModel';
  /** Общее количество пользователей */
  count: Scalars['Int']['output'];
  /** Пользователи */
  users: Array<User>;
};

export type GetUsersInput = {
  /** Идентификатор гражданства */
  citizenshipId?: InputMaybe<Scalars['String']['input']>;
  /** Ограничение по количеству выдаваемой информации */
  limit: Scalars['Int']['input'];
  /** Статус подписания договоров Наймикс */
  naimixContractStatus?: InputMaybe<UserContractNaimixStatusEnum>;
  /** Статус проверки платёжных данных */
  naimixPaymentInfo?: InputMaybe<NaimixRegistrationCheckStatusEnum>;
  /** Статус проверки персональных данных */
  naimixPersonalInfo?: InputMaybe<NaimixRegistrationPersonalInfoStatusEnum>;
  /** Статус проверки самозанятости */
  naimixTaxPartnerInfo?: InputMaybe<NaimixRegistrationCheckStatusEnum>;
  /** Идентификатор объекта */
  objectId?: InputMaybe<Scalars['String']['input']>;
  /** Отступ выдаваемой информации */
  offset: Scalars['Int']['input'];
  /** Сортировать по */
  orderBy?: InputMaybe<GetUsersOrderByEnum>;
  /** Направление сортировки */
  orderDirection?: InputMaybe<OrderDirectionEnum>;
  /** Отображение пользователей с подтверждёнными номерами */
  phoneApprove?: InputMaybe<GetUsersPhoneApproveEnum>;
  /** Роль пользователя */
  role?: InputMaybe<UserRoleEnum>;
  /** Поиск */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type GetUsersModel = {
  __typename?: 'GetUsersModel';
  /** Общее количество пользователей */
  count: Scalars['Int']['output'];
  /** Пользователи */
  users: Array<UserEntity>;
};

/** Возможные способы сортировки пользователя */
export enum GetUsersOrderByEnum {
  /** По фамилии */
  Lastname = 'LASTNAME',
  /** По статусу прохождения проверки платёжных данных */
  PaymentInfo = 'PAYMENT_INFO',
  /** По статусу прохождения проверки в Наймикс персональных данных */
  PersonalInfo = 'PERSONAL_INFO',
  /** По статусу прохождения проверки в Наймикс самозанятости */
  TaxPartnerInfo = 'TAX_PARTNER_INFO'
}

/** Фильтрация по состоянию подтверждения номера телефона */
export enum GetUsersPhoneApproveEnum {
  /** Все */
  All = 'ALL',
  /** Только подтвержденные */
  Approved = 'APPROVED',
  /** Только не подтверждённые */
  NotApproved = 'NOT_APPROVED'
}

export type GetUsersWhoRespondedToTheRequestScheduleInput = {
  requestScheduleId: Scalars['ID']['input'];
};

export type GetUsersWhoRespondedToTheRequestShiftInput = {
  requestShiftId: Scalars['ID']['input'];
};

export type GetVacanciesOnMapInput = {
  /** Фильтрация по группе объектов */
  facilityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Нижняя граница широты */
  latBottom: Scalars['Float']['input'];
  /** Верхняя граница широты */
  latTop: Scalars['Float']['input'];
  /** Левая граница долготы */
  lonLeft: Scalars['Float']['input'];
  /** Правая граница долготы */
  lonRight: Scalars['Float']['input'];
  /** Список идентификаторов профессий */
  positionIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetVacancyGalleryInput = {
  /** Идентификатор вакансии */
  vacancyId: Scalars['String']['input'];
};

export type GroupManager = {
  __typename?: 'GroupManager';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  facilityGroup: FacilityGroup;
  user: User;
};

export type HrmsProfessionEntity = {
  __typename?: 'HrmsProfessionEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Краткое описание профессии HRMS */
  description?: Maybe<Scalars['String']['output']>;
  /** Идентификатор профессии в HRMS */
  hrmsId: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Название профессии из HRMS */
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type IVacancyStartTime = {
  __typename?: 'IVacancyStartTime';
  timesEnd: Array<Scalars['String']['output']>;
  timesStart: Array<Scalars['String']['output']>;
};

export type InitAgencyContractResponseNaimixModel = {
  __typename?: 'InitAgencyContractResponseNaimixModel';
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type InitLoginMobileInput = {
  /** Номер телефона пользователя */
  phone: Scalars['String']['input'];
  userDevice: RegisterUserDeviceInput;
};

export type InitLoginMobileModel = {
  __typename?: 'InitLoginMobileModel';
  /** Отправлено смс */
  isSmsSent: Scalars['Boolean']['output'];
  /** Дата и время когда можно будет отправить следующее сообщение */
  nextAllowSentDatetime: Scalars['Date']['output'];
};

export type InitRegisterUserInput = {
  /** Номер телефона пользователя */
  phone: Scalars['String']['input'];
  userDevice: RegisterUserDeviceInput;
};

export type InitRegisterUserModel = {
  __typename?: 'InitRegisterUserModel';
  /** Отправлено смс */
  isSmsSent: Scalars['Boolean']['output'];
  /** Дата и время когда можно будет отправить следующее сообщение */
  nextAllowSentDatetime: Scalars['Date']['output'];
};

export type InitUserFrameContractNaimixInput = {
  userContractId: Scalars['String']['input'];
};

export type InviteFriendProgressOutput = {
  __typename?: 'InviteFriendProgressOutput';
  /** Текущее количество хороших смен */
  currentShifts: Scalars['Int']['output'];
  /** Сумма бонуса */
  sum: Scalars['Float']['output'];
  /** Необходимое количество смен для достижения бонуса "Приведи друга" */
  targetShifts: Scalars['Int']['output'];
};

/** Job Name */
export enum JobName {
  NotifyLetter = 'NotifyLetter',
  SendPush = 'SendPush',
  StoryV1 = 'StoryV1',
  UnpublishPush = 'UnpublishPush',
  UnpublishStory = 'UnpublishStory'
}

export type Lead = {
  __typename?: 'Lead';
  /** ID Пользователя, который создал лида */
  authorId?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата приёмки/отказа */
  date?: Maybe<Scalars['Date']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата достижения бонуса "Приведи друга" */
  inviteFriendDate?: Maybe<Scalars['Date']['output']>;
  /** Обработан */
  isProcessed: Scalars['Boolean']['output'];
  /** Дата достижения бонуса "Очко" */
  ochkoDate?: Maybe<Scalars['Date']['output']>;
  /** Признак выплаты рефералу */
  referralPaymentDatetime?: Maybe<Scalars['Date']['output']>;
  /** Реферальная программа, к которой привязано пуш уведомление */
  referralProgram?: Maybe<ReferralProgramEntity>;
  /** Идентификатор реферальной программы, во время действия которой был зарегистрирован пользователь */
  referralProgramId?: Maybe<Scalars['String']['output']>;
  /** Признак выплаты реферреру */
  referrerPaymentDatetime?: Maybe<Scalars['Date']['output']>;
  /** Статус */
  status: LeadStatus;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Реферал */
  user?: Maybe<User>;
  /** ID Пользователя, которого пригласили */
  userId: Scalars['String']['output'];
};

/** Поля доступные для сортировки  */
export enum LeadFieldsForSorting {
  CreatedAt = 'createdAt',
  Date = 'date',
  InviteFriendDate = 'inviteFriendDate',
  Phone = 'phone',
  ReferrerPaymentDatetime = 'referrerPaymentDatetime',
  UpdatedAt = 'updatedAt'
}

export type LeadListInput = {
  /** Фильтр по минимальной дате достижения порога смен для выплаты */
  achieveDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Фильтр по максимальной дате достижения порога смен для выплаты */
  achieveDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID группы объектов */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** ID объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Фильтр по минимальной дате создания лида */
  inviteDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Фильтр по максимальной дате создания лида */
  inviteDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Идентификатор реферальной программы */
  referralProgramId?: InputMaybe<Scalars['String']['input']>;
  /** Роль пользователя */
  role?: InputMaybe<Role>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<LeadFieldsForSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  status?: InputMaybe<LeadStatus>;
};

export type LeadOutput = {
  __typename?: 'LeadOutput';
  /** ID Пользователя, который создал лида */
  authorId?: Maybe<Scalars['String']['output']>;
  /** Количество учтенных смен */
  countShifts?: Maybe<Scalars['Int']['output']>;
  /** Количество смен в статусе BAD */
  countShiftsBad?: Maybe<Scalars['Int']['output']>;
  /** Количество смен в статусе GOOD */
  countShiftsGood?: Maybe<Scalars['Int']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата приёмки/отказа */
  date?: Maybe<Scalars['Date']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата достижения бонуса "Приведи друга" */
  inviteFriendDate?: Maybe<Scalars['Date']['output']>;
  /** Прогресс бонуса "Приведи друга" */
  inviteFriendProgress: InviteFriendProgressOutput;
  /** Обработан */
  isProcessed: Scalars['Boolean']['output'];
  /** Дата достижения бонуса "Очко" */
  ochkoDate?: Maybe<Scalars['Date']['output']>;
  /** Признак выплаты рефералу */
  referralPaymentDatetime?: Maybe<Scalars['Date']['output']>;
  /** Реферальная программа, к которой привязано пуш уведомление */
  referralProgram?: Maybe<ReferralProgramEntity>;
  /** Идентификатор реферальной программы, во время действия которой был зарегистрирован пользователь */
  referralProgramId?: Maybe<Scalars['String']['output']>;
  /** Признак выплаты реферреру */
  referrerPaymentDatetime?: Maybe<Scalars['Date']['output']>;
  /** Статус */
  status: LeadStatus;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Реферал */
  user?: Maybe<User>;
  /** ID Пользователя, которого пригласили */
  userId: Scalars['String']['output'];
};

export enum LeadStatus {
  Accepted = 'ACCEPTED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type LegalEntity = {
  __typename?: 'LegalEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facility?: Maybe<Facility>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Список договоров, заключенных с исполнителями на объекте */
  userContracts?: Maybe<Array<UserContract>>;
};

export type LockWorkSheetPeriodInput = {
  /** Дата конца периода */
  endDate: Scalars['String']['input'];
  /** Идентификатор объекта */
  facilityId: Scalars['String']['input'];
  /** Дата начала периода */
  startDate: Scalars['String']['input'];
};

export type LoginInput = {
  /** Токен android устройства пользователя на который отсылаются push уведомления */
  androidToken?: InputMaybe<Scalars['String']['input']>;
  /** Токен ios устройства пользователя на который отсылаются push уведомления */
  iosToken?: InputMaybe<Scalars['String']['input']>;
  /** Пароль */
  password: Scalars['String']['input'];
  /** Номер телефона */
  phone: Scalars['String']['input'];
  /** Запомнить меня */
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginModel = {
  __typename?: 'LoginModel';
  /** Токен доступа */
  accessToken: Scalars['String']['output'];
  /** Токен обновления токена доступа */
  refreshToken: Scalars['String']['output'];
  /** Пользователь */
  user: UserEntity;
};

export type LoginTestInput = {
  /** Токен android устройства пользователя на который отсылаются push уведомления */
  androidToken?: InputMaybe<Scalars['String']['input']>;
  /** СМС код */
  code: Scalars['String']['input'];
  /** Токен Huawei устройства пользователя на который отсылаются push уведомления */
  huaweiToken?: InputMaybe<Scalars['String']['input']>;
  /** Токен ios устройства пользователя на который отсылаются push уведомления */
  iosToken?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона, с девятки без +7 или 8 */
  phone: Scalars['String']['input'];
  /** Запомнить меня */
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Информация об устройстве пользователя */
  userDevice?: InputMaybe<UserDeviceInput>;
};

export type LoginWebInput = {
  /** Пароль */
  password: Scalars['String']['input'];
  /** Номер телефона */
  phone: Scalars['String']['input'];
};

export type ManualAccrual = {
  __typename?: 'ManualAccrual';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время начала */
  dateFrom: Scalars['String']['output'];
  /** Дата и время конца */
  dateTo: Scalars['String']['output'];
  /** Объект */
  facility?: Maybe<Facility>;
  /** Id объекта */
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Строки выплат */
  items?: Maybe<Array<ManualAccrualItem>>;
  /** Существующие выплаты пользователей */
  manualUserAccruals?: Maybe<Array<ManualUserAccrual>>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ManualAccrualItem = {
  __typename?: 'ManualAccrualItem';
  accrual: ManualAccrual;
  /** Id выплаты за период */
  accrualId: Scalars['String']['output'];
  /** Сумма надобавки Активный месяца за выполненные смены */
  activeMonth?: Maybe<Scalars['Float']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Id выплаты за период */
  customName?: Maybe<Scalars['String']['output']>;
  /** Сумма надбавки Трудяга за выполненные смены */
  hardWorker?: Maybe<Scalars['Float']['output']>;
  hourRate: Scalars['Int']['output'];
  hours: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Должность за которую делается начисление */
  position?: Maybe<Position>;
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Сумма за выполненные смены по ставке без бонусов */
  rateAmount?: Maybe<Scalars['Float']['output']>;
  /** Сумма надобавки Супер-Трудяга за выполненные смены */
  superWorker?: Maybe<Scalars['Float']['output']>;
  /** Сумма со всеми надбавками */
  totalAmount?: Maybe<Scalars['Float']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user?: Maybe<User>;
  /** Id пользователя */
  userId: Scalars['String']['output'];
  /** Сумма начислений пользователю */
  userSum?: Maybe<Scalars['Float']['output']>;
};

export type ManualAccrualSenderInput = {
  /** Id выплаты за период */
  accrualId: Scalars['String']['input'];
  /** Пользователи назначенные на объект */
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ManualUserAccrual = {
  __typename?: 'ManualUserAccrual';
  accrual: ManualAccrual;
  /** Id выплаты за период */
  accrualId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Показывать в мобильном приложении */
  enabled: Scalars['Boolean']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Сумма */
  summ?: Maybe<Scalars['Float']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Модель выплаты к которой относится этот элемент */
  user?: Maybe<ManualAccrual>;
  /** Id пользователя */
  userId: Scalars['String']['output'];
};

export type MapMetrikaModel = {
  __typename?: 'MapMetrikaModel';
  in4km: Scalars['Int']['output'];
  in10km: Scalars['Int']['output'];
  inCity: Scalars['Int']['output'];
};

export type MapPlaceModel = {
  __typename?: 'MapPlaceModel';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  point?: Maybe<Scalars['String']['output']>;
  positions?: Maybe<Array<MapProfessionModel>>;
  shopName: Scalars['String']['output'];
};

export type MapProfessionModel = {
  __typename?: 'MapProfessionModel';
  erp: MapMetrikaModel;
  name: Scalars['String']['output'];
  smena: MapMetrikaModel;
};

export type Mark = {
  __typename?: 'Mark';
  /** Точность координат, в метрах */
  accuracy?: Maybe<Scalars['Int']['output']>;
  /** id пользователя который сделал отметку на смене - работник или бригадир если сделал отметку за работника */
  authorId?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** расстояние от отметки до точки объекта (по умолчанию null а не 0!) */
  distance?: Maybe<Scalars['Int']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  shift: Shift;
  shiftId: Scalars['String']['output'];
  status: MarkStatus;
  statusMessage: Scalars['String']['output'];
  time: Scalars['Date']['output'];
  type: MarkType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

/** Mark status */
export enum MarkStatus {
  Bad = 'BAD',
  Good = 'GOOD'
}

/** Mark type */
export enum MarkType {
  Checkin = 'CHECKIN',
  Checkout = 'CHECKOUT'
}

export type MedicalAttestation = {
  __typename?: 'MedicalAttestation';
  /** Даты конца аттестации строка даты YYYY-MM-DD */
  attestationEnd: Scalars['String']['output'];
  /** Даты начала аттестации строка даты YYYY-MM-DD */
  attestationStart: Scalars['String']['output'];
  bookNumber: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['String']['output'];
};

export type MetroLineEntity = {
  __typename?: 'MetroLineEntity';
  /** Город линии метро */
  city: CityEntity;
  color: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Первая станция ветки метро */
  firstLine: MetroStationEntity;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Последняя станция ветки метро */
  lastLine: MetroStationEntity;
  /** Станции метро на этой ветке */
  metroStations: Array<MetroStationEntity>;
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MetroLineOutput = {
  __typename?: 'MetroLineOutput';
  color: Scalars['String']['output'];
  firstLastOnAline: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stations: Array<MetroStation>;
};

export type MetroStation = {
  __typename?: 'MetroStation';
  addressId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  cityEntity?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  color: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Объекты привязанные к станции метро */
  facilities?: Maybe<Array<Facility>>;
  firstLastOnALine: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  latitude: Scalars['Float']['output'];
  lineName: Scalars['String']['output'];
  longitude: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MetroStationEntity = {
  __typename?: 'MetroStationEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Широта */
  lat: Scalars['Float']['output'];
  /** Долгота */
  lon: Scalars['Float']['output'];
  /** Линия станции метро */
  metroLine: MetroLineEntity;
  /** Название */
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type MetroStationsByLineOutput = {
  __typename?: 'MetroStationsByLineOutput';
  lines: Array<MetroLineOutput>;
};

export enum MigrationStatusNaimixEnum {
  /** Нет */
  None = 'NONE'
}

export type Moderation = {
  __typename?: 'Moderation';
  /** Удержания */
  arrestedPayments?: Maybe<Array<ModerationArrestedPaymentEntity>>;
  /** Причина комментария */
  cause: Scalars['String']['output'];
  /** Комментарий модерации */
  comment: Scalars['String']['output'];
  /** Размер оплаты по смене */
  cost: Scalars['Float']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Часы к оплате */
  duration: Scalars['Int']['output'];
  /** Ставка отредактированная */
  hourRate: Scalars['Float']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  /** Надбавки */
  salaryPayments?: Maybe<Array<ModerationSalaryPaymentEntity>>;
  /** Сущность смены */
  shift: Shift;
  /** Id смены для которой создана модерация */
  shiftId: Scalars['String']['output'];
  /** Оплачивается смена (да/нет) */
  toPayment: Scalars['Boolean']['output'];
  /** Учитывается бонус (да/нет) */
  toPaymentBonus: Scalars['Boolean']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Значение для смен по сдельной оплате */
  value?: Maybe<Scalars['Float']['output']>;
};

export type ModerationArrestedPaymentEntity = {
  __typename?: 'ModerationArrestedPaymentEntity';
  /** Идентификатор автора */
  authorId: Scalars['String']['output'];
  /** Причина удержания */
  cause: Scalars['String']['output'];
  /** Комментарий к удержанию */
  comment: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Идентификатор модерации */
  moderationId: Scalars['String']['output'];
  /** Сумма удержания */
  sum: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ModerationReport = {
  __typename?: 'ModerationReport';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата конца периода модерации */
  dateEnd: Scalars['Date']['output'];
  /** Дата начала периода модерации */
  dateStart: Scalars['Date']['output'];
  /** объект на который создан период */
  facility?: Maybe<Facility>;
  /** Id объекта на который создан период */
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Загружен ли файл? */
  isImportFromFile?: Maybe<Scalars['Boolean']['output']>;
  /** Количество сотрудников в отчете */
  noModerated?: Maybe<Scalars['Int']['output']>;
  /** Тип периода (WEEK, Неделя / TWO_WEEK, Две недели / MONTH, Месяц) */
  periodType: PeriodType;
  /** Количество смен в отчете */
  shiftCount?: Maybe<Scalars['Int']['output']>;
  /** Статус модерации */
  status: ModerationStatus;
  /** Дата установки статуса */
  statusDate?: Maybe<Scalars['Date']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Количество сотрудников в отчете */
  workersCount?: Maybe<Scalars['Int']['output']>;
};

export type ModerationReportListInput = {
  /** Дата конца периода модерации */
  dateEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Дата начала периода модерации */
  dateStart?: InputMaybe<Scalars['DateTime']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Тип периода (WEEK, Неделя / TWO_WEEK, Две недели / MONTH, Месяц) */
  periodType?: InputMaybe<PeriodType>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<ModerationReportListSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Статус модерации */
  status?: InputMaybe<ModerationStatus>;
};

/** поле по которому будет работать сортировка */
export enum ModerationReportListSorting {
  DateStart = 'dateStart',
  StatusDate = 'statusDate',
  UpdatedAt = 'updatedAt'
}

/** Данные для непосредственно экрана табеля */
export type ModerationReportTable = {
  __typename?: 'ModerationReportTable';
  /** Массив смен в дне */
  report: ModerationReport;
  /** Массив смен в дне */
  rows: Array<ModerationReportTableRow>;
};

/** Строка Табеля */
export type ModerationReportTableRow = {
  __typename?: 'ModerationReportTableRow';
  /** Сумма бонусных выплат */
  bonusPayment: Scalars['Int']['output'];
  /** Бонус Все возможно если есть на объекте и работник достиг его */
  everythingIsPossibleBonus?: Maybe<Scalars['Float']['output']>;
  /** Фактическое количество часов */
  factHours: Scalars['Float']['output'];
  /** Фактическое число отработанных */
  factValue: Scalars['Float']['output'];
  /** Сумма бонусных выплат */
  finalPayment: Scalars['Int']['output'];
  /** количество смен без модерации */
  noModeratedCount?: Maybe<Scalars['Int']['output']>;
  /** Сумма штрафов */
  penaltySum?: Maybe<Scalars['Int']['output']>;
  /** Плановое число часов */
  planHours: Scalars['Float']['output'];
  /** Плановое число отработанных */
  planValue: Scalars['Float']['output'];
  /** Должность */
  position: Position;
  /** Сумма стажировочных смен */
  probationSum?: Maybe<Scalars['Float']['output']>;
  /** Идентификатор отчёта */
  reportId: Scalars['String']['output'];
  /** Смены */
  shifts: Array<ShiftFact>;
  /** Количество смен */
  shiftsCount: Scalars['Int']['output'];
  /** Количество смен к оплате */
  shiftsToPayment: Scalars['Int']['output'];
  /** Сумма */
  sum: Scalars['Float']['output'];
  /** Статус оплаты */
  toPayment: Scalars['Boolean']['output'];
  /** Единицы измерения для оплаты */
  unit: UnitType;
  /** Пользователь */
  user: User;
};

export type ModerationSalaryPaymentEntity = {
  __typename?: 'ModerationSalaryPaymentEntity';
  /** Идентификатор автора */
  authorId: Scalars['String']['output'];
  /** Причина надбавки */
  cause: Scalars['String']['output'];
  /** Комментарий к надбавке */
  comment: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Идентификатор модерации */
  moderationId: Scalars['String']['output'];
  /** Сумма надбавки */
  sum: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Moderation status */
export enum ModerationStatus {
  InWork = 'IN_WORK',
  Sent = 'SENT'
}

/** DTO для ручной установки периода стажировки работнику */
export type MoveProbationPeriodInput = {
  /** Новая дата стажировки */
  dateFrom: Scalars['DateTime']['input'];
  /** ID объекта */
  facilityId: Scalars['String']['input'];
  /** ID профессии */
  positionId: Scalars['String']['input'];
  /** ID исполнителя */
  userId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Принять изменения в заявке (супервайзер) */
  acceptChangesBySupervisor: Scalars['Boolean']['output'];
  /** Одобрить откликнувшихся исполнителей на смену */
  acceptRequestShiftsSuggestions: ZayavkaSchedule;
  /** Принять заявку директором */
  acceptZayavkaByDirector: Scalars['Boolean']['output'];
  /** Принять заявку супервайзером */
  acceptZayavkaBySupervisor: Scalars['Boolean']['output'];
  /** создает запрос на добавление контактного номера телефона (должен быть подтвержден через смс) */
  addContactPhone: Scalars['Boolean']['output'];
  /** Назначает Директора на группу объектов */
  addDirectorToFacilityGroup: User;
  /** Назначает Бригадира на объект */
  addForemanToFacility: User;
  /** Назначает Менеджера на объект */
  addManagerToFacility: User;
  /** Назначает Менеджера на группу объектов */
  addManagerToFacilityGroup: Scalars['Boolean']['output'];
  /** Метод для добавления лида пользователем */
  addReferral: Scalars['Boolean']['output'];
  /** Добавить ответственных на объект web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12875-37991&t=Hx3U0quytriJLcbw-4 */
  addResponsibleToObject: Scalars['Boolean']['output'];
  /** Назначает Супервайзера на объект */
  addSupervisorToFacility: User;
  /** Добавление пустой строки с пользователем в модерацию */
  addUserToModerationReport: ModerationReportTableRow;
  /** Метод для архивирования реферальной программы */
  archiveReferralProgram: Scalars['Boolean']['output'];
  /** Принять сотрудником горячую смену */
  assignTemporaryShiftToUser: Shift;
  /** Создает на "График заявки"(ZayavkaSchedule) новый "График работнику"(Schedule), после этого работник считается назначенным на график заявки */
  assignZayavkaSchedule: ZayavkaSchedule;
  /** Назначение работника на смену заявки */
  assignZayavkaShift: ZayavkaShift;
  /** Забронировать смену в графике заявок */
  bookAShiftInTheSchedule: Array<ZayavkaShift>;
  /** Расчет свежих данных по периодам HOUR, DAY, WEEK, MONTH */
  calculateLatestMetrics: Scalars['Boolean']['output'];
  /** Отменить запланированное изменение ставки профессии */
  cancelPlanCasingRate: Scalars['Boolean']['output'];
  /** Метод для планирования новой ставки профессии объекта */
  cancelPlannedObjectProfessionRate: Scalars['Boolean']['output'];
  /** Отмена горячей смены (и назначенной смены работнику если она есть) */
  cancelTemporaryShift: Scalars['Boolean']['output'];
  /** Отменить заявку (совсем) */
  cancelZayavka: Scalars['Boolean']['output'];
  /** Предложить отмену заявки менеджером */
  cancelZayavkaByManager: Scalars['Boolean']['output'];
  /** Редактирование надбавки */
  changeArrestedPayment: ModerationArrestedPaymentEntity;
  /** Метод для изменения или создания (если нет) кастомного графика пользователя */
  changeCustomSchedule: Schedule;
  /** Устанавливает информацию о штрафах на объекте */
  changeFacilityPenalty: Penalty;
  /** Изменяет is_active объекта - скрывает активный и наоборот */
  changeFacilityStatus: Facility;
  /** Смена основного номера телефона шаг 4 */
  changeMainPhoneStepFour: ContactPhone;
  /** Смена основного номера телефона шаг 1 */
  changeMainPhoneStepOne: Scalars['Boolean']['output'];
  /** Смена основного номера телефона шаг 3 */
  changeMainPhoneStepThree: Scalars['Boolean']['output'];
  /** Смена основного номера телефона шаг 2 */
  changeMainPhoneStepTwo: Scalars['Boolean']['output'];
  /** Устанавливает статус модерации строке пользователя */
  changeModerationSelectedUsers: Array<ModerationReportTableRow>;
  /** Метод для получения паспортных данных */
  changeMyPersonalInfoPassport: MyPersonalInfoPassportOutput;
  /** Изменение статуса активности объекта web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12875-37176&t=Hx3U0quytriJLcbw-4 */
  changeObjectActivityState: Scalars['Boolean']['output'];
  /** Изменить пароль */
  changePassword: User;
  /** Метод для изменения информации по медицинской книжке пользователя */
  changePersonalInfoMedInvoice: PersonalInfoMedInvoiceOutput;
  /** Метод для изменения медицинской книжки пользователя */
  changePersonalInfoMedical: PersonalInfoMedicalOutput;
  /** Метод изменения паспортных данных пользователя */
  changePersonalInfoPassport: PersonalInfoPassportOutput;
  /** Метод изменения платёжных данных пользователя */
  changePersonalInfoPayment: PersonalInfoPaymentOutput;
  /** Метод для изменения пользователю регистрации по паспорту */
  changePersonalInfoRegistration: Requisite;
  /** Метод изменения статуса самозанятого пользователя */
  changePersonalInfoTax: PersonalInfoTaxOutput;
  /** @deprecated Использовать saveUserQuestionnaire */
  changeQuestionnaireExtended: Questionnaire;
  /** Назначение пользователя из импорта к пользователю на объекте */
  changeResolveReportUser: ResolveReportUserModel;
  /** Редактирование надбавки */
  changeSalaryPayment: ModerationSalaryPaymentEntity;
  /** Метод для изменения или создания (если нет) графика пользователя */
  changeSchedule: Schedule;
  /** Редактирование надбавки */
  changeShiftArrestedPayment: ShiftArrestedPaymentEntity;
  /** Редактирование / Модерация смены */
  changeShiftModeration: ShiftFact;
  /** Редактирование надбавки */
  changeShiftSalaryPayment: ShiftSalaryPaymentEntity;
  /** Изменяет статус смены */
  changeShiftStage: Shift;
  /** Смена типа слайда "Истории" */
  changeStorySlideType: StorySlide;
  /** Метод для изменения персональных данных */
  changeUserInfoMain: ChangeUserInfoMainModel;
  /** Поменять пароль пользователя */
  changeUserPassword: User;
  /** Сменить роль пользователя */
  changeUserRole: User;
  /** Изменить статус пользователя */
  changeUserStatus: User;
  /** Изменяет is_active объекта - скрывает активный и наоборот */
  changeVacancyStatus: Vacancy;
  /** Актуальное создание Чекина/Чекаута, возвращает модель Mark */
  createAndGetMark: Mark;
  /** Создание надбавки */
  createArrestedPayment: ModerationArrestedPaymentEntity;
  /** Создать оклад */
  createCasing: Casing;
  /** Создать оклад */
  createCasingsInBatch: Array<Casing>;
  /** Метод для создания города */
  createCity: CityEntity;
  /** добавляет контактный номер телефона работнику */
  createContactPhone: ContactPhone;
  createDailyReport: Report;
  /** Метод для создания черновика реферальной программы */
  createDraftReferralProgram: NewReferralProgramEntity;
  /** Создание объекта */
  createFacility: Facility;
  /** Создание группы объектов */
  createFacilityGroup: FacilityGroup;
  /** Метод добавления новой профессии HRMS */
  createHrmsProfession: HrmsProfessionEntity;
  createLeadsReport: Report;
  /** Создает объект выплаты за период */
  createManualAccuralByPeriod: ManualAccrual;
  /** Метод для создания реферальных программ для групп и объектов. Возвращает количество созданных программ */
  createManyReferralPrograms: Scalars['Int']['output'];
  /** Создание новой модерации */
  createModerationReport: ModerationReport;
  /** Создание нового объекта web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12858-26481&t=Hx3U0quytriJLcbw-4 */
  createNewObject: ObjectEntity;
  /** Метод для создания новой бонусной программы */
  createNewObjectPromotion: ObjectPromotionEntity;
  /** создать горячу смену */
  createNewTemporaryShift: TemporaryShift;
  /** Создание должности web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=14528-30089&t=6fdG4F3vMmTCMLV6-4 */
  createNewWorkPost: WorkPostEntity;
  /** Создать уведомление */
  createNotification: Notification;
  /** Создать рассылку */
  createNotifyLetter: NotifyLetter;
  /** Метод для создания новой профессии объекта */
  createObjectProfession: ObjectProfessionEntity;
  /** Создание объекта вакансии */
  createObjectVacancy: ObjectVacancyEntity;
  /** Создать или обновить реквизиты пользователя */
  createOrUpdateUserRequisite: Requisite;
  /** Поставить подработку на пользователя */
  createPart: Shift;
  createPollsReport: Report;
  /** Создать позицию */
  createPosition: Position;
  createReportEverythingIsPossibleBonus: Report;
  /** Создание надбавки */
  createSalaryPayment: ModerationSalaryPaymentEntity;
  /** Предложить пользователю смену */
  createShift: ShiftEntity;
  /** Создание надбавки */
  createShiftArrestedPayment: ShiftArrestedPaymentEntity;
  /** Метод для создания комментария к смене на модерацию */
  createShiftComment: ShiftCommentEntity;
  /** Создание смены сразу с модерацией для табеля */
  createShiftInModeration: ShiftFact;
  createShiftMark: ShiftMarkEntity;
  /** Создать штраф на смене */
  createShiftPenalty: ShiftPenaltyEntity;
  /** Создание надбавки */
  createShiftSalaryPayment: ShiftSalaryPaymentEntity;
  /** Создание "Истории" с названием по умолчанию */
  createStory: Story;
  /** Создает слайд "Истории" с указанным типом */
  createStorySlideByType: StorySlide;
  createTimesheetByMonthAndFacility: Report;
  createTimesheetByMonthAndFacilityGroup: Report;
  /** Создание пользователя */
  createUserByPersonalInfo: User;
  /** метод для создания пользователя через API ERP */
  createUserErp: User;
  /** Создает оценку пользователя */
  createUserGrade: UserGrade;
  /** Создать пользовательские реквизиты */
  createUserRequisite: Requisite;
  /** Создает отзыв о пользователе */
  createUserReview: UserReview;
  /** Создание вакансии */
  createVacancy: Vacancy;
  /** Создание вакансий списком */
  createVacancyInBatch: Array<Vacancy>;
  /** Создание должности */
  createWorkPost: WorkPost;
  /** Создание заявки */
  createZayavka: ZayavkaProgress;
  /** Создание графика в заявке */
  createZayavkaSchedule: Array<ZayavkaSchedule>;
  /** Создает смену в заявке со стороны клиента */
  createZayavkaShiftByClient: ZayavkaShift;
  /** Производит проверку статуса прохождения регистрации Наймикс, подтягивание документов и обновление персональной информации пользователей */
  cron_checkContractorStatusNaimix: Scalars['String']['output'];
  /** Собирает статистику для дашборда за разные интервалы времени */
  cron_dashboardStatistic: Scalars['String']['output'];
  /** Удаляет реферальные программы со статусом DRAFT, по условию COALESCE(updatedAt, createdAt) <= NOW() - INTERVAL '1 DAY' */
  cron_deleteOldDraftReferralPrograms: Scalars['String']['output'];
  /** Удаление непринятых вовремя графиков */
  cron_deletingSchedulesThatWereNotAcceptedOnTime: Scalars['String']['output'];
  /** Определяет смены, которые заканчиваются и отправляет уведомления об окончании */
  cron_detectingEndingShiftsAndSendingNotifications: Scalars['String']['output'];
  /** Определяет смены, которые начинаются и отправляет уведомления о начале смены */
  cron_detectingStartingShiftsAndSendingNotifications: Scalars['String']['output'];
  /** Удаление записей старше 3 лет от текущего момента из таблицы Marks */
  cron_dropOldMarks: Scalars['String']['output'];
  /** Удаление записей старше 1 месяца от текущего момента из таблицы Notification */
  cron_dropOldNotifications: Scalars['String']['output'];
  /** Удаление записей старше 1 года от текущего момента из таблицы UserActivityLog */
  cron_dropOldUserActivityLog: Scalars['String']['output'];
  /** Закрывает стажировку для профессий, где сутки назад закончился стажировочный период */
  cron_finishProbation: Scalars['String']['output'];
  /** Принудительное закрытие смен спустя 2 часа после завершения */
  cron_forcedClosingOfShifts: Scalars['String']['output'];
  /** Рассылка уведомлений пользователям о незавершённой регистрации в Наймикс */
  cron_notifyingUsersAboutUnfinishedRegistrationInNaimix: Scalars['String']['output'];
  /** Уведомления о сроке действия медицинской книжки */
  cron_processingOfExpiredMedicalBooks: Scalars['String']['output'];
  /** Отправляет лида в телегу и ERP, если пользователь зареган больше 10 минут и лид ещё не был отправлен */
  cron_sendLeadAfterRegistration: Scalars['String']['output'];
  /** Отправляет бригадирам уведомления об опоздавших сотрудниках */
  cron_sendsNotificationsToForemenAboutLateWorkers: Scalars['String']['output'];
  /** Запуск бонусных программ, если наступило время запуска */
  cron_startObjectPromotions: Scalars['String']['output'];
  /** Запускает реферальные программы */
  cron_startReferralPrograms: Scalars['String']['output'];
  /** Остановка бонусных программ, если наступило время остановки */
  cron_stopObjectPromotions: Scalars['String']['output'];
  /** Останавливает реферальные программы */
  cron_stopReferralPrograms: Scalars['String']['output'];
  /** Перевод заявок в статус "выполнено/finished" */
  cron_transferTheRequestToTheStatusCompleted: Scalars['String']['output'];
  /** Отклонить отмену заявки директором */
  declineCancelZayavkaByDirector: Scalars['Boolean']['output'];
  /** Отклонение изменений менеджера (Директором) */
  declineChangesByDirector: Scalars['Boolean']['output'];
  /** Отклонить изменения (супервайзер) */
  declineChangesBySupervisor: Scalars['Boolean']['output'];
  /** Отклонить откликнувшихся исполнителей на смену */
  declineRequestShiftsSuggestions: ZayavkaSchedule;
  /** Отклонить заявку Директором */
  declineZayavkaByDirector: Scalars['Boolean']['output'];
  /** Отклонить заявку супервайзером */
  declineZayavkaBySupervisor: Scalars['Boolean']['output'];
  /** Удалить все смены пользователя */
  deleteAllUserShifts: Scalars['Boolean']['output'];
  /** Удаление удержания */
  deleteArrestedPayment: Scalars['Boolean']['output'];
  /** удаление контактного номера телефона пользователю */
  deleteContactPhone: Scalars['Boolean']['output'];
  /** Удалить запись из выплаты */
  deleteManualAccuralItem: Scalars['Boolean']['output'];
  /** Удаление аккаунта */
  deleteMe: Scalars['Boolean']['output'];
  /** Удаляется "Рассылка Уведомлений" */
  deleteNotifyLetter: Scalars['Boolean']['output'];
  /** Метод для удаления профессии объекта */
  deleteObjectProfession: Scalars['Boolean']['output'];
  /** Метод для удаления бонусной программы */
  deleteObjectPromotion: Scalars['Boolean']['output'];
  /** Метод для удаления реферальной программы */
  deleteReferralProgram: Scalars['Boolean']['output'];
  /** Удаление надбавки */
  deleteSalaryPayment: Scalars['Boolean']['output'];
  /** Удаление удержания */
  deleteShiftArrestedPayment: Scalars['Boolean']['output'];
  /** Удаление надбавки */
  deleteShiftSalaryPayment: Scalars['Boolean']['output'];
  /** Удаляется "истории" */
  deleteStoryAndFiles: Scalars['Boolean']['output'];
  /** Удаляется "миниатюра" для "истории" */
  deleteStoryIcon: Story;
  /** Удаляется Слайд "истории" */
  deleteStorySlide: Scalars['Boolean']['output'];
  /** Удаление аккаунта пользователя */
  deleteUser: Scalars['Boolean']['output'];
  /** Снимает работника из назначения на график заявки */
  deleteWorkerFromZayavkaSchedule: ZayavkaSchedule;
  /** Удаляет работника из смены в заявке */
  deleteWorkerFromZayavkaShift: Scalars['Boolean']['output'];
  /** Удаляет график в заявке */
  deleteZayavkaSchedule: Scalars['Boolean']['output'];
  /** Удаляет смену в заявке со стороны клиента */
  deleteZayavkaShiftByClient: Scalars['Boolean']['output'];
  /** Загрузить отчёт модерации */
  downloadModerationReport: Report;
  /** Метод для редактирования города */
  editCity: CityEntity;
  /** Метод изменения профессии HRMS */
  editHrmsProfession: HrmsProfessionEntity;
  /** Редактирование объекта web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12947-38598&t=Hx3U0quytriJLcbw-4 */
  editObject: ObjectEntity;
  /** Метод для редактирования профессии объекта */
  editObjectProfession: ObjectProfessionEntity;
  /** Метод для редактирования бонусной программы в группе объектов */
  editObjectPromotion: ObjectPromotionEntity;
  /** Редактирование объекта вакансии web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=14000-114346&t=Hx3U0quytriJLcbw-4 */
  editObjectVacancy: ObjectVacancyEntity;
  /** Метод для редактирования реферальной программы */
  editReferralProgram: NewReferralProgramEntity;
  /** Метод для изменения графика */
  editSchedule: Schedule;
  /** Редактирование смены. Доступ имеет ADMIN или SUPERVISOR назначенный на соотв. смене объект. */
  editShift: Shift;
  emptyQueueByMessageType: Scalars['Boolean']['output'];
  /** Загрузка и добавление лого в группу объектов */
  facilityGroupUploadImage: FacilityGroup;
  /** Метод создания фейк-кода для авторизации по номеру телефона и смс */
  fakeCode: Scalars['String']['output'];
  /** Метод для добавления смен после импорта файла */
  finishResolveReportUser: Scalars['Boolean']['output'];
  /** возвращает способ авторизации пользователя по номеру телефона, в ответе приходит 'sms-message' или 'password' или ошибка отправки sms-message */
  getAuthOption: AuthOption;
  /** Скрывает график */
  hideSchedule: Scalars['Boolean']['output'];
  /** Скрывает для отображения смену */
  hideShift: Scalars['Boolean']['output'];
  /** Инициализация изменения платёжных данных пользователя в Наймикс */
  initEditUserPaymentInfoInNaimix: Scalars['Boolean']['output'];
  /** Инициализация авторизации пользователя в приложении */
  initLoginMobile: InitLoginMobileModel;
  /** Инициализация регистрации пользователя в приложении */
  initRegisterUser: InitRegisterUserModel;
  /** Метод для блокировки периода и отправки в HRMS */
  lockWorkSheetPeriod: Scalars['Boolean']['output'];
  /** Метод авторизации по номеру телефона и паролю */
  login: Auth;
  /** Метод логина, через номер телефона и код из смс */
  loginByCode: Auth;
  /** Авторизация пользователя в админке */
  loginWeb: LoginModel;
  /** Обнуляет токены устройств пользователя */
  logout: Scalars['Boolean']['output'];
  /** Пометить сообщение как новое */
  markAsNewNotification: Notification;
  /** Мутация для ручной установки периода стажировки работнику */
  moveProbationPeriod: WorkPost;
  /** меняет местами значение index в двх сущностях StorySlide */
  moveStorySlide: Story;
  /** Отправить заявку директором */
  moveZayavkaToDirector: Scalars['Boolean']['output'];
  parseAndSaveFacilityMetroStationsIds: Scalars['Boolean']['output'];
  /** Запланировать изменение ставки профессии */
  planCasingRate: CasingRateEntity;
  /** Метод для планирования новой ставки профессии объекта */
  planObjectProfessionRate: Array<ObjectProfessionRateEntity>;
  /** Запрос, сделает все непрочитанные нотификации авторизованного пользователя прочитанными */
  readAllNotification: Scalars['Boolean']['output'];
  /** Прочитать уведомление */
  readNotification: Notification;
  /** Метод для прочтения всех комментариев к смене на модерацию. Возвращает число затронутых комментариев */
  readShiftComments: Scalars['Int']['output'];
  /** Метод обновления связки refresh-access токена по refresh токену */
  refreshToken: Token;
  /** Метод для удаления графика */
  refuseSchedule: Schedule;
  /** Меняет статус смены на REFUSED. Доступ имеет ADMIN или SUPERVISOR назначенный на соотв. смене объект. */
  refuseShift: Shift;
  /** Удалить оклад */
  removeCasing: Scalars['Boolean']['output'];
  /** Метод для удаления города по идентификатору */
  removeCity: Scalars['Boolean']['output'];
  /** Удаляет все отложенные задачи в очереди push-уведомлений */
  removeDelayedJobs: Scalars['Boolean']['output'];
  /** Убирает Директора из Группы объектов */
  removeDirectorFromFacilityGroup: Scalars['Boolean']['output'];
  /** Отключение штрафа на объекте */
  removeFacilityPenalty: Scalars['Boolean']['output'];
  /** Убирает Бригадира с Объекта */
  removeForemanFromFacility: Scalars['Boolean']['output'];
  removeJobsFromPushingQueue: Scalars['Boolean']['output'];
  /** Убирает Менеджера с Объекта */
  removeManagerFromFacility: Scalars['Boolean']['output'];
  /** Убирает Менеджера из Группы объектов */
  removeManagerFromFacilityGroup: Scalars['Boolean']['output'];
  /** Удалить фотографию из альбома профессии объекта */
  removePhotoInCasingGallery: Scalars['Boolean']['output'];
  /** Удалить фотографию из альбома профессии объекта */
  removePhotoInFacilityGallery: Scalars['Boolean']['output'];
  /** Удалить фотографию из альбома объекта */
  removePhotoInObjectPhotoGallery: Array<ObjectPhotoGalleryEntity>;
  /** Удалить фотографию из альбома объекта */
  removePhotoInObjectProfessionPhotoGallery: Array<ObjectProfessionPhotoGalleryEntity>;
  /** Удалить позицию */
  removePosition: Scalars['Boolean']['output'];
  /** Удалить ответственных на объекте web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12875-38000&t=Hx3U0quytriJLcbw-4 */
  removeResponsibleFromTheObject: Scalars['Boolean']['output'];
  /** Снимает статус "Свободная" со смены в заявке */
  removeStatusFreeRequestShift: Scalars['Boolean']['output'];
  /** Убирает Супервайзера с Объекта */
  removeSupervisorFromFacility: Scalars['Boolean']['output'];
  /** Метод для удаления пользовательского документа */
  removeUserDocument: Scalars['Boolean']['output'];
  /** Удаление должности */
  removeWorkPost: Scalars['Boolean']['output'];
  /** Мутация на пересчет всех данных по статистике */
  resetMetrics: Scalars['Boolean']['output'];
  /** Метод возврата бонусной программы к настройкам по умолчанию */
  resetToDefaultObjectPromotion: ObjectPromotionEntity;
  /** Отклик на вакансию */
  respond: User;
  /** Восстановить пользователя на должность */
  restoreWorkerPosition: Array<WorkerFacilityWorkPostsOutput>;
  /** Обновить информацию о пользователе */
  saveUserQuestionnaire: User;
  /** Отправить директору изменения менеджера */
  sendChangesToDirector: Scalars['Boolean']['output'];
  /** Отправить супервайзеру изменения */
  sendChangesToSupervisor: Scalars['Boolean']['output'];
  /** Отправить сообщение с ссылкой на приложение */
  sendDownloadSms: Scalars['String']['output'];
  /** Метод для отправки свободных смен по id графика */
  sendFreeShiftByRequestShiftId: Array<ZayavkaProgress>;
  /** Метод для отправки свободных смен по id заявок */
  sendFreeShiftsByRequestIds: Array<ZayavkaProgress>;
  /** Метод для отправки свободных смен по id графика */
  sendFreeShiftsByRequestScheduleId: Array<ZayavkaProgress>;
  /** Фиксирует выплаты для отображения у пользователей в мобильном приложении */
  sendManualAccurals: Scalars['Boolean']['output'];
  /** Отправить пользовательские данные в Наймикс */
  sendUserDataToNaimix: Scalars['Boolean']['output'];
  /** устанавливает контактный номер телефона как основной */
  setContactPhoneToMain: User;
  /** Устанавливает параметры "Все Возможно Бонус" на объекте */
  setEverythingIsPossibleBonus: Facility;
  /** Метод для изменения статуса модерации */
  setModerationReportStatus: Scalars['Boolean']['output'];
  /** Метод проставляет дату отметки об оплате по реферальной программе */
  setReferralProgramPaymentDatetime: Lead;
  /** Метод для установки статуса проверки пользовательского документа */
  setReviewStatus: DocumentReview;
  /** Метод для изменения статуса графика */
  setScheduleStatus: SetScheduleOutput;
  /** Изменить/создать переменные для фронта */
  setSetting: Setting;
  /** Записывает пользователю по токену город */
  setSettlementForUser: Scalars['Boolean']['output'];
  /** Обновление информации о параметрах публикации "Истории" */
  setStoryPublicCondition: Story;
  /** Записывает работнику город */
  setToUserWorkCity: Scalars['Boolean']['output'];
  /** Записывает токен пользователя в браузере для получения браузерных уведомлений */
  setUserBrowserToken: User;
  /** Метод для изменения токена пользователя */
  setUserToken: Scalars['Boolean']['output'];
  /** Устанавливает параметры срока ожидания мед.книжки у работника после осмотра для работы на объекте */
  setWaitingMedicalOnFacility: Facility;
  /** Отклик на Акцию и отправка в CRM данных по отклику */
  shareResponse: Scalars['Boolean']['output'];
  /** Изменение пользовательских данных в Наймикс */
  signEditUserPaymentInfoInNaimix: Scalars['Boolean']['output'];
  /** Авторизация пользователя в приложении */
  signLoginMobile: LoginModel;
  /** Регистрация пользователя в приложении */
  signRegisterUser: LoginModel;
  smsReport: Report;
  /** Загрузка и добавление изображения в "историю", создает сущность слайд */
  storySlideReplaceImage: StorySlide;
  /** Загрузка и добавление изображения в "историю", создает сущность слайд */
  storySlideUploadImage: StorySlide;
  /** Загрузка и добавление "миниатюры" в "историю" */
  storyUploadIcon: Story;
  /** Подписка на вакансию */
  subscribe: User;
  /** Отправить рассылку на публикацию */
  toPublishNotifyLetter: NotifyLetter;
  /**
   * Устанавливает статус "ожидает публикации" если условия публикации ожидают наступления
   * либо статус "опубликовано" если условия публикации выполнены
   * возвращает сущность "сторис" с установленным статусом
   */
  toPublishStory: Story;
  /** переводит рассылку уведомлений в статус "REMOVED" (Снято с публикации) */
  toRemoveNotifyLetter: NotifyLetter;
  /** Устанавливает статус "Снято с публикации" */
  toRemovePublishStory: Story;
  /** Снять пользователя с должност(-и/-ей) */
  unassignUserOnWorkPost: Array<WorkPostEntity>;
  /** Снять пользователя с должности в объекте */
  unassignWorkerFromFacility: Array<WorkerFacilityWorkPostsOutput>;
  /** Снять пользователя с должности на группе объектов */
  unassignWorkerFromFacilityGroup: Array<WorkerFacilityWorkPostsOutput>;
  /** Снять пользователя с должности */
  unassignWorkerFromPosition: Array<WorkerFacilityWorkPostsOutput>;
  /** Обновить оклад */
  updateCasing: Casing;
  /** Метод для изменения города */
  updateCity: City;
  /** Пакетное обновление статуса активности у объектов */
  updateFacilitiesActivity: Scalars['Boolean']['output'];
  /** Пакетное обновление юр. лиц у объектов */
  updateFacilitiesLegalEntities: Scalars['Boolean']['output'];
  /** Метод для обновления объекта */
  updateFacility: Facility;
  /** Обновление информации о группе объектов */
  updateFacilityGroup: FacilityGroup;
  /** Метод для обновления лида */
  updateLead: Lead;
  /** Обновить рассылку */
  updateNotifyLetter: NotifyLetter;
  /** Обновить позицию */
  updatePosition: Position;
  /** Модерация оплаты бонуса */
  updateShiftModeration: Scalars['Boolean']['output'];
  /** Обновление информации о "Истории" */
  updateStory: Story;
  /** Обновление информации о слайде "Истории" */
  updateStorySlide: StorySlide;
  /** @deprecated Неудобный метод. Распилили */
  updateUser: User;
  /** Обновление email пользователя */
  updateUserEmail: User;
  /** Обновление статуса работы с Наймикс пользователя */
  updateUserNaimixWorkStatus: User;
  /** Обновление имени, фамилии, отчества и гражданства пользователя */
  updateUserNameAndCitizenship: User;
  /** Обновить пользовательские реквизиты */
  updateUserRequisite: Requisite;
  /** Обновить текущую версию приложения пользователя */
  updateUserVersion: User;
  /** Обновление вакансии */
  updateVacancy: Vacancy;
  /** Обновление заявки */
  updateZayavka: ZayavkaProgress;
  /** Создание в заявке по должности */
  updateZayavkaSchedule: ZayavkaSchedule;
  /** Обновляет смену в заявке со стороны клиента */
  updateZayavkaShiftByClient: ZayavkaShift;
  /** Загрузка кропнутого изображения */
  uploadCropImage: File;
  /** Загрузить фотографии в альбом профессии объекта */
  uploadPhotoInCasingGallery: CasingGalleryEntity;
  /** Загрузить фотографии в альбом объекта */
  uploadPhotoInFacilityGallery: FacilityGalleryEntity;
  /** Загрузить фотографии в альбом объекта */
  uploadPhotoInObjectPhotoGallery: ObjectPhotoGalleryEntity;
  /** Загрузить фотографии в альбом профессии объекта */
  uploadPhotoInObjectProfessionPhotoGallery: ObjectProfessionPhotoGalleryEntity;
  /** Загрузка Excel файлов со сменами */
  uploadShiftsExcel: Scalars['Boolean']['output'];
  /** Загрузка и добавление пользовательских документов */
  uploadUserDocument: UserDocumentEntity;
  /** Загрузить сканы документов пользователя для отправки в Наймикс */
  uploadUserFileScanForNaimix: File;
  /** проверяет код отравленный для добавления номера телефона */
  verifyContactPhone: ContactPhone;
  /** Пометить историю как просмотренную */
  viewStory: Scalars['Boolean']['output'];
  /** Создает запись в БД о действии пользователя */
  writeMobileLog: Scalars['Boolean']['output'];
};


export type MutationAcceptChangesBySupervisorArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptRequestShiftsSuggestionsArgs = {
  input: AcceptRequestShiftsSuggestionsInput;
};


export type MutationAcceptZayavkaByDirectorArgs = {
  id: Scalars['String']['input'];
};


export type MutationAcceptZayavkaBySupervisorArgs = {
  id: Scalars['String']['input'];
};


export type MutationAddContactPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type MutationAddDirectorToFacilityGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddForemanToFacilityArgs = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddManagerToFacilityArgs = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddManagerToFacilityGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddReferralArgs = {
  input: AddReferralInput;
};


export type MutationAddResponsibleToObjectArgs = {
  input: AddResponsibleToObjectInput;
};


export type MutationAddSupervisorToFacilityArgs = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationAddUserToModerationReportArgs = {
  input: AddUserModerationReportInput;
};


export type MutationArchiveReferralProgramArgs = {
  input: ArchiveReferralProgramInput;
};


export type MutationAssignTemporaryShiftToUserArgs = {
  input: AssignTemporaryShiftInput;
};


export type MutationAssignZayavkaScheduleArgs = {
  workerId: Scalars['String']['input'];
  zayavkaScheduleId: Scalars['String']['input'];
};


export type MutationAssignZayavkaShiftArgs = {
  workerId: Scalars['String']['input'];
  zayavkaShiftId: Scalars['String']['input'];
};


export type MutationBookAShiftInTheScheduleArgs = {
  input: BookAShiftInTheScheduleInput;
};


export type MutationCancelPlanCasingRateArgs = {
  input: CancelPlanCasingRateInput;
};


export type MutationCancelPlannedObjectProfessionRateArgs = {
  input: CancelPlannedObjectProfessionRateInput;
};


export type MutationCancelTemporaryShiftArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelZayavkaArgs = {
  id: Scalars['String']['input'];
};


export type MutationCancelZayavkaByManagerArgs = {
  id: Scalars['String']['input'];
};


export type MutationChangeArrestedPaymentArgs = {
  input: ChangeArrestedPaymentInput;
};


export type MutationChangeCustomScheduleArgs = {
  inputs: Array<SingleShiftInput>;
};


export type MutationChangeFacilityPenaltyArgs = {
  applyTimeInMinutes: Scalars['Int']['input'];
  cost: Scalars['Int']['input'];
  facilityId: Scalars['String']['input'];
};


export type MutationChangeFacilityStatusArgs = {
  id: Scalars['String']['input'];
};


export type MutationChangeMainPhoneStepFourArgs = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationChangeMainPhoneStepThreeArgs = {
  phone: Scalars['String']['input'];
};


export type MutationChangeMainPhoneStepTwoArgs = {
  code: Scalars['String']['input'];
};


export type MutationChangeModerationSelectedUsersArgs = {
  input: ChangeModerationUserRowInput;
};


export type MutationChangeMyPersonalInfoPassportArgs = {
  input: MyPersonalInfoPassportInput;
};


export type MutationChangeObjectActivityStateArgs = {
  input: ChangeObjectActivityStateInput;
};


export type MutationChangePasswordArgs = {
  data: ChangePasswordInput;
};


export type MutationChangePersonalInfoMedInvoiceArgs = {
  input: PersonalInfoMedInvoiceInput;
};


export type MutationChangePersonalInfoMedicalArgs = {
  input: PersonalInfoMedicalInput;
};


export type MutationChangePersonalInfoPassportArgs = {
  input: PersonalInfoPassportInput;
};


export type MutationChangePersonalInfoPaymentArgs = {
  input: PersonalInfoPaymentInput;
};


export type MutationChangePersonalInfoRegistrationArgs = {
  registration: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChangePersonalInfoTaxArgs = {
  input: PersonalInfoTaxInput;
};


export type MutationChangeQuestionnaireExtendedArgs = {
  questionnaire: QuestionnaireInput;
  workerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationChangeResolveReportUserArgs = {
  input: ChangeResolveReportUserInput;
};


export type MutationChangeSalaryPaymentArgs = {
  input: ChangeSalaryPaymentInput;
};


export type MutationChangeScheduleArgs = {
  input: ChangeScheduleInput;
};


export type MutationChangeShiftArrestedPaymentArgs = {
  input: ChangeShiftArrestedPaymentInput;
};


export type MutationChangeShiftModerationArgs = {
  moderation: ChangeModerationInput;
};


export type MutationChangeShiftSalaryPaymentArgs = {
  input: ChangeShiftSalaryPaymentInput;
};


export type MutationChangeShiftStageArgs = {
  input: ChangeShiftStageInput;
};


export type MutationChangeStorySlideTypeArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationChangeUserInfoMainArgs = {
  input: ChangeUserInfoMainInput;
};


export type MutationChangeUserPasswordArgs = {
  password: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChangeUserRoleArgs = {
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationChangeUserStatusArgs = {
  input: UserStatusInput;
};


export type MutationChangeVacancyStatusArgs = {
  id: Scalars['String']['input'];
};


export type MutationCreateAndGetMarkArgs = {
  input: CreateMarkInput;
};


export type MutationCreateArrestedPaymentArgs = {
  input: CreateArrestedPaymentInput;
};


export type MutationCreateCasingArgs = {
  input: CasingCardInput;
};


export type MutationCreateCasingsInBatchArgs = {
  input: BatchCasingCardInput;
};


export type MutationCreateCityArgs = {
  input: CreateCityInput;
};


export type MutationCreateContactPhoneArgs = {
  phone: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateDailyReportArgs = {
  input: CreateDailyReportInput;
};


export type MutationCreateDraftReferralProgramArgs = {
  input: CreateDraftReferralProgramInput;
};


export type MutationCreateFacilityArgs = {
  input: FacilityCardInput;
};


export type MutationCreateFacilityGroupArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateHrmsProfessionArgs = {
  input: CreateHrmsProfessionInput;
};


export type MutationCreateLeadsReportArgs = {
  input: LeadListInput;
};


export type MutationCreateManualAccuralByPeriodArgs = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  facilityId: Scalars['String']['input'];
};


export type MutationCreateManyReferralProgramsArgs = {
  input: CreateManyReferralProgramsInput;
};


export type MutationCreateModerationReportArgs = {
  input: CreateModerationReportInput;
};


export type MutationCreateNewObjectArgs = {
  input: CreateNewObjectInput;
};


export type MutationCreateNewObjectPromotionArgs = {
  input: CreateNewObjectPromotionInput;
};


export type MutationCreateNewTemporaryShiftArgs = {
  input: CreateTemporaryShiftInput;
};


export type MutationCreateNewWorkPostArgs = {
  input: CreateNewWorkPostInput;
};


export type MutationCreateNotificationArgs = {
  input: CreateNotificationInput;
};


export type MutationCreateNotifyLetterArgs = {
  input?: InputMaybe<CreateNotifyLetterInput>;
};


export type MutationCreateObjectProfessionArgs = {
  input: CreateObjectProfessionInput;
};


export type MutationCreateObjectVacancyArgs = {
  input: CreateObjectVacancyInput;
};


export type MutationCreateOrUpdateUserRequisiteArgs = {
  input: RequisiteInput;
};


export type MutationCreatePartArgs = {
  input: CreatePartInput;
};


export type MutationCreatePollsReportArgs = {
  input: CreatePollsReportInput;
};


export type MutationCreatePositionArgs = {
  input: PositionCardInput;
};


export type MutationCreateReportEverythingIsPossibleBonusArgs = {
  startOfMonth: Scalars['String']['input'];
};


export type MutationCreateSalaryPaymentArgs = {
  input: CreateSalaryPaymentInput;
};


export type MutationCreateShiftArgs = {
  input: CreateShiftInput;
};


export type MutationCreateShiftArrestedPaymentArgs = {
  input: CreateShiftArrestedPaymentInput;
};


export type MutationCreateShiftCommentArgs = {
  input: CreateShiftCommentInput;
};


export type MutationCreateShiftInModerationArgs = {
  moderation: CreateModerationInput;
  shift: SingleShiftInput;
};


export type MutationCreateShiftMarkArgs = {
  input: CreateShiftMarkInput;
};


export type MutationCreateShiftPenaltyArgs = {
  input: CreateShiftPenaltyInput;
};


export type MutationCreateShiftSalaryPaymentArgs = {
  input: CreateShiftSalaryPaymentInput;
};


export type MutationCreateStoryArgs = {
  input?: InputMaybe<CreateDraftStoryInput>;
};


export type MutationCreateStorySlideByTypeArgs = {
  id: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateTimesheetByMonthAndFacilityArgs = {
  input: CreateTimesheetByMonthAndFacilityInput;
};


export type MutationCreateTimesheetByMonthAndFacilityGroupArgs = {
  input: CreateTimesheetByMonthAndFacilityGroupInput;
};


export type MutationCreateUserByPersonalInfoArgs = {
  input: CreateUserByPersonalInfoMainInput;
};


export type MutationCreateUserErpArgs = {
  input: CreateUserErpInput;
};


export type MutationCreateUserGradeArgs = {
  input: CreateUserGradeInput;
};


export type MutationCreateUserRequisiteArgs = {
  input: RequisiteInput;
};


export type MutationCreateUserReviewArgs = {
  input: CreateUserReviewInput;
};


export type MutationCreateVacancyArgs = {
  input: VacancyInput;
};


export type MutationCreateVacancyInBatchArgs = {
  input: BatchVacancyInput;
};


export type MutationCreateWorkPostArgs = {
  facilityId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
  recountProbation: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateZayavkaArgs = {
  input: ZayavkaCardInput;
};


export type MutationCreateZayavkaScheduleArgs = {
  input: ZayavkaScheduleInput;
};


export type MutationCreateZayavkaShiftByClientArgs = {
  input: ZayavkaShiftByClientInput;
  zayavkaScheduleId: Scalars['String']['input'];
};


export type MutationCron_DashboardStatisticArgs = {
  input: CronDashboardStatisticInput;
};


export type MutationDeclineCancelZayavkaByDirectorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeclineChangesByDirectorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeclineChangesBySupervisorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeclineRequestShiftsSuggestionsArgs = {
  input: DeclineRequestShiftSuggestionsInput;
};


export type MutationDeclineZayavkaByDirectorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeclineZayavkaBySupervisorArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAllUserShiftsArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteArrestedPaymentArgs = {
  input: DeleteArrestedPaymentInput;
};


export type MutationDeleteContactPhoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteManualAccuralItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteMeArgs = {
  input: DeleteMeInput;
};


export type MutationDeleteNotifyLetterArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteObjectProfessionArgs = {
  input: DeleteObjectProfessionInput;
};


export type MutationDeleteObjectPromotionArgs = {
  input: DeleteObjectPromotionInput;
};


export type MutationDeleteReferralProgramArgs = {
  input: DeleteReferralProgramInput;
};


export type MutationDeleteSalaryPaymentArgs = {
  input: DeleteSalaryPaymentInput;
};


export type MutationDeleteShiftArrestedPaymentArgs = {
  input: DeleteShiftArrestedPaymentInput;
};


export type MutationDeleteShiftSalaryPaymentArgs = {
  input: DeleteShiftSalaryPaymentInput;
};


export type MutationDeleteStoryAndFilesArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStoryIconArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStorySlideArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteWorkerFromZayavkaScheduleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteWorkerFromZayavkaShiftArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteZayavkaScheduleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteZayavkaShiftByClientArgs = {
  id: Scalars['String']['input'];
};


export type MutationDownloadModerationReportArgs = {
  id: Scalars['String']['input'];
};


export type MutationEditCityArgs = {
  input: EditCityInput;
};


export type MutationEditHrmsProfessionArgs = {
  input: EditHrmsProfessionInput;
};


export type MutationEditObjectArgs = {
  input: EditObjectInput;
};


export type MutationEditObjectProfessionArgs = {
  input: EditObjectProfessionInput;
};


export type MutationEditObjectPromotionArgs = {
  input: EditObjectPromotionInput;
};


export type MutationEditObjectVacancyArgs = {
  input: EditObjectVacancyInput;
};


export type MutationEditReferralProgramArgs = {
  input: EditReferralProgramInput;
};


export type MutationEditScheduleArgs = {
  input: ChangeScheduleInput;
};


export type MutationEditShiftArgs = {
  input: EditShiftInput;
};


export type MutationEmptyQueueByMessageTypeArgs = {
  input: EmptyQueueInput;
};


export type MutationFacilityGroupUploadImageArgs = {
  id: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationFakeCodeArgs = {
  phone: Scalars['String']['input'];
};


export type MutationFinishResolveReportUserArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationGetAuthOptionArgs = {
  device?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};


export type MutationHideScheduleArgs = {
  id: Scalars['String']['input'];
};


export type MutationHideShiftArgs = {
  id: Scalars['String']['input'];
};


export type MutationInitLoginMobileArgs = {
  input: InitLoginMobileInput;
};


export type MutationInitRegisterUserArgs = {
  input: InitRegisterUserInput;
};


export type MutationLockWorkSheetPeriodArgs = {
  input: LockWorkSheetPeriodInput;
};


export type MutationLoginArgs = {
  data: LoginInput;
};


export type MutationLoginByCodeArgs = {
  input: LoginTestInput;
};


export type MutationLoginWebArgs = {
  input: LoginWebInput;
};


export type MutationMarkAsNewNotificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationMoveProbationPeriodArgs = {
  input: MoveProbationPeriodInput;
};


export type MutationMoveStorySlideArgs = {
  slideIdOne: Scalars['String']['input'];
  slideIdTwo: Scalars['String']['input'];
};


export type MutationMoveZayavkaToDirectorArgs = {
  id: Scalars['String']['input'];
};


export type MutationPlanCasingRateArgs = {
  input: PlanCasingRateInput;
};


export type MutationPlanObjectProfessionRateArgs = {
  input: PlanObjectProfessionRateInput;
};


export type MutationReadNotificationArgs = {
  id: Scalars['String']['input'];
};


export type MutationReadShiftCommentsArgs = {
  input: ReadShiftCommentsInput;
};


export type MutationRefreshTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRefuseScheduleArgs = {
  id: Scalars['String']['input'];
};


export type MutationRefuseShiftArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCasingArgs = {
  facilityId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
};


export type MutationRemoveCityArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveDirectorFromFacilityGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveFacilityPenaltyArgs = {
  facilityId: Scalars['String']['input'];
};


export type MutationRemoveForemanFromFacilityArgs = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveJobsFromPushingQueueArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveManagerFromFacilityArgs = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveManagerFromFacilityGroupArgs = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemovePhotoInCasingGalleryArgs = {
  photoIds: Array<Scalars['String']['input']>;
};


export type MutationRemovePhotoInFacilityGalleryArgs = {
  photoIds: Array<Scalars['String']['input']>;
};


export type MutationRemovePhotoInObjectPhotoGalleryArgs = {
  input: RemovePhotoOnObjectPhotoGalleryInput;
};


export type MutationRemovePhotoInObjectProfessionPhotoGalleryArgs = {
  input: RemovePhotoOnObjectProfessionPhotoGalleryInput;
};


export type MutationRemovePositionArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveResponsibleFromTheObjectArgs = {
  input: RemoveResponsibleFromTheObjectInput;
};


export type MutationRemoveStatusFreeRequestShiftArgs = {
  input: RemoveStatusFreeRequestShiftInput;
};


export type MutationRemoveSupervisorFromFacilityArgs = {
  facilityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationRemoveUserDocumentArgs = {
  type: Scalars['String']['input'];
  workerId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveWorkPostArgs = {
  facilityId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationResetToDefaultObjectPromotionArgs = {
  input: ResetToDefaultObjectPromotionInput;
};


export type MutationRespondArgs = {
  data: Scalars['String']['input'];
};


export type MutationRestoreWorkerPositionArgs = {
  input: RestoreWorkerPositionInput;
};


export type MutationSaveUserQuestionnaireArgs = {
  input: QuestionnaireInput;
};


export type MutationSendChangesToDirectorArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendChangesToSupervisorArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendDownloadSmsArgs = {
  phone: Scalars['String']['input'];
};


export type MutationSendFreeShiftByRequestShiftIdArgs = {
  input: SendFreeShiftByRequestShiftIdInput;
};


export type MutationSendFreeShiftsByRequestIdsArgs = {
  input: SendFreeShiftsByRequestIdsInput;
};


export type MutationSendFreeShiftsByRequestScheduleIdArgs = {
  input: SendFreeShiftsByRequestScheduleIdInput;
};


export type MutationSendManualAccuralsArgs = {
  input: ManualAccrualSenderInput;
};


export type MutationSendUserDataToNaimixArgs = {
  input: SendUserDataToNaimixInput;
};


export type MutationSetContactPhoneToMainArgs = {
  phoneId: Scalars['String']['input'];
};


export type MutationSetEverythingIsPossibleBonusArgs = {
  input: EverythingIsPossibleBonusInput;
};


export type MutationSetModerationReportStatusArgs = {
  input: SetStatusModerationInput;
};


export type MutationSetReferralProgramPaymentDatetimeArgs = {
  input: SetReferralProgramPaymentDatetimeInput;
};


export type MutationSetReviewStatusArgs = {
  input: DocumentReviewInput;
};


export type MutationSetScheduleStatusArgs = {
  scheduleInput: UserScheduleStatusInput;
};


export type MutationSetSettingArgs = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationSetSettlementForUserArgs = {
  input: SetCityForUserInput;
};


export type MutationSetStoryPublicConditionArgs = {
  input: StoryPublicConditionInput;
};


export type MutationSetToUserWorkCityArgs = {
  cityId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationSetUserBrowserTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationSetUserTokenArgs = {
  input: SetUserTokenInput;
};


export type MutationSetWaitingMedicalOnFacilityArgs = {
  facilityId: Scalars['String']['input'];
  isMedInvoiceAllowed: Scalars['Boolean']['input'];
  numberDaysWaitMedical: Scalars['Int']['input'];
};


export type MutationShareResponseArgs = {
  bannerId?: InputMaybe<Scalars['String']['input']>;
  shareData: Scalars['String']['input'];
};


export type MutationSignEditUserPaymentInfoInNaimixArgs = {
  input: SignEditUserPaymentInfoInNaimixInput;
};


export type MutationSignLoginMobileArgs = {
  input: SignLoginMobileInput;
};


export type MutationSignRegisterUserArgs = {
  input: SignRegisterUserInput;
};


export type MutationStorySlideReplaceImageArgs = {
  image: Scalars['Upload']['input'];
  slideId: Scalars['String']['input'];
};


export type MutationStorySlideUploadImageArgs = {
  id: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationStoryUploadIconArgs = {
  id: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationSubscribeArgs = {
  data: Scalars['String']['input'];
};


export type MutationToPublishNotifyLetterArgs = {
  id: Scalars['String']['input'];
};


export type MutationToPublishStoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationToRemoveNotifyLetterArgs = {
  id: Scalars['String']['input'];
};


export type MutationToRemovePublishStoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationUnassignUserOnWorkPostArgs = {
  input: UnassignUserOnWorkPostInput;
};


export type MutationUnassignWorkerFromFacilityArgs = {
  input: UnassignWorkerFromFacilityInput;
};


export type MutationUnassignWorkerFromFacilityGroupArgs = {
  input: UnassignWorkerFromFacilityGroupInput;
};


export type MutationUnassignWorkerFromPositionArgs = {
  input: UnassignWorkerFromPositionInput;
};


export type MutationUpdateCasingArgs = {
  input: CasingCardInput;
};


export type MutationUpdateCityArgs = {
  input: CityInput;
};


export type MutationUpdateFacilitiesActivityArgs = {
  input: UpdateFacilitiesActivityInput;
};


export type MutationUpdateFacilitiesLegalEntitiesArgs = {
  input: UpdateFacilitiesLegalEntitiesInput;
};


export type MutationUpdateFacilityArgs = {
  input: FacilityCardInput;
};


export type MutationUpdateFacilityGroupArgs = {
  input: FacilityGroupCardInput;
};


export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


export type MutationUpdateNotifyLetterArgs = {
  input: UpdateNotifyLetterInput;
};


export type MutationUpdatePositionArgs = {
  input: PositionCardInput;
};


export type MutationUpdateShiftModerationArgs = {
  input: UpdateShiftModerationInput;
};


export type MutationUpdateStoryArgs = {
  input: UpdateStoryInput;
};


export type MutationUpdateStorySlideArgs = {
  input: UpdateStorySlideInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateUserNaimixWorkStatusArgs = {
  input: UpdateUserNaimixWorkStatusInput;
};


export type MutationUpdateUserNameAndCitizenshipArgs = {
  input: UpdateUserNameAndCitizenshipInput;
};


export type MutationUpdateUserRequisiteArgs = {
  input: RequisiteInput;
};


export type MutationUpdateUserVersionArgs = {
  input: UpdateUserVersionInput;
};


export type MutationUpdateVacancyArgs = {
  id: Scalars['String']['input'];
  input: VacancyInput;
};


export type MutationUpdateZayavkaArgs = {
  id: Scalars['String']['input'];
  input: ZayavkaCardInput;
};


export type MutationUpdateZayavkaScheduleArgs = {
  id: Scalars['String']['input'];
  input: ZayavkaScheduleInput;
};


export type MutationUpdateZayavkaShiftByClientArgs = {
  id: Scalars['String']['input'];
  input: ZayavkaShiftByClientInput;
};


export type MutationUploadCropImageArgs = {
  cropData: CropDataInput;
  fileId: Scalars['String']['input'];
};


export type MutationUploadPhotoInCasingGalleryArgs = {
  casingId: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUploadPhotoInFacilityGalleryArgs = {
  facilityId: Scalars['String']['input'];
  image: Scalars['Upload']['input'];
};


export type MutationUploadPhotoInObjectPhotoGalleryArgs = {
  input: UploadPhotoInObjectPhotoGalleryInput;
};


export type MutationUploadPhotoInObjectProfessionPhotoGalleryArgs = {
  input: UploadPhotoInObjectProfessionPhotoGalleryInput;
};


export type MutationUploadShiftsExcelArgs = {
  file: Scalars['Upload']['input'];
  reportId: Scalars['String']['input'];
  sourceType: ExcelVariant;
};


export type MutationUploadUserDocumentArgs = {
  document: Scalars['Upload']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUploadUserFileScanForNaimixArgs = {
  file: Scalars['Upload']['input'];
  scanType: ScanTypeNaimixEnum;
};


export type MutationVerifyContactPhoneArgs = {
  code: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};


export type MutationViewStoryArgs = {
  id: Scalars['String']['input'];
};


export type MutationWriteMobileLogArgs = {
  input: UserActivityLogInput;
};

export type MyFriendsOutput = {
  __typename?: 'MyFriendsOutput';
  /** Список приглашенных рефералов */
  leads: Array<LeadOutput>;
  /** Прогресс бонуса "Очко" */
  ochkoProgress: OchkoProgressOutput;
};

export type MyPersonalInfoPassportInput = {
  /** Дата рождения */
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Кем выдан паспорт */
  passportIssuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи паспорта */
  passportIssuedDate?: InputMaybe<Scalars['String']['input']>;
  /** Код подразделения, выдавшего паспорт */
  passportIssuerCode?: InputMaybe<Scalars['String']['input']>;
  /** Номер паспорта */
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  /** Адрес регистрации */
  passportRegistrationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Серия паспорта */
  passportSeries?: InputMaybe<Scalars['String']['input']>;
  /** Пол */
  sex?: InputMaybe<Sex>;
};

export type MyPersonalInfoPassportOutput = {
  __typename?: 'MyPersonalInfoPassportOutput';
  /** Дата рождения */
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Кем выдан паспорт */
  passportIssuedBy: Scalars['String']['output'];
  /** Дата выдачи паспорта */
  passportIssuedDate?: Maybe<Scalars['String']['output']>;
  /** Код подразделения, выдавшего паспорт */
  passportIssuerCode?: Maybe<Scalars['String']['output']>;
  /** Номер паспорта */
  passportNumber: Scalars['String']['output'];
  /** Адрес регистрации */
  passportRegistrationAddress?: Maybe<Scalars['String']['output']>;
  /** Серия паспорта */
  passportSeries: Scalars['String']['output'];
  /** Пол */
  sex?: Maybe<Sex>;
  /** Дата обновления блока паспортные данные */
  updatedAtPassport?: Maybe<Scalars['Date']['output']>;
};

export type NaimixLegalEntityEntity = {
  __typename?: 'NaimixLegalEntityEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type NaimixObjectOutput = {
  __typename?: 'NaimixObjectOutput';
  /** Идентификатор объекта в Наймикс */
  naimixObjectId?: Maybe<Scalars['String']['output']>;
  /** Название объекта в Наймикс */
  naimixObjectName?: Maybe<Scalars['String']['output']>;
};

/** Статус проверки в Наймикс */
export enum NaimixRegistrationCheckStatusEnum {
  /** Прошёл проверку */
  Confirmed = 'CONFIRMED',
  /** Не проверялось */
  NotChecked = 'NOT_CHECKED',
  /** Не прошёл проверку */
  NotConfirmed = 'NOT_CONFIRMED'
}

/** Статус проверки персональных данных в Наймикс */
export enum NaimixRegistrationPersonalInfoStatusEnum {
  /** Персональная информация не отправлялась */
  PersonalDataNotSent = 'PERSONAL_DATA_NOT_SENT',
  /** Персональная информация не прошла проверку */
  PersonalDataNotVerified = 'PERSONAL_DATA_NOT_VERIFIED',
  /** Персональная информация отправлена */
  PersonalDataSent = 'PERSONAL_DATA_SENT',
  /** Персональная информация успешно прошла проверку */
  PersonalDataVerified = 'PERSONAL_DATA_VERIFIED'
}

export type NewReferralProgramEntity = {
  __typename?: 'NewReferralProgramEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Дата и время окончания */
  endDatetime?: Maybe<Scalars['Date']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Название */
  name?: Maybe<Scalars['String']['output']>;
  /** Пуши реферальной программы */
  notifyLetters: Array<NotifyLetter>;
  /** Количество хороших смен для выполнения */
  numberOfGoodShifts?: Maybe<Scalars['Int']['output']>;
  /** Объект */
  object?: Maybe<ObjectEntity>;
  /** Сумма выплаты реферреру */
  rewardForTheReferrer?: Maybe<Scalars['Float']['output']>;
  /** Дата и время начала */
  startDatetime?: Maybe<Scalars['Date']['output']>;
  /** Статус */
  status: ReferralProgramStatusEnum;
  /** Истории реферальной программы */
  stories: Array<Story>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  appType: AppType;
  body: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  route: Scalars['String']['output'];
  routeId: Scalars['String']['output'];
  success: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

export type NotificationsCountersOutput = {
  __typename?: 'NotificationsCountersOutput';
  /** Количество прочитанных сообщений */
  isReadCount: Scalars['Int']['output'];
  /** Количество новых сообщений */
  newCount: Scalars['Int']['output'];
};

export type NotifyLetter = {
  __typename?: 'NotifyLetter';
  /** Текст уведомления */
  body?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Название уведомления */
  name: Scalars['String']['output'];
  /** Условия публикации */
  publicCondition?: Maybe<PublicCondition>;
  /** Реферальная программа, к которой привязано пуш уведомление */
  referralProgram?: Maybe<NewReferralProgramEntity>;
  /** Ссылка для перенаправления */
  route?: Maybe<PushRoute>;
  /** Статус пуш уведомления */
  status: NotifyLetterStatus;
  /** Заголовок уведомления */
  title: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Notify Letter Status */
export enum NotifyLetterStatus {
  New = 'NEW',
  Pending = 'PENDING',
  Published = 'PUBLISHED',
  Removed = 'REMOVED'
}

/** Notify Letter List Sortiing */
export enum NotifyLettersListSorting {
  PublishFrom = 'publishFrom',
  UpdatedAt = 'updatedAt'
}

/** Параметры запроса постраничного списка push-уведомлений. */
export type NotifyLettersPaginatedInput = {
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Сортировка (по умолчанию "updatedAt") */
  sortBy?: InputMaybe<NotifyLettersListSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Фильтрация по статусу push-уведомления */
  status?: InputMaybe<NotifyLetterStatus>;
};

/** Постраничный вывод push-уведомлений */
export type NotifyLettersPaginatedList = {
  __typename?: 'NotifyLettersPaginatedList';
  /** Всего элементов' */
  count: Scalars['Int']['output'];
  /** Список push-уведомлений */
  notifyLetters: Array<NotifyLetter>;
  /** Количество страниц */
  pages: Scalars['Int']['output'];
};

export type ObjectEntity = {
  __typename?: 'ObjectEntity';
  /** Дочерние объекты */
  children?: Maybe<Array<ObjectEntity>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Идентификатор в erp */
  hrmsId?: Maybe<Scalars['Int']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Этот объект активен? */
  isActive: Scalars['Boolean']['output'];
  /** Название объекта */
  name: Scalars['String']['output'];
  /** Родительский объект */
  parent?: Maybe<ObjectEntity>;
  /** Галерея фотографий объекта */
  photoGallery?: Maybe<Array<ObjectPhotoGalleryEntity>>;
  /** Бонусные программы объекта */
  promotions?: Maybe<Array<ObjectPromotionEntity>>;
  /** Ответственные на объекте */
  responsibleUsers?: Maybe<Array<User>>;
  /** Настройки объекта */
  settings?: Maybe<ObjectSettingEntity>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Вакансии объекта */
  vacancies?: Maybe<ObjectVacancyEntity>;
  /** Прикреплённые к объекту пользователи */
  workPosts?: Maybe<Array<WorkPostEntity>>;
};

export type ObjectPhotoGalleryEntity = {
  __typename?: 'ObjectPhotoGalleryEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  photo: File;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ObjectProfessionEntity = {
  __typename?: 'ObjectProfessionEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Обучение */
  hasEducation: Scalars['Boolean']['output'];
  /** Есть пробный период? */
  hasProbation: Scalars['Boolean']['output'];
  hrmsProfession: HrmsProfessionEntity;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Медицинская книжка */
  isMedBookRequired: Scalars['Boolean']['output'];
  /** Самозанятый? */
  isSelfEmployed: Scalars['Boolean']['output'];
  object: ObjectEntity;
  /** Тип периода */
  payoutType: PayoutTypeEnum;
  /** Единица измерения типа периода */
  payoutTypeUnit: PayoutTypeUnitEnum;
  /** Галерея фотографий профессии объекта */
  photoGallery?: Maybe<Array<ObjectProfessionPhotoGalleryEntity>>;
  /** Тип вознаграждения пробного периода */
  probationPayoutType?: Maybe<ProbationPayoutTypeEnum>;
  /** Количество типа периода пробного периода */
  probationPayoutValue?: Maybe<Scalars['Int']['output']>;
  /** Тип периода пробного периода */
  probationPeriodType?: Maybe<ProbationPeriodTypeEnum>;
  /** История ставок */
  rates: Array<ObjectProfessionRateEntity>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ObjectProfessionPhotoGalleryEntity = {
  __typename?: 'ObjectProfessionPhotoGalleryEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  photo: File;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ObjectProfessionRateEntity = {
  __typename?: 'ObjectProfessionRateEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Это пробный период? */
  isProbation: Scalars['Boolean']['output'];
  /** Ставка */
  rate: Scalars['Float']['output'];
  /** Ставка */
  selfEmployedRate?: Maybe<Scalars['Float']['output']>;
  /** Дата начала действия ставки */
  startDatetime: Scalars['Date']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Бонусная программа */
export type ObjectPromotionEntity = {
  __typename?: 'ObjectPromotionEntity';
  /** Количество плохих смен для аннулирования */
  badShiftCount: Scalars['Int']['output'];
  /** Дочерние бонусные программы */
  children?: Maybe<Array<ObjectPromotionEntity>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время окончания бонусной программы */
  endDatetime?: Maybe<Scalars['Date']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Название бонусной программы */
  name: Scalars['String']['output'];
  /** Родительская бонусная программа */
  parent?: Maybe<ObjectPromotionEntity>;
  /** Тип повтора бонусной программы (условия запуска бонусной программы с нуля) */
  repeatCondition: ObjectPromotionRepeatConditionEnum;
  /** Количество смен для выполнения условий получения бонуса */
  requirementShiftCount: Scalars['Int']['output'];
  /** Сумма вознаграждения */
  rewardSum: Scalars['Int']['output'];
  /** Тип вознаграждения */
  rewardType: ObjectPromotionRewardTypeEnum;
  /** Дата и время начала бонусной программы */
  startDatetime: Scalars['Date']['output'];
  /** Статус бонусной программы */
  status: ObjectPromotionStatusEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Повтор (условия запуска бонусной программы с нуля) */
export enum ObjectPromotionRepeatConditionEnum {
  /** Раз в месяц */
  OnceAMonth = 'ONCE_A_MONTH',
  /** Раз в 2 месяца */
  OnceEvery_2Month = 'ONCE_EVERY_2_MONTH',
  /** Раз в 3 месяца */
  OnceEvery_3Month = 'ONCE_EVERY_3_MONTH',
  /** Раз в полгода */
  OnceEvery_6Month = 'ONCE_EVERY_6_MONTH',
  /** Раз в год */
  OnceEvery_12Month = 'ONCE_EVERY_12_MONTH',
  /** Однократно */
  OneTime = 'ONE_TIME'
}

/** Тип вознаграждения в бонусной программе */
export enum ObjectPromotionRewardTypeEnum {
  /** Надбавка к хорошим сменам */
  BonusForGoodShifts = 'BONUS_FOR_GOOD_SHIFTS',
  /** Единоразовая выплата к следующей хорошей смене */
  SinglePayment = 'SINGLE_PAYMENT',
  /** Надбавка к ставке */
  SurchargeToTheRate = 'SURCHARGE_TO_THE_RATE'
}

/** Статус бонусной программы */
export enum ObjectPromotionStatusEnum {
  /** Завершено */
  Completed = 'COMPLETED',
  /** Удалено */
  Deleted = 'DELETED',
  /** Опубликовано */
  Published = 'PUBLISHED',
  /** Ожидает отправки */
  WaitingToBeSent = 'WAITING_TO_BE_SENT'
}

export type ObjectSettingEntity = {
  __typename?: 'ObjectSettingEntity';
  /** Адрес объекта */
  address?: Maybe<AddressEntity>;
  /** Аватар объекта */
  avatar?: Maybe<File>;
  /** Сумма удержания при отмене смены, в рублях */
  cancelShiftHoldAmount?: Maybe<Scalars['Int']['output']>;
  /** Порог срабатывания при отмене смены, в часах */
  cancelShiftHoldThresholdHours?: Maybe<Scalars['Int']['output']>;
  /** Погрешность при чекине */
  checkInMeasurement: Scalars['Int']['output'];
  /** Погрешность при чекауте */
  checkOutMeasurement: Scalars['Int']['output'];
  /** Город объекта */
  city?: Maybe<CityEntity>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Разрешить наследоваться от этого объекта? */
  isAllowInheritanceFromThisObject: Scalars['Boolean']['output'];
  /** Удержание при отмене смены включено? */
  isCancelShiftHoldEnabled: Scalars['Boolean']['output'];
  /** По умолчанию разрешать исполнителям работу без Наймикс? */
  isDefaultAllowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Отображать исполнителям бонусы? */
  isDisplayBonusesWorkers: Scalars['Boolean']['output'];
  /** Отображать доход до модерации */
  isDisplayIncomeBeforeModeration: Scalars['Boolean']['output'];
  /** Отображать исполнителям выплаты? */
  isDisplayPaymentsWorkers: Scalars['Boolean']['output'];
  /** Ожидание мед. книжки включено? */
  isMedicalBookWaitingEnabled: Scalars['Boolean']['output'];
  /** Отображать табель в этом объекте? */
  isShowWorkSheetInThisObject: Scalars['Boolean']['output'];
  /** Сумма удержания при отмене смены, в рублях */
  medicalCertificateAllowedDays?: Maybe<Scalars['Int']['output']>;
  /** Станции метро объекта */
  metroStations?: Maybe<Array<MetroStationEntity>>;
  /** Юридическое лицо в Наймикс объекта */
  naimixLegalEntity?: Maybe<NaimixLegalEntityEntity>;
  /** Погрешность при чекине/чекауте в метрах */
  radius?: Maybe<Scalars['Int']['output']>;
  /** Часовой пояс объекта */
  timeZone?: Maybe<Scalars['Int']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ObjectVacancyEntity = {
  __typename?: 'ObjectVacancyEntity';
  /** Максимальный возраст */
  ageMax?: Maybe<Scalars['Int']['output']>;
  /** Минимальный возраст */
  ageMin?: Maybe<Scalars['Int']['output']>;
  /** Средняя стоимость смены */
  averageRate?: Maybe<Scalars['Float']['output']>;
  /** Гражданства */
  citizenship: Array<CountryEntity>;
  /** Обложка вакансии */
  cover?: Maybe<File>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Отдел или секция */
  departmentOrSection?: Maybe<Scalars['String']['output']>;
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** ID группы в ERP */
  erpGroupId?: Maybe<Scalars['Int']['output']>;
  /** ID источника в ERP */
  erpSourceId?: Maybe<Scalars['Int']['output']>;
  /** Пол */
  gender?: Maybe<GenderEnum>;
  /** Есть обучение? */
  hasEducation: Scalars['Boolean']['output'];
  /** Есть пробный период? */
  hasProbation: Scalars['Boolean']['output'];
  /** Есть спец. одежда? */
  hasWorkwear: Scalars['Boolean']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Это активная вакансия? */
  isActive: Scalars['Boolean']['output'];
  /** Публиковать стоимость смены? */
  isPublishShiftRate: Scalars['Boolean']['output'];
  /** Обед */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Название */
  name: Scalars['String']['output'];
  /** Примечание */
  note?: Maybe<Scalars['String']['output']>;
  /** Примечание к документам */
  noteToDocuments?: Maybe<Scalars['String']['output']>;
  /** Объект вакансии */
  object: ObjectEntity;
  objectProfession: ObjectProfessionEntity;
  /** Частота выплат */
  payoutFrequency: PayoutFrequencyEnum;
  /** Тип оплаты */
  payoutType: PayoutTypeEnum;
  /** Единица измерения типа оплаты */
  payoutTypeUnit: PayoutTypeUnitEnum;
  /** Продолжительность пробного периода */
  probationValue?: Maybe<Scalars['Int']['output']>;
  /** Стоимость смены до */
  rangeRateMax?: Maybe<Scalars['Float']['output']>;
  /** Стоимость смены от */
  rangeRateMin?: Maybe<Scalars['Float']['output']>;
  /** Ставка */
  rate: Scalars['Float']['output'];
  /** Тип отображения стоимости смены */
  rateType?: Maybe<RateTypeEnum>;
  /** Обязательные документы */
  requiredDocuments: Array<RequiredDocumentEnum>;
  /** Окончание смены */
  shiftEndTime: Scalars['String']['output'];
  /** Начало смены */
  shiftStartTime: Scalars['String']['output'];
  /** Транспорт */
  transport?: Maybe<Scalars['String']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type OchkoProgressOutput = {
  __typename?: 'OchkoProgressOutput';
  /** Текущее количество рефералов, достигших условий бонуса "Приведи друга" */
  currentReferrals: Scalars['Int']['output'];
  /** Текущее количество смен рефералов достигших условий бонуса "Приведи друга" */
  currentShifts?: Maybe<Scalars['Int']['output']>;
  /** Сумма бонуса */
  sum: Scalars['Float']['output'];
  /** Необходимое количество рефералов, достигших условий бонуса "Приведи друга", для достижения условий бонуса "Очко" */
  targetReferrals: Scalars['Int']['output'];
  /** Необходимое количество смен рефералов для достижения бонуса "Приведи друга" */
  targetShifts: Scalars['Int']['output'];
};

export type OchkoReferrerOutput = {
  __typename?: 'OchkoReferrerOutput';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** ID реферерра */
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  leads: Array<LeadOutput>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  progress: OchkoProgressOutput;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

/** Параметры запроса на постраничный вывод реферреров с прогрессом по бонусу "21 друг" */
export type OchkoReferrersListInput = {
  /** Фильтр по минимальной дате выполнения бонуса */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Фильтр по максимальной дате выполнения бонуса */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** ID группы объектов */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** ID объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Роль реферера */
  role?: InputMaybe<Role>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Сортировать по полю */
  sortBy?: InputMaybe<OchkoReferrersSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
};

/** Ochko referrers sorting */
export enum OchkoReferrersSorting {
  Lastname = 'lastname',
  OchkoDate = 'ochkoDate'
}

/** Направление сортировки */
export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Направление сортировки */
export enum OrderDirectionEnum {
  /** По возрастанию */
  Asc = 'ASC',
  /** По убыванию */
  Desc = 'DESC'
}

export type PaginatedCasingsOutput = {
  __typename?: 'PaginatedCasingsOutput';
  /** Профессии на объекте */
  casings: Array<Casing>;
  /** Количество профессий */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
};

export type PaginatedClientUsers = {
  __typename?: 'PaginatedClientUsers';
  /** Количество страниц */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
  /** пользователи */
  users: Array<ClientUser>;
};

export type PaginatedFacilities = {
  __typename?: 'PaginatedFacilities';
  /** Количество страниц */
  count: Scalars['Int']['output'];
  /** объекты */
  facilities: Array<Facility>;
  /** Количество страниц */
  pages: Scalars['Int']['output'];
};

export type PaginatedLeadsModel = {
  __typename?: 'PaginatedLeadsModel';
  /** Количество лидов всего */
  count: Scalars['Int']['output'];
  /** Список Лидов */
  leads: Array<LeadOutput>;
  /** Количество страниц с лидами */
  pages: Scalars['Int']['output'];
};

/** Табели модерации смен по периодам с пагинацией */
export type PaginatedModerationReportModel = {
  __typename?: 'PaginatedModerationReportModel';
  /** Количество страниц */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
  /** Массив Табелей Модерации */
  reports: Array<ModerationReport>;
};

export type PaginatedNotifications = {
  __typename?: 'PaginatedNotifications';
  /** Всего уведомлений */
  count: Scalars['Int']['output'];
  /** Уведомления */
  notifications: Array<Notification>;
  /** Количество страниц */
  pages: Scalars['Int']['output'];
};

export type PaginatedNotificationsInput = {
  /** Фильтр только прочитанные / не прочитанные */
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  /** Сколько уведомлений пропустить */
  offset: Scalars['Int']['input'];
  /** Кол-во уведомлений на странице */
  size: Scalars['Int']['input'];
  /** Направление сортировки по дате создания */
  sortWay?: InputMaybe<SortingWay>;
};

export type PaginatedOchkoReferrersList = {
  __typename?: 'PaginatedOchkoReferrersList';
  /** Количество реферерров всего */
  count: Scalars['Int']['output'];
  /** Количество страниц с рефераррами */
  pages: Scalars['Int']['output'];
  /** Список реферерров */
  referrers: Array<OchkoReferrerOutput>;
};

export type PaginatedStory = {
  __typename?: 'PaginatedStory';
  /** Всего "Историй" */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
  /** Массив "Историй" */
  stories: Array<Story>;
};

export type PaginatedUsers = {
  __typename?: 'PaginatedUsers';
  /** Количество страниц */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
  /** пользователи */
  users: Array<User>;
};

export type PaginatedVacancies = {
  __typename?: 'PaginatedVacancies';
  /** Количество вакансий */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
  /** Вакансии */
  vacancies: Array<Vacancy>;
};

export type PaginatedZayavky = {
  __typename?: 'PaginatedZayavky';
  /** Количество объектов */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
  /** объекты */
  zayavky: Array<ZayavkaProgress>;
};

/** Тип паспорта */
export enum PassportTypeEnum {
  /** Внутренний паспорт */
  InternalPassport = 'INTERNAL_PASSPORT',
  /** Международный паспорт */
  InternationalPassport = 'INTERNATIONAL_PASSPORT'
}

/** Тип паспорта. Нужно указывать для гражданств: Беларусь, Казахстан, Киргизия */
export enum PassportTypeNaimixEnum {
  /** Внутренний паспорт */
  InternalPassport = 'INTERNAL_PASSPORT',
  /** Международный паспорт */
  InternationalPassport = 'INTERNATIONAL_PASSPORT'
}

export type Payment = {
  __typename?: 'Payment';
  /** Дата и время создания объекта */
  createdAt: Scalars['Date']['output'];
  date: Scalars['String']['output'];
  /** Уникальный идентификатор объекта */
  id: Scalars['ID']['output'];
  shiftsCount: Scalars['Int']['output'];
  sum: Scalars['Int']['output'];
  /** Дата и время обновления объекта */
  updatedAt: Scalars['Date']['output'];
};

/** Статус проверки платёжных данных в Наймикс */
export enum PaymentInfoEnum {
  Confirmed = 'CONFIRMED',
  NotChecked = 'NOT_CHECKED',
  NotConfirmed = 'NOT_CONFIRMED'
}

/** Частота выплат */
export enum PayoutFrequency {
  Monthly = 'MONTHLY',
  TwiceInMonth = 'TWICE_IN_MONTH',
  Weekly = 'WEEKLY'
}

/** Частота выплат */
export enum PayoutFrequencyEnum {
  /** Раз в месяц */
  Month = 'MONTH',
  /** Раз в две недели */
  TwoWeek = 'TWO_WEEK',
  /** Раз в неделю */
  Week = 'WEEK'
}

/** Тип выплаты за работу HOUR Часы, POINT Проценты, PIECE Штуки */
export enum PayoutType {
  Hourly = 'HOURLY',
  Piecework = 'PIECEWORK'
}

/** Тип вознаграждения */
export enum PayoutTypeEnum {
  /** Почасовой */
  Hourly = 'HOURLY',
  /** Сдельный */
  Piecework = 'PIECEWORK'
}

/** Единица измерения типа вознаграждения */
export enum PayoutTypeUnitEnum {
  /** Часы */
  Hour = 'HOUR',
  /** Процент */
  Percent = 'PERCENT',
  /** Штуки */
  Piece = 'PIECE'
}

export type Penalty = {
  __typename?: 'Penalty';
  /** Интервал до начала смены с которого срабатывает штраф в минутах */
  applyTimeInMinutes: Scalars['Int']['output'];
  /** Комментарий */
  comment?: Maybe<Scalars['String']['output']>;
  /** Стоимость штрафа (в руб.) */
  cost: Scalars['Float']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facility: Facility;
  /** Id объекта */
  facilityId?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Тип штрафа */
  type: PenaltyType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Тип штрафа */
export enum PenaltyType {
  ShiftRejected = 'SHIFT_REJECTED'
}

/** Тип периода */
export enum PeriodEnum {
  /** День */
  Day = 'DAY',
  /** Ночь */
  Night = 'NIGHT'
}

/** Period type */
export enum PeriodType {
  Custom = 'CUSTOM',
  Month = 'MONTH',
  TwoWeek = 'TWO_WEEK',
  Week = 'WEEK'
}

export type PersonalInfoMedInvoiceInput = {
  /** Ожидаемая дата выдачи медицинской книжки после получения справки */
  medicalExpectedReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Дата выдачи медицинской справки (о прохождении осмотра перед получением медицинской книжки) */
  medicalInvoiceIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Id работника */
  userId: Scalars['String']['input'];
};

export type PersonalInfoMedInvoiceOutput = {
  __typename?: 'PersonalInfoMedInvoiceOutput';
  /** Ожидаемая дата выдачи медицинской книжки после получения справки */
  medicalExpectedReceiptDate?: Maybe<Scalars['Date']['output']>;
  /** Дата выдачи медицинской справки (о прохождении осмотра перед получением медицинской книжки) */
  medicalInvoiceIssueDate?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока мед.книжка */
  updatedAtMedical?: Maybe<Scalars['Date']['output']>;
};

export type PersonalInfoMedicalInput = {
  /** Даты конца аттестации */
  medicalAttestationEnd?: InputMaybe<Scalars['DateTime']['input']>;
  /** Даты начала аттестации */
  medicalAttestationStart?: InputMaybe<Scalars['DateTime']['input']>;
  /** Ожидаемая дата выдачи медицинской книжки после получения справки */
  medicalExpectedReceiptDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Дата выдачи медицинской справки (о прохождении осмотра перед получением медицинской книжки) */
  medicalInvoiceIssueDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Номер мед.книжки */
  medicalNumber?: InputMaybe<Scalars['String']['input']>;
  /** Id работника */
  userId: Scalars['String']['input'];
};

export type PersonalInfoMedicalOutput = {
  __typename?: 'PersonalInfoMedicalOutput';
  /** Даты конца аттестации */
  medicalAttestationEnd?: Maybe<Scalars['DateTime']['output']>;
  /** Даты начала аттестации в массиве */
  medicalAttestationStart?: Maybe<Scalars['DateTime']['output']>;
  /** Ожидаемая дата выдачи медицинской книжки после получения справки */
  medicalExpectedReceiptDate?: Maybe<Scalars['Date']['output']>;
  /** Дата выдачи медицинской справки (о прохождении осмотра перед получением медицинской книжки) */
  medicalInvoiceIssueDate?: Maybe<Scalars['Date']['output']>;
  /** Номер мед.книжки */
  medicalNumber?: Maybe<Scalars['String']['output']>;
  /** Дата обновления блока мед.книжка */
  updatedAtMedical?: Maybe<Scalars['Date']['output']>;
};

export type PersonalInfoOutput = {
  __typename?: 'PersonalInfoOutput';
  /** Документы пользователя */
  documents: Array<UserDocumentEntity>;
  /** Периоды аттестации медкнижки */
  medicalAttestations: Array<MedicalAttestation>;
  /** Все заполняемые поля документов */
  requisite?: Maybe<Requisite>;
  /** Апрувы на документы пользователя */
  reviews: Array<DocumentReview>;
  /** ID пользователя */
  userId: Scalars['String']['output'];
};

export type PersonalInfoPassportInput = {
  /** Дата рождения */
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Место рождения */
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  /** Имя */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Фамилия */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** Кем выдан паспорт */
  passportIssuedBy?: InputMaybe<Scalars['String']['input']>;
  /** Дата выдачи паспорта */
  passportIssuedDate?: InputMaybe<Scalars['String']['input']>;
  /** Код подразделения, выдавшего паспорт */
  passportIssuerCode?: InputMaybe<Scalars['String']['input']>;
  /** Номер паспорта */
  passportNumber?: InputMaybe<Scalars['String']['input']>;
  /** Адрес регистрации */
  passportRegistrationAddress?: InputMaybe<Scalars['String']['input']>;
  /** Серия паспорта */
  passportSeries?: InputMaybe<Scalars['String']['input']>;
  /** Отчество */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  /** Пол */
  sex?: InputMaybe<Sex>;
  /** Id работника */
  userId: Scalars['String']['input'];
};

export type PersonalInfoPassportOutput = {
  __typename?: 'PersonalInfoPassportOutput';
  /** Дата рождения */
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Кем выдан паспорт */
  passportIssuedBy: Scalars['String']['output'];
  /** Дата выдачи паспорта */
  passportIssuedDate?: Maybe<Scalars['String']['output']>;
  /** Код подразделения, выдавшего паспорт */
  passportIssuerCode?: Maybe<Scalars['String']['output']>;
  /** Номер паспорта */
  passportNumber: Scalars['String']['output'];
  /** Адрес регистрации */
  passportRegistrationAddress?: Maybe<Scalars['String']['output']>;
  /** Серия паспорта */
  passportSeries: Scalars['String']['output'];
  /** Отчество */
  patronymic: Scalars['String']['output'];
  /** Пол */
  sex?: Maybe<Sex>;
  /** Дата обновления блока паспортные данные */
  updatedAtPassport?: Maybe<Scalars['Date']['output']>;
};

export type PersonalInfoPaymentInput = {
  /** Номер счёта */
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  /** Название банка */
  bankName?: InputMaybe<Scalars['String']['input']>;
  /** БИК */
  bik?: InputMaybe<Scalars['String']['input']>;
  /** Срок действия карты */
  cardExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  /** Имя держателя карты */
  cardName?: InputMaybe<Scalars['String']['input']>;
  /** Номер карты */
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  /** Номер корр.счёта */
  correspondentAccount?: InputMaybe<Scalars['String']['input']>;
  /** Email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Id работника */
  userId: Scalars['String']['input'];
};

export type PersonalInfoPaymentOutput = {
  __typename?: 'PersonalInfoPaymentOutput';
  /** Номер счёта */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Название банка */
  bankName?: Maybe<Scalars['String']['output']>;
  /** БИК */
  bik?: Maybe<Scalars['String']['output']>;
  /** Срок действия карты */
  cardExpiryDate?: Maybe<Scalars['Date']['output']>;
  /** Имя держателя карты */
  cardName?: Maybe<Scalars['String']['output']>;
  /** Номер карты */
  cardNumber: Scalars['String']['output'];
  /** Номер корр.счёта */
  correspondentAccount?: Maybe<Scalars['String']['output']>;
  /** Email */
  email?: Maybe<Scalars['String']['output']>;
  /** Дата обновления блока платежная информация */
  updatedAtPayment?: Maybe<Scalars['Date']['output']>;
};

export type PersonalInfoTaxInput = {
  /** ИНН */
  inn?: InputMaybe<Scalars['String']['input']>;
  /** Статус самозанятого */
  selfEmployed?: InputMaybe<SelfEmployedStatus>;
  /** Дата самозанятости */
  selfEmployedDate?: InputMaybe<Scalars['Date']['input']>;
  /** Id работника */
  userId: Scalars['String']['input'];
};

export type PersonalInfoTaxOutput = {
  __typename?: 'PersonalInfoTaxOutput';
  /** ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Статус самозанятого */
  selfEmployed?: Maybe<SelfEmployedStatus>;
  /** Дата самозанятости */
  selfEmployedDate?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока налоговые реквизиты */
  updatedAtTax?: Maybe<Scalars['Date']['output']>;
};

export type PlanCasingRateInput = {
  casingId: Scalars['String']['input'];
  isProbation: Scalars['Boolean']['input'];
  rate: Scalars['Float']['input'];
  startDatetime: Scalars['String']['input'];
};

export type PlanObjectProfessionRateInput = {
  /** Это пробный период? */
  isProbation: Scalars['Boolean']['input'];
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
  /** Ставка */
  rate: Scalars['Float']['input'];
  /** Дата в формате YYYY-MM-DD */
  startDatetime: Scalars['String']['input'];
};

export type Position = {
  __typename?: 'Position';
  casings: Array<Casing>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Описание должности */
  description?: Maybe<Scalars['String']['output']>;
  /** Id позиции в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Возможность самозанятости */
  isSelfEmployed: Scalars['Boolean']['output'];
  manualAccrualItems: Array<ManualAccrualItem>;
  /** Название должности */
  name: Scalars['String']['output'];
  publicConditions?: Maybe<Array<PublicCondition>>;
  schedules: Array<Schedule>;
  shifts: Array<Shift>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userExperiences: Array<UserExperience>;
  userGrades: Array<UserGrade>;
  userReviews: Array<UserReview>;
  users: Array<User>;
  vacancies: Array<Vacancy>;
  workPosts: Array<WorkPost>;
  zayavkaPlans: Array<ZayavkaPlan>;
  zayavkaSchedules: Array<ZayavkaSchedule>;
  zayavkaShifts: Array<ZayavkaShift>;
};

/** Таблица-справочник должностей на объекте */
export type PositionCardInput = {
  /** Название должности */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Id объекта в ERP */
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** Возможность самозанятости */
  isSelfEmployed?: Scalars['Boolean']['input'];
  /** Название должности */
  name: Scalars['String']['input'];
};

/** Выплата за единицу типа пробного периода */
export enum ProbationPayoutTypeEnum {
  /** За час */
  ForHour = 'FOR_HOUR',
  /** За смену */
  ForShift = 'FOR_SHIFT'
}

/** Еди */
export enum ProbationPeriodTypeEnum {
  /** Часы */
  CalendarDays = 'CALENDAR_DAYS',
  /** Штуки */
  ShiftCount = 'SHIFT_COUNT'
}

export type PromotionResult = {
  __typename?: 'PromotionResult';
  /** Объект */
  facility?: Maybe<Facility>;
  /** Дата последнего обновления статистики */
  lastUpdate?: Maybe<Scalars['Date']['output']>;
  /** Прогресс выполнения */
  progress: Scalars['Int']['output'];
  /** Сущность бонусной программы */
  promotion: ObjectPromotionEntity;
};

/** Условия публикации "Историй"/"рассылок пуш-уведомлений" */
export type PublicCondition = {
  __typename?: 'PublicCondition';
  cities?: Maybe<Array<City>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facilities?: Maybe<Array<Facility>>;
  facilityGroups?: Maybe<Array<FacilityGroup>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Бессрочная публикация да/нет */
  indefinitely: Scalars['Boolean']['output'];
  /** Интервал для повторения рассылки в минутах */
  interval?: Maybe<Scalars['Int']['output']>;
  /** Пуш уведомление */
  notifyLetter?: Maybe<NotifyLetter>;
  positions?: Maybe<Array<Position>>;
  /** Дата начала публикации */
  publishFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания публикации */
  publishTo?: Maybe<Scalars['Date']['output']>;
  /** Фильтр по открепленным исполнителям */
  pushToUnassigned: PushToUnassignedFilter;
  /** Кол-во получателей истории / пуша по условиям публикации */
  recipientsCount: Scalars['Int']['output'];
  /** Роли для которых публикуется стори */
  roles: Array<Role>;
  /** "Истории" */
  stories?: Maybe<Array<Story>>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Показать группе пользователей да/нет */
  useCondition: Scalars['Boolean']['output'];
};

/** Параметры группы пользователей публикации */
export type PushRecipientsCountInput = {
  /** Массив ID городов */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID объектов */
  facilities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID групп объектов */
  facilityGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID позиций (профессий) */
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Фильтр по открепленным исполнителям */
  pushToUnassigned: PushToUnassignedFilter;
  /** Массив Ролей */
  roles?: InputMaybe<Array<Role>>;
  /** Показать группе пользователей да/нет */
  useCondition?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Перенаправления в push-уведомлениях */
export enum PushRoute {
  Home = 'HOME',
  Promo = 'PROMO',
  StoryV1 = 'STORY_V1'
}

export enum PushToUnassignedFilter {
  UnassignedOnly = 'UnassignedOnly',
  WithUnassigned = 'WithUnassigned',
  WithoutUnassigned = 'WithoutUnassigned'
}

export type Query = {
  __typename?: 'Query';
  /** Возвращает объект со свободными, занятыми и принятыми сменами. Либо null, если все значения равны 0 */
  areThereAnyFreeShifts?: Maybe<AreThereAnyFreeShiftsModel>;
  /** @deprecated Метод не включает в себя статусы и возможность объединения аккаунтов */
  checkNaimixContractorStatus: Scalars['Boolean']['output'];
  /** Проверяет ИНН пользователя на возможность регистрации в Наймикс */
  checkNaimixContractorStatusV2: CheckNaimixContractorStatusV2Model;
  /** Метод для получения списка городов */
  cities: Array<City>;
  /** Возвращает список Директоров */
  clientDirectors: Array<User>;
  /** Работники, которые были назначены на смены по заявкам Клиента. в User.Shifts конкретно этого запроса смены только по заявкам клиента */
  clientUsers: PaginatedClientUsers;
  /** Метод для получения списка всех стран */
  countries: Array<Country>;
  /** Метод для получения привязанных объектов */
  facilities: Array<Facility>;
  /** Метод для получения списка объектов постранично */
  facilitiesPaginated: PaginatedFacilities;
  /** Получить карточку одного объекта */
  facility: Facility;
  /** Получить список позиций объекта */
  facilityCasings: Array<Casing>;
  /** Получить список объектов с бригадирами */
  facilityForemen: Array<Facility>;
  /** Возвращает информацию о группе объектов по id */
  facilityGroup: FacilityGroup;
  /** Получить список позиций группы объектов */
  facilityGroupCasings: PaginatedCasingsOutput;
  /** Список групп объектов */
  facilityGroups: Array<FacilityGroup>;
  /** Метод для получения пользователя по номеру телефона */
  findUserByPhone?: Maybe<User>;
  /** Список работников бригадира по всем его объектам с информацией о статусе мед.документов работника */
  foremanWorkersWithMedical: Array<WorkerWithMedical>;
  /** Получить список бригадиров */
  foremans: Array<User>;
  /** Возвращает всех юзеров с ролью менеджер */
  getAllManagers: Array<User>;
  /** Получить список горячих смен доступных работнику */
  getAllTemporaryShifts: Array<TemporaryShift>;
  /** Получить оклад по ID */
  getCasing: Casing;
  /** Получить галерею профессии объекта */
  getCasingGallery: Array<CasingGalleryEntity>;
  /** Получить галерею профессии объекта */
  getCasingGalleryByFacilityAndPosition: Array<CasingGalleryEntity>;
  /** Метод для получения городов */
  getCities: GetCitiesModel;
  /** Метод для получения города */
  getCity: CityEntity;
  /** Поиск станций метро по городу и названию */
  getCityMetroLinesWithStations: Array<MetroLineEntity>;
  /** Метод для получения списка всех стран web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=14000-114509&t=22CVpR8lx7ZLXKvL-4 */
  getCountries: GetCountriesModel;
  /** Метод для получения текущего налога самозанятого */
  getCurrentSelfEmployedTax: Scalars['Float']['output'];
  /** Список групп к которым авторизованный пользователь прикреплен как Супервайзер / Менеджер / Директор */
  getDirectorOrManagerOrSupervisorGroups: Array<FacilityGroup>;
  /** Актуальное создание Чекина/Чекаута, возвращает модель Mark */
  getErpInstances: GetErpInstancesModel;
  /** Метод для получения привязанных объектов */
  getFacilitiesByFacilityGroupOfFacilityId: Array<Facility>;
  /** Получить галерею профессии объекта */
  getFacilityGallery: Array<FacilityGalleryEntity>;
  /** Метод для получения всех групп с объектами */
  getFacilityGroupsWithFacilities: Array<FacilityGroup>;
  /** Получение списка вакансий для карты */
  getFacilityVacanciesOnMap: Array<Facility>;
  /** Получить список свободных смен для календаря */
  getFreeRequestShiftsForCalendar: Array<ZayavkaShift>;
  /** Метод получения списка приглашённых */
  getFriends: MyFriendsOutput;
  /** Метод для получения профессии HRMS */
  getHrmsProfession: HrmsProfessionEntity;
  /** Метод для получения профессии HRMS */
  getHrmsProfessions: GetHrmsProfessionsModel;
  /** Выводит постраничный список пользователей для страницы "Реферальная программа" */
  getLeadsV2: GetLeadsV2Model;
  /** Метод для получения списка юридических в Наймикс */
  getLegalEntities: Array<LegalEntity>;
  /** Получение списка связки id и названия объектов Наймикс */
  getLinkedNaimixObjects: Array<NaimixObjectOutput>;
  /** Получение списка вакансий */
  getListVacancies: Array<Vacancy>;
  /** Метод для получения периода по идентификатору */
  getLockedPeriod: GetLockedPeriodModel;
  /** Метод для получения списка заблокированных периодов */
  getLockedPeriods: GetLockedPeriodsModel;
  getLoggedJobs: Scalars['String']['output'];
  /** Получение статуса может ли пользователь работать сегодня на объекте по мед книжке */
  getMedicalWaitingFacilities: Array<WaitingFacility>;
  /** Метод для получение данных для построения анкеты модерации */
  getModerationReport: ModerationReportTable;
  /** Получить бонусы пользователя */
  getMyBonusAndRates: BonusAndRate;
  getMyIp: Scalars['String']['output'];
  /** Метод для получения списка юридических лиц Наймикс */
  getNaimixLegalEntities: GetNaimixLegalEntitiesModel;
  /** Метод для получения списка объектов Наймикс по ID юридического лица */
  getNaimixObjects?: Maybe<Array<NaimixObjectOutput>>;
  /** Получить уведомления */
  getNotifications: PaginatedNotifications;
  /** Получить число новый и прочитанных уведомлений */
  getNotificationsCounters: NotificationsCountersOutput;
  /** Получить рассылку по ID */
  getNotifyLetter: NotifyLetter;
  /** Получить постраничный список рассылок */
  getNotifyLettersPaginated: NotifyLettersPaginatedList;
  /** Получить объект web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12947-38598&t=Hx3U0quytriJLcbw-4 */
  getObject: ObjectEntity;
  /** Получить альбомы фотографий объекта и его родителей */
  getObjectPhotoGalleryWithParent: Array<ObjectPhotoGalleryEntity>;
  /** Метод для получения профессии объекта */
  getObjectProfession: ObjectProfessionEntity;
  /** Получить альбом профессии объекта */
  getObjectProfessionPhotoGallery: Array<ObjectProfessionPhotoGalleryEntity>;
  /** Метод для получения профессий объекта */
  getObjectProfessions: GetObjectProfessionsModel;
  /** Получение объекта вакансии */
  getObjectVacancies: GetObjectVacanciesModel;
  /** Получить список вакансий для карты вакансий */
  getObjectVacanciesOnMap: Array<ObjectVacancyEntity>;
  /** Получение объекта вакансии */
  getObjectVacancy: ObjectVacancyEntity;
  /** Получить список объектов web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12947-58211&t=Hx3U0quytriJLcbw-4 | https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12775-39993&t=Hx3U0quytriJLcbw-4 */
  getObjects: GetObjectsModel;
  /** Получить список объектов web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12947-58211&t=Hx3U0quytriJLcbw-4 | https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12775-39993&t=Hx3U0quytriJLcbw-4 */
  getObjectsForCreateWorkpost: GetObjectsModel;
  /** Получить список реферерров с прогрессом по бонусу "Очко" */
  getOchkoReferrersPaginated: PaginatedOchkoReferrersList;
  /** Получить список родительских объектов к которым можно привязать объект web: https://www.figma.com/design/NZr8Pxwj40IHZvxPtrS70U/Smena-%7C-Web-sandbox?node-id=12922-30559&t=Hx3U0quytriJLcbw-4 */
  getParentObjectsForCreateNewObject: GetParentObjectsForCreateNewObjectModel;
  /** Получить позицию по ID */
  getPosition: Position;
  /** Получить список позиций объектов, групп объектов, городов */
  getPositionsByFacilitiesAndCities: Array<Position>;
  /** Получить список пользователей для рассылки */
  getPushListRecipients: Array<User>;
  /** Кол-во получателей истории / push-уведомления */
  getPushRecipientsCount: Scalars['Int']['output'];
  getPushingListJobs: Scalars['String']['output'];
  /** Метод для получения реферальной программы по id */
  getReferralProgram: ReferralProgramModel;
  /** Метод для получения списка реферальных программ планировщика */
  getReferralProgramScheduler: Array<NewReferralProgramEntity>;
  /** Метод для получения списка реферальных программ */
  getReferralProgramsPaginated: GetReferralProgramsPaginatedModel;
  getRepeatableJobs: Scalars['String']['output'];
  /** Получить список графиков заявок с профессиями */
  getRequestScheduleListWithProfessions: Array<ZayavkaSchedule>;
  /** возвращает график и его смены */
  getSchedule: Schedule;
  /** Возвращает типы графиков */
  getScheduleTypes: Array<ScheduleType>;
  /** Данные для графиков на дашборд (v2) */
  getStatistic?: Maybe<Array<ChartOutput>>;
  /** Получение "Истории" по id */
  getStory: Story;
  /** Возвращает доступные Истории для пользователя */
  getStoryByUser: Array<Story>;
  /** Постраничный список "Историй" по 25 записей */
  getStoryPaginationList: PaginatedStory;
  /** Данные для табеля супервайзера */
  getSupervisorWorkSheet: GetSupervisorWorkSheetModel;
  /** Сформировать отчёт для супервайзера */
  getSupervisorWorkSheetReport: File;
  /** Объекты супервайзера */
  getSupervisorsFacilities: Array<Facility>;
  /** Получить список горячих смен доступных бригадиру */
  getTemporaryShiftForForeman: Array<TemporaryShift>;
  /** Метод для получения таймзон, которые есть в enum TimeZones БД */
  getTimeZones: Array<Scalars['String']['output']>;
  /** Метод для получения уникальных названий населённых пунктов */
  getUniqueSettlements: Array<Scalars['String']['output']>;
  /** Получить демо агентского договора Наймикс */
  getUserDemoAgencyContract: GetDemoAgencyContractNaimixModel;
  /** Получение демо рамочного договора Наймикс */
  getUserDemoFrameContract: GetDemoFrameContractNaimixModel;
  /** Получить демо договора Наймикс на обработку ПД */
  getUserDemoPDContract: GetDemoPdContractNaimixModel;
  /** Метод для получения персональной информации */
  getUserDocuments: PersonalInfoOutput;
  /** Получение рамочного договора Наймикс */
  getUserFrameContract: GetDemoFrameContractNaimixModel;
  /** Получение договора из Наймикс */
  getUserNaimixContract: GetNaimixContractNaimixModel;
  /** Постраничный вывод списка договоров */
  getUserNaimixContracts: GetUserNaimixContractsModel;
  /** Возвращает данные о профиле пользователя */
  getUserProfile: User;
  /** Получить реквизиты пользователя */
  getUserRequisite?: Maybe<Requisite>;
  getUsers: GetUsersModel;
  /** Получить список пользователей по объекту и позиции */
  getUsersByFacilityAndPosition: Array<User>;
  getUsersByRole: GetUsersByRoleModel;
  /** Получить пользователей, которые откликнулись на график заявок */
  getUsersWhoRespondedToTheRequestSchedule: ZayavkaSchedule;
  /** Получить пользователей, которые откликнулись на заявку */
  getUsersWhoRespondedToTheRequestShift: ZayavkaShift;
  /** Получение галерей вакансии */
  getVacancyGallery: VacancyGallery;
  /** Получение времени работы вакансии */
  getVacancyStartTime: IVacancyStartTime;
  /** Объекты и должности как исполнителя */
  getWorkerFacilitiesWorkPostExperience: Array<WorkerFacilityWorkPostsOutput>;
  /** Возвращает список пользователей с пересечениями для выбранного Графика в заявке */
  getWorkersForZayavkaSchedule: Array<UserIntersect>;
  /** Возвращает список пользователей с пересечениями для выбранной Смены в заявке */
  getWorkersForZayavkaShift: Array<UserIntersect>;
  /** Возвращает заявку с планом заявки и графиками заявки */
  getZayavka: ZayavkaProgress;
  /** Отображает список всех заявок для работы с графиком Супервайзером */
  getZayavkyByFacility: Array<ZayavkaProgress>;
  /** Инициализация подписания агентского договора в Наймикс */
  initUserAgencyContractNaimix: InitAgencyContractResponseNaimixModel;
  /** Инициализация подписания рамочного договора в Наймикс */
  initUserFrameContractNaimix: Scalars['Boolean']['output'];
  /** Проверка номера телефона на регистрацию в Смене */
  isPhoneNumberRegistered: Scalars['Boolean']['output'];
  /** Проверка подтверждения самозанятости пользователя в Наймикс */
  isUserConfirmTaxInNaimix: Scalars['Boolean']['output'];
  /** Метод получения лида по id */
  lead: Lead;
  /**
   * Выводит постраничный список пользователей для страницы "Реферальная программа"
   * @deprecated Неоптимизированный метод
   */
  leads: PaginatedLeadsModel;
  /** Возвращает список менеджеров для конкретной группы объектов */
  managersByGroup: Array<User>;
  /** тяжелый запрос возвращает данные о текущем пользователе с большинством связанных данных */
  me: RichUser;
  /** сравнительно экономичный запрос возвращает данные о текущем пользователе без дополнительных запросов к связанным данным */
  meShortly: RichUser;
  /** Получение списка постраничного модераций */
  moderationReportsPaginated: PaginatedModerationReportModel;
  /** Получить начисления */
  myAccruals: Array<ManualUserAccrual>;
  /** Получить уведомление по ID */
  notification: Notification;
  /** Получить все позиции */
  positions: Array<Position>;
  /** Отображение для сопоставления пользователей из импорта и пользователей на объекте */
  resolveModerationUsers: Array<ResolveReportUserModel>;
  /** Метод для получения городов и объектов, которые есть в этих городах */
  searchCitiesWithFacilities: Array<City>;
  /** Поиск объектов с вакансиями по адресу */
  searchFacilitiesVacancies: Array<Facility>;
  /** Метод для получения адресов */
  searchFacilityAddresses: Array<Address>;
  /** Поиск станций метро по городу и названию */
  searchMetroStations: MetroStationsByLineOutput;
  /** Постраничный вывод списка договоров */
  searchUserContracts: UserContractsPaginatedOutput;
  /** Поиск объектов с вакансиями по адресу */
  searchVacanciesMobile: Array<Vacancy>;
  /** Получить переменные для фронта */
  setting: Setting;
  /** Получить смену по ID */
  shift: Shift;
  /** Получить список смен */
  shifts: Array<Shift>;
  /** Подписание агенского договора в Наймикс */
  signUserAgencyContractNaimix: Scalars['Boolean']['output'];
  /** Подписание рамочного договора в Наймикс */
  signUserFrameContractNaimix: Scalars['Boolean']['output'];
  /** Получить список супервайзеров */
  supervisors: Array<User>;
  /** Получить последние непрочитанные сообщения в числе 100 шт. */
  unreadNotifications: Array<Notification>;
  /** Получение пользователя по ID */
  user: RatingUser;
  /** Получить список смен пользователя */
  userShifts: Array<Shift>;
  /** Люди по вакансиям на карте */
  usersOnMapByFacility: Array<MapPlaceModel>;
  /** Люди по вакансиям на карте */
  usersOnMapByFacility2: Array<MapPlaceModel>;
  /** Получить постраничный список пользователей */
  usersPaginated: PaginatedUsers;
  /** Получение списка вакансий */
  vacancies: Array<Vacancy>;
  /** Список вакансий с пагинацией, фильтрами, поиском и сортировкам */
  vacanciesPaginated: PaginatedVacancies;
  /** Получение вакансии по ID */
  vacancy: Vacancy;
  /** Получение рабочего расписания */
  vacancySchedules: Array<Scalars['String']['output']>;
  /** Список заявок с пагинацией и фильтрацией */
  zayavkiPaginated: PaginatedZayavky;
};


export type QueryCheckNaimixContractorStatusArgs = {
  input: CheckNaimixContractorStatusInput;
};


export type QueryCheckNaimixContractorStatusV2Args = {
  input: CheckNaimixContractorStatusInput;
};


export type QueryCitiesArgs = {
  input?: InputMaybe<GetCitiesInput>;
};


export type QueryClientUsersArgs = {
  input?: InputMaybe<ClientUserListInput>;
};


export type QueryFacilitiesPaginatedArgs = {
  input: FacilityListInput;
};


export type QueryFacilityArgs = {
  id: Scalars['String']['input'];
};


export type QueryFacilityCasingsArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryFacilityForemenArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryFacilityGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryFacilityGroupCasingsArgs = {
  input: FacilityGroupCasingsInput;
};


export type QueryFacilityGroupsArgs = {
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFindUserByPhoneArgs = {
  phone: Scalars['String']['input'];
};


export type QueryGetCasingArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetCasingGalleryArgs = {
  casingId: Scalars['String']['input'];
};


export type QueryGetCasingGalleryByFacilityAndPositionArgs = {
  facilityId: Scalars['String']['input'];
  positionId: Scalars['String']['input'];
};


export type QueryGetCitiesArgs = {
  input: GetCitiesV2Input;
};


export type QueryGetCityArgs = {
  input: GetCityInput;
};


export type QueryGetCityMetroLinesWithStationsArgs = {
  input: GetMetroLinesWithStationsInput;
};


export type QueryGetCountriesArgs = {
  input: GetCountriesInput;
};


export type QueryGetErpInstancesArgs = {
  input: GetErpInstanceInput;
};


export type QueryGetFacilitiesByFacilityGroupOfFacilityIdArgs = {
  input: GetFacilitiesByFacilityGroupOfFacilityIdInput;
};


export type QueryGetFacilityGalleryArgs = {
  facilityId: Scalars['String']['input'];
};


export type QueryGetFacilityVacanciesOnMapArgs = {
  input: GetVacanciesOnMapInput;
};


export type QueryGetFreeRequestShiftsForCalendarArgs = {
  input: GetFreeRequestShiftsForCalendarInput;
};


export type QueryGetHrmsProfessionArgs = {
  input: GetHrmsProfessionInput;
};


export type QueryGetHrmsProfessionsArgs = {
  input: GetHrmsProfessionsInput;
};


export type QueryGetLeadsV2Args = {
  input: LeadListInput;
};


export type QueryGetListVacanciesArgs = {
  input: GetListVacanciesInput;
};


export type QueryGetLockedPeriodArgs = {
  input: GetLockedPeriodInput;
};


export type QueryGetLockedPeriodsArgs = {
  input: GetLockedPeriodsInput;
};


export type QueryGetLoggedJobsArgs = {
  type: Scalars['String']['input'];
};


export type QueryGetMedicalWaitingFacilitiesArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetModerationReportArgs = {
  id: Scalars['String']['input'];
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetNaimixLegalEntitiesArgs = {
  input: GetNaimixLegalEntitiesInput;
};


export type QueryGetNaimixObjectsArgs = {
  legalEntityId: Scalars['String']['input'];
};


export type QueryGetNotificationsArgs = {
  input: PaginatedNotificationsInput;
};


export type QueryGetNotifyLetterArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetNotifyLettersPaginatedArgs = {
  input?: InputMaybe<NotifyLettersPaginatedInput>;
};


export type QueryGetObjectArgs = {
  input: GetObjectInput;
};


export type QueryGetObjectPhotoGalleryWithParentArgs = {
  input: GetObjectPhotoGalleryWithParentInput;
};


export type QueryGetObjectProfessionArgs = {
  input: GetObjectProfessionInput;
};


export type QueryGetObjectProfessionPhotoGalleryArgs = {
  input: GetObjectProfessionPhotoGalleryInput;
};


export type QueryGetObjectProfessionsArgs = {
  input: GetObjectProfessionsInput;
};


export type QueryGetObjectVacanciesArgs = {
  input: GetObjectVacanciesInput;
};


export type QueryGetObjectVacanciesOnMapArgs = {
  input: GetObjectVacanciesOnMapInput;
};


export type QueryGetObjectVacancyArgs = {
  input: GetObjectVacancyInput;
};


export type QueryGetObjectsArgs = {
  input: GetObjectsInput;
};


export type QueryGetObjectsForCreateWorkpostArgs = {
  input: GetObjectsForCreateWorkpostInput;
};


export type QueryGetOchkoReferrersPaginatedArgs = {
  input?: InputMaybe<OchkoReferrersListInput>;
};


export type QueryGetParentObjectsForCreateNewObjectArgs = {
  input: GetParentObjectsForCreateNewObjectInput;
};


export type QueryGetPositionArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPositionsByFacilitiesAndCitiesArgs = {
  cityIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  facilityIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGetPushListRecipientsArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetPushRecipientsCountArgs = {
  input: PushRecipientsCountInput;
};


export type QueryGetPushingListJobsArgs = {
  type: Scalars['String']['input'];
};


export type QueryGetReferralProgramArgs = {
  input: GetReferralProgramInput;
};


export type QueryGetReferralProgramSchedulerArgs = {
  input: GetSchedulerReferralProgramsInput;
};


export type QueryGetReferralProgramsPaginatedArgs = {
  input: GetReferralProgramsPaginatedInput;
};


export type QueryGetScheduleArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetStatisticArgs = {
  input: GetStatisticInput;
};


export type QueryGetStoryArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetStoryPaginationListArgs = {
  input: StoryListInput;
};


export type QueryGetSupervisorWorkSheetArgs = {
  input: GetSupervisorWorkSheetInput;
};


export type QueryGetSupervisorWorkSheetReportArgs = {
  input: GetSupervisorWorkSheetInput;
};


export type QueryGetUniqueSettlementsArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserDemoFrameContractArgs = {
  input: GetUserDemoFrameContractInput;
};


export type QueryGetUserDocumentsArgs = {
  workerId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUserFrameContractArgs = {
  input: GetUserDemoFrameContractInput;
};


export type QueryGetUserNaimixContractArgs = {
  input: GetUserNaimixContractInput;
};


export type QueryGetUserNaimixContractsArgs = {
  input: GetUserNaimixContractsInput;
};


export type QueryGetUserRequisiteArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  input: GetUsersInput;
};


export type QueryGetUsersByFacilityAndPositionArgs = {
  facilityId: Scalars['String']['input'];
  positions: Array<Scalars['String']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetUsersByRoleArgs = {
  input: GetUsersByRoleInput;
};


export type QueryGetUsersWhoRespondedToTheRequestScheduleArgs = {
  input: GetUsersWhoRespondedToTheRequestScheduleInput;
};


export type QueryGetUsersWhoRespondedToTheRequestShiftArgs = {
  input: GetUsersWhoRespondedToTheRequestShiftInput;
};


export type QueryGetVacancyGalleryArgs = {
  input: GetVacancyGalleryInput;
};


export type QueryGetVacancyStartTimeArgs = {
  facilityGroupId: Scalars['String']['input'];
};


export type QueryGetWorkerFacilitiesWorkPostExperienceArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetWorkersForZayavkaScheduleArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  zayavkaScheduleId: Scalars['String']['input'];
};


export type QueryGetWorkersForZayavkaShiftArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  zayavkaShiftId: Scalars['String']['input'];
};


export type QueryGetZayavkaArgs = {
  id: Scalars['String']['input'];
};


export type QueryGetZayavkyByFacilityArgs = {
  facilityId: Scalars['String']['input'];
  month?: InputMaybe<Scalars['String']['input']>;
  show?: InputMaybe<ZayavkaByFacilityDisplay>;
};


export type QueryInitUserFrameContractNaimixArgs = {
  input: InitUserFrameContractNaimixInput;
};


export type QueryIsPhoneNumberRegisteredArgs = {
  phone: Scalars['String']['input'];
};


export type QueryLeadArgs = {
  id: Scalars['String']['input'];
};


export type QueryLeadsArgs = {
  input?: InputMaybe<LeadListInput>;
};


export type QueryManagersByGroupArgs = {
  groupId: Scalars['String']['input'];
};


export type QueryModerationReportsPaginatedArgs = {
  input: ModerationReportListInput;
};


export type QueryNotificationArgs = {
  id: Scalars['String']['input'];
};


export type QueryResolveModerationUsersArgs = {
  reportId: Scalars['String']['input'];
};


export type QuerySearchCitiesWithFacilitiesArgs = {
  facilityGroupId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchFacilitiesVacanciesArgs = {
  input: SearchVacanciesFilterInput;
};


export type QuerySearchFacilityAddressesArgs = {
  query: Scalars['String']['input'];
};


export type QuerySearchMetroStationsArgs = {
  city: Scalars['String']['input'];
  search: Scalars['String']['input'];
};


export type QuerySearchUserContractsArgs = {
  input: SearchContractsInput;
};


export type QuerySearchVacanciesMobileArgs = {
  input: SearchVacanciesMobileFilterInput;
};


export type QuerySettingArgs = {
  name: Scalars['String']['input'];
};


export type QueryShiftArgs = {
  id: Scalars['String']['input'];
};


export type QueryShiftsArgs = {
  input?: InputMaybe<FindUserShiftsInput>;
};


export type QuerySignUserAgencyContractNaimixArgs = {
  input: SignUserAgencyContractNaimixInput;
};


export type QuerySignUserFrameContractNaimixArgs = {
  input: SignUserFrameContractNaimixInput;
};


export type QueryUserArgs = {
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserShiftsArgs = {
  input: FindUserShiftsInput;
};


export type QueryUsersPaginatedArgs = {
  input?: InputMaybe<UserListInput>;
};


export type QueryVacanciesArgs = {
  facilityId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVacanciesPaginatedArgs = {
  input: VacancyListInput;
};


export type QueryVacancyArgs = {
  vacancyId: Scalars['String']['input'];
};


export type QueryZayavkiPaginatedArgs = {
  input: ZayavkaListInput;
};

/** Анкета пользователя */
export type Questionnaire = {
  __typename?: 'Questionnaire';
  address: Address;
  /**
   * Id адреса
   * @deprecated Устарело, использовать cityId
   */
  addressId?: Maybe<Scalars['String']['output']>;
  /** Размер одежды */
  clothingSize?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Свободный график */
  customSchedule?: Maybe<Scalars['String']['output']>;
  /** IDs групп объектов */
  facilityGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Размер ноги */
  footSize?: Maybe<Scalars['Int']['output']>;
  /** Рост */
  growth?: Maybe<Scalars['Int']['output']>;
  /** Кол-во часов в день */
  hoursPerDay?: Maybe<Scalars['Int']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** IDs станций метро */
  metroStationsIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Профессии */
  positionsIds: Array<Scalars['String']['output']>;
  /** Радиус поиска вакансий в метрах */
  radius?: Maybe<Scalars['Int']['output']>;
  /**
   * ID типов графиков
   * @deprecated Отказываемся от них
   */
  scheduleTypesIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Пол */
  sex?: Maybe<Sex>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  /** Id пользователя */
  userId: Scalars['String']['output'];
  vacancySearchType: VacancySearchType;
};

/** Анкета работника */
export type QuestionnaireInput = {
  /** Идентификатор страны */
  citizenshipId?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор города */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Размер одежды */
  clothingSize?: InputMaybe<Scalars['String']['input']>;
  /** Свободный график */
  customSchedule?: InputMaybe<Scalars['String']['input']>;
  /** Массив IDs профессий */
  facilityGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Имя */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Размер ноги */
  footSize?: InputMaybe<Scalars['Int']['input']>;
  /** Рост */
  growth?: InputMaybe<Scalars['Int']['input']>;
  /** Кол-во часов в день */
  hoursPerDay?: InputMaybe<Scalars['Int']['input']>;
  /** Фамилия */
  lastname?: InputMaybe<Scalars['String']['input']>;
  /** IDs станций метро */
  metroStationsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Отчество */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  /** Массив IDs профессий */
  positionsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив IDs типов графиков */
  scheduleTypesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Пол */
  sex?: InputMaybe<Sex>;
  /** Идентификатор пользователя */
  userId?: InputMaybe<Scalars['String']['input']>;
  vacancySearchType?: InputMaybe<VacancySearchType>;
};

/** Тип отображения стоимости смены */
export enum RateTypeEnum {
  /** Средняя */
  Average = 'AVERAGE',
  /** Диапазон */
  Range = 'RANGE'
}

export type RatesOutput = {
  __typename?: 'RatesOutput';
  /** Когда назначен на рабочее место */
  assignedAt: Scalars['Date']['output'];
  assignedBy: Scalars['String']['output'];
  /** Экземпляр модели объекта, на котором пользователь занимает конкретную должность */
  casing?: Maybe<Facility>;
  /** Экземпляр модели объекта, на котором пользователь занимает конкретную должность */
  facility?: Maybe<Facility>;
  /** id объекта, на котором пользователь занимает конкретную должность */
  facilityId: Scalars['String']['output'];
  /** Возможность стажировки */
  hasProbation: Scalars['Boolean']['output'];
  /** Признак есть ли хотя бы одна отработанная смена после стажировки */
  hasWorkedShift?: Maybe<Scalars['Boolean']['output']>;
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Признак пройдена ли стажировка */
  isProbationFinished?: Maybe<Scalars['Boolean']['output']>;
  /** Возможность самозанятости */
  isSelfEmployed: Scalars['Boolean']['output'];
  /** Тип выплаты за работу */
  payout?: Maybe<PayoutType>;
  /** Объект должности, которую занимает пользователь на объекте (рабочем месте) */
  position?: Maybe<Position>;
  /** id должности, которую занимает пользователь на объекте (рабочем месте) */
  positionId: Scalars['String']['output'];
  /** Дата окончания стажировки в формате YYYY-MM-DD */
  probationEnd?: Maybe<Scalars['String']['output']>;
  /** Период стажировки в календарных днях */
  probationPeriod?: Maybe<Scalars['Int']['output']>;
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  /** Дата начала стажировки в формате YYYY-MM-DD */
  probationStart?: Maybe<Scalars['String']['output']>;
  /** Надбавка к часовой ставке за самозанятость у работника */
  selfEmployedRate?: Maybe<Scalars['Int']['output']>;
  /** Статус рабочего места */
  status: WorkPostStatus;
  /** Единицы измерения для оплаты */
  unit?: Maybe<UnitType>;
  /** Дата и время создания рабочего места */
  updatedAt: Scalars['Date']['output'];
  /** Объект пользователя, который связан с рабочим местом (должность + объект) */
  user?: Maybe<User>;
  /** Id пользователя, который связан с рабочим местом (должность + объект) */
  userId: Scalars['String']['output'];
};

/** Юзер с полями: скорость, характер, ответственность */
export type RatingUser = {
  __typename?: 'RatingUser';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  character: Scalars['Int']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  responsiveness: Scalars['Int']['output'];
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  speed: Scalars['Int']['output'];
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

export type ReadShiftCommentsInput = {
  /** Идентификатор смены, где необходимо пометить комментарии как прочитанные */
  shiftId: Scalars['String']['input'];
};

export type ReferralProgramEntity = {
  __typename?: 'ReferralProgramEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Описание реферальной программы */
  description?: Maybe<Scalars['String']['output']>;
  /** Дата и время завершения */
  endDatetime?: Maybe<Scalars['Date']['output']>;
  /** Объект привязанный к реферальной программе */
  facility?: Maybe<Facility>;
  /** Группа объектов привязанная к реферальной программе */
  facilityGroup?: Maybe<FacilityGroup>;
  /** Идентификатор группы объектов */
  facilityGroupId?: Maybe<Scalars['String']['output']>;
  /** Идентификатор объекта */
  facilityId?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Название реферальной программы */
  name?: Maybe<Scalars['String']['output']>;
  /** Пуш уведомления привязанные к бонусной программе */
  notifyLetters: Array<NotifyLetter>;
  /** Количество хорошо отработанных смен */
  numberOfGoodShifts?: Maybe<Scalars['Int']['output']>;
  /** Вознаграждение приглашающего */
  rewardForTheReferer?: Maybe<Scalars['Int']['output']>;
  /** Дата и время начала */
  startDatetime?: Maybe<Scalars['Date']['output']>;
  /** Текущее состояние */
  status: ReferralProgramStatusEnum;
  /** Истории привязанные к бонусной программе */
  stories: Array<Story>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ReferralProgramModel = {
  __typename?: 'ReferralProgramModel';
  /** Текущей реферальная программа */
  currentReferralProgram: NewReferralProgramEntity;
  /** Следующая реферальная программа */
  nextReferralProgram?: Maybe<NewReferralProgramEntity>;
  /** Реферальная программа */
  referralProgram: NewReferralProgramEntity;
};

export enum ReferralProgramRoleEnum {
  Referral = 'REFERRAL',
  Referrer = 'REFERRER'
}

/** Статус реферальной программы */
export enum ReferralProgramStatusEnum {
  /** Активно */
  Active = 'ACTIVE',
  /** Архив */
  Archive = 'ARCHIVE',
  /** Черновик */
  Draft = 'DRAFT',
  /** Запланировано */
  Planned = 'PLANNED'
}

export type RegisterUserDeviceInput = {
  /** Текущая версия приложения на устройстве */
  currentApplicationVersion: Scalars['String']['input'];
  /** Токен Firebase */
  firebaseToken: Scalars['String']['input'];
  /** Модель устройства */
  model: Scalars['String']['input'];
  /** Тип ОС устройства */
  type: UserDeviceTypeEnum;
};

/** Статус подписания АД и согласия на обработку ПД в Наймикс */
export enum RegistrationInNaimixStateEnum {
  FullRegistration = 'FULL_REGISTRATION',
  IncompleteRegistration = 'INCOMPLETE_REGISTRATION',
  NotChecked = 'NOT_CHECKED',
  NotRegistered = 'NOT_REGISTERED'
}

/** Причина отклонения документов */
export enum RejectReason {
  DocumentExpired = 'DOCUMENT_EXPIRED',
  IncorrectData = 'INCORRECT_DATA',
  None = 'NONE',
  NoFace = 'NO_FACE',
  PoorQuality = 'POOR_QUALITY',
  SelfieDoesntMatch = 'SELFIE_DOESNT_MATCH'
}

export type RemovePhotoOnObjectPhotoGalleryInput = {
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Идентификаторы фотографий из альбома к удалению */
  objectPhotoGalleryIds: Array<Scalars['ID']['input']>;
};

export type RemovePhotoOnObjectProfessionPhotoGalleryInput = {
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
  /** Идентификаторы фотографий из альбома к удалению */
  objectProfessionPhotoGalleryIds: Array<Scalars['ID']['input']>;
};

export type RemoveResponsibleFromTheObjectInput = {
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Идентификатор пользователя */
  userId: Scalars['ID']['input'];
};

export type RemoveStatusFreeRequestShiftInput = {
  /** Идентификатор смены в заявке */
  requestShiftId: Scalars['String']['input'];
};

export type Report = {
  __typename?: 'Report';
  author: User;
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  filePath: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  type: ReportType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export enum ReportType {
  Daily = 'DAILY',
  EverythingIsPossibleBonus = 'EVERYTHING_IS_POSSIBLE_BONUS',
  Polls = 'POLLS',
  Sms = 'SMS',
  Timesheet = 'TIMESHEET'
}

export type RequestShiftSuggestionEntity = {
  __typename?: 'RequestShiftSuggestionEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  requestShift: ZayavkaShift;
  requestShiftId: Scalars['ID']['output'];
  status: ZayavkaShiftSuggestionsStatusEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user: User;
  userId: Scalars['ID']['output'];
};

/** Необходимые документы */
export enum RequiredDocumentEnum {
  /** ИНН */
  Inn = 'INN',
  /** Медицинская книжка */
  MedBook = 'MED_BOOK',
  /** Паспорт */
  Passport = 'PASSPORT',
  /** Платёжная информация */
  PaymentInfo = 'PAYMENT_INFO'
}

export type Requisite = {
  __typename?: 'Requisite';
  /** Номер счёта */
  accountNumber?: Maybe<Scalars['String']['output']>;
  /** Уведомление о прибытии иностранного гражданина в место пребывания - дата постановки на учет */
  arrivalNoticeRegistrationDate?: Maybe<Scalars['String']['output']>;
  /** Уведомление о прибытии иностранного гражданина в место пребывания - адрес пребывания */
  arrivalNoticeResidenceAddress?: Maybe<Scalars['String']['output']>;
  /** Уведомление о прибытии иностранного гражданина в место пребывания - дата окончания срока действия */
  arrivalNoticeValidToDate?: Maybe<Scalars['String']['output']>;
  /** Название банка */
  bankName?: Maybe<Scalars['String']['output']>;
  /** БИК */
  bik?: Maybe<Scalars['String']['output']>;
  /** Дата рождения */
  birthDate?: Maybe<Scalars['String']['output']>;
  /** Место рождения */
  birthPlace?: Maybe<Scalars['String']['output']>;
  /** Срок действия карты */
  cardExpiryDate?: Maybe<Scalars['Date']['output']>;
  /** Имя держателя карты */
  cardName?: Maybe<Scalars['String']['output']>;
  /** Номер карты */
  cardNumber?: Maybe<Scalars['String']['output']>;
  /** Номер корр.счёта */
  correspondentAccount?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Паспорт - идентификационный номер */
  identificationNumber?: Maybe<Scalars['String']['output']>;
  /** ИНН */
  inn?: Maybe<Scalars['String']['output']>;
  /** Даты конца аттестации строка даты YYYY-MM-DD */
  medicalAttestationEnd?: Maybe<Scalars['String']['output']>;
  /** Даты начала аттестации строка даты YYYY-MM-DD */
  medicalAttestationStart?: Maybe<Scalars['String']['output']>;
  /** Ожидаемая дата выдачи медицинской книжки после получения справки */
  medicalExpectedReceiptDate?: Maybe<Scalars['Date']['output']>;
  /** Дата выдачи медицинской справки (о прохождении осмотра перед получением медицинской книжки) */
  medicalInvoiceIssueDate?: Maybe<Scalars['Date']['output']>;
  /** Номер мед.книжки */
  medicalNumber?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи миграционной карты */
  migrationCardIssueDate?: Maybe<Scalars['String']['output']>;
  /** Номер миграционной карты */
  migrationCardNumber?: Maybe<Scalars['String']['output']>;
  /** Серия миграционной карты */
  migrationCardSeries?: Maybe<Scalars['String']['output']>;
  /** Дата истечения действия миграционной карты */
  migrationCardValidToDate?: Maybe<Scalars['String']['output']>;
  /** Миграционный статус */
  migrationStatus?: Maybe<MigrationStatusNaimixEnum>;
  /** Кем выдан паспорт */
  passportIssuedBy?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи паспорта */
  passportIssuedDate?: Maybe<Scalars['String']['output']>;
  /** Код подразделения */
  passportIssuerCode?: Maybe<Scalars['String']['output']>;
  /** Номер паспорта */
  passportNumber?: Maybe<Scalars['String']['output']>;
  /** Адрес регистрации */
  passportRegistrationAddress?: Maybe<Scalars['String']['output']>;
  /** Серия паспорта */
  passportSeries?: Maybe<Scalars['String']['output']>;
  /** Паспорт - Тип паспорта для исполнителя ЭДО */
  passportType?: Maybe<PassportTypeNaimixEnum>;
  /** Дата окончания срока действия паспорта */
  passportValidToDate?: Maybe<Scalars['String']['output']>;
  /** Статус самозанятого */
  selfEmployed?: Maybe<SelfEmployedStatus>;
  /** Дата самозанятости */
  selfEmployedDate?: Maybe<Scalars['Date']['output']>;
  /** Пол */
  sex?: Maybe<Sex>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока мед.книжка */
  updatedAtMedical?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока паспортные данные */
  updatedAtPassport?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока платежная информация */
  updatedAtPayment?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока с персональной информацией */
  updatedAtPersonal?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока регистрации */
  updatedAtRegistration?: Maybe<Scalars['Date']['output']>;
  /** Дата обновления блока налоговые реквизиты */
  updatedAtTax?: Maybe<Scalars['Date']['output']>;
  /** работник */
  user?: Maybe<User>;
  /** Id работника */
  userId: Scalars['String']['output'];
};

export type RequisiteInput = {
  inn?: InputMaybe<Scalars['String']['input']>;
  selfEmployed?: InputMaybe<SelfEmployedStatus>;
  selfEmployedDate?: InputMaybe<Scalars['DateTime']['input']>;
  userId: Scalars['String']['input'];
};

export type ResetToDefaultObjectPromotionInput = {
  /** Идентификатор бонусной программы */
  objectPromotionId: Scalars['ID']['input'];
};

export type RestoreWorkerPositionInput = {
  /** ID объекта */
  facilityId: Scalars['String']['input'];
  /** ID профессии */
  positionId: Scalars['String']['input'];
  /** ID исполнителя */
  userId: Scalars['String']['input'];
};

/** Тип документа на проверку */
export enum ReviewType {
  Inn = 'INN',
  MainPage = 'MAIN_PAGE',
  MedicalInvoice = 'MEDICAL_INVOICE',
  Page2_3 = 'PAGE2_3',
  Page28_29 = 'PAGE28_29',
  PaymentInfo = 'PAYMENT_INFO',
  Person = 'PERSON',
  Registration = 'REGISTRATION',
  Selfie = 'SELFIE'
}

export type RichUser = {
  __typename?: 'RichUser';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Максимальная версия */
  maxVersion?: Maybe<Scalars['String']['output']>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  /** Список ID профессий указанных работником в анкете */
  questionnairePositionIds?: Maybe<Array<Scalars['String']['output']>>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

/** Роль пользователя */
export enum Role {
  Admin = 'ADMIN',
  ClientDirector = 'CLIENT_DIRECTOR',
  ClientManager = 'CLIENT_MANAGER',
  Foreman = 'FOREMAN',
  Newbie = 'NEWBIE',
  Supervisor = 'SUPERVISOR',
  Worker = 'WORKER'
}

export enum ScanTypeNaimixEnum {
  /** Скан уведомления о прибытии, первая сторона */
  ArrivalNotificationFirstSide = 'ARRIVAL_NOTIFICATION_FIRST_SIDE',
  /** Скан уведомления о прибытии, вторая сторона */
  ArrivalNotificationSecondSide = 'ARRIVAL_NOTIFICATION_SECOND_SIDE',
  /** Скан заграничного паспорта, место рождения */
  ForeignPassportBirthPlace = 'FOREIGN_PASSPORT_BIRTH_PLACE',
  /** Скан заграничного паспорта, персональная информация */
  ForeignPassportPersonalInformation = 'FOREIGN_PASSPORT_PERSONAL_INFORMATION',
  /** Скан внутреннего паспорта, обратная сторона */
  InternalPassportBackSide = 'INTERNAL_PASSPORT_BACK_SIDE',
  /** Скан миграционной карты, лицевая сторона */
  MigrationCard = 'MIGRATION_CARD',
  /** Скан миграционной карты, обратная сторона */
  MigrationCardBackSide = 'MIGRATION_CARD_BACK_SIDE',
  /** Селфи с паспортом */
  PassportSelfie = 'PASSPORT_SELFIE',
  /** Фотография нотариального заверения перевода паспорта */
  PassportTranslationNotarizationScan = 'PASSPORT_TRANSLATION_NOTARIZATION_SCAN',
  /** Фотография перевода паспорта на русский язык */
  PassportTranslationScan = 'PASSPORT_TRANSLATION_SCAN',
  /** Скан паспорта РФ, персональная информация */
  RfPassportPersonalInformation = 'RF_PASSPORT_PERSONAL_INFORMATION',
  /** Скан паспорта РФ, регистрация */
  RfPassportRegistration = 'RF_PASSPORT_REGISTRATION'
}

export type Schedule = {
  __typename?: 'Schedule';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время подтверждения графика */
  dateAccept?: Maybe<Scalars['Date']['output']>;
  /** Дата и время начала графика */
  dateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата и время окончания графика */
  dateTo?: Maybe<Scalars['Date']['output']>;
  /** Тип графика: 1 - 2/2; 2 - 4/2; 3 - 5/2; 4 - 6/1; 5 - 7/0 (рабочих дней / выходные) */
  dayInterleaving?: Maybe<Scalars['Int']['output']>;
  /** Объект */
  facility?: Maybe<Facility>;
  /** Id объекта */
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** График принят */
  isAccept: Scalars['Boolean']['output'];
  /** Кастомный график */
  isCustom: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Длительность обеда в графике */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Должность */
  position?: Maybe<Position>;
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Дата окончания стажировки в формате YYYY-MM-DD */
  probationEnd?: Maybe<Scalars['String']['output']>;
  /** Дата начала стажировки в формате YYYY-MM-DD */
  probationStart?: Maybe<Scalars['String']['output']>;
  /** Тип графика */
  scheduleType?: Maybe<ScheduleType>;
  /** Идентификатор типа графика */
  scheduleTypeId?: Maybe<Scalars['String']['output']>;
  /** Длительность смены в графике, необязательное */
  shiftDuration?: Maybe<Scalars['Int']['output']>;
  /** Смены */
  shifts?: Maybe<Array<Shift>>;
  /** Новый статус графика */
  stage: ScheduleStage;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user: User;
  /** Id пользователя */
  userId: Scalars['String']['output'];
  /** Связь графика с заявкой */
  zayavkaSchedule?: Maybe<ZayavkaSchedule>;
  /** ID связи с заявкой */
  zayavkaScheduleId?: Maybe<Scalars['String']['output']>;
};

/** Schedule NEW statuses */
export enum ScheduleStage {
  Accepted = 'ACCEPTED',
  Ineligible = 'INELIGIBLE',
  New = 'NEW',
  Refused = 'REFUSED'
}

export type ScheduleSubOutput = {
  __typename?: 'ScheduleSubOutput';
  /** Объект графика */
  schedule: Schedule;
  /** Смены которые были изменены при  */
  shifts?: Maybe<Array<Shift>>;
  /** Id бригадира */
  userId: Scalars['String']['output'];
};

export type ScheduleType = {
  __typename?: 'ScheduleType';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offDays: Scalars['Int']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workDays: Scalars['Int']['output'];
  zayavkaSchedules: Array<ZayavkaSchedule>;
};

/** Фильтр для поиска договоров */
export type SearchContractsInput = {
  /** Дата создания договора */
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Идентификатор группы объектов */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Поля сортировки списка договоров */
  sortBy?: InputMaybe<UserContractSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Статус договора */
  status?: InputMaybe<UserContractStatus>;
  /** Тип договора */
  type?: InputMaybe<UserContractType>;
};

export type SearchVacanciesFilterInput = {
  /** ID группы объектов */
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  /** ID объекта */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Флаг выводить ли объекты без вакансий */
  hasVacancies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Широта */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Долгота */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Список идентификаторов станций метро */
  metroStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID профессии */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Массив ID профессий */
  positionsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Радиус поиска в километрах (20км по умолчанию) */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** Название населенного пункта */
  settlement?: InputMaybe<Scalars['String']['input']>;
};

export type SearchVacanciesMobileFilterInput = {
  /** Широта */
  latitude?: InputMaybe<Scalars['Float']['input']>;
  /** Долгота */
  longitude?: InputMaybe<Scalars['Float']['input']>;
  /** Список идентификаторов станций метро */
  metroStationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID профессий */
  positionsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Радиус поиска в километрах (20км по умолчанию) */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** Массив ID типов графика */
  scheduleTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Населенный пункт */
  settlement?: InputMaybe<Scalars['String']['input']>;
  /** Длительность смены */
  shiftDuration?: InputMaybe<Scalars['Int']['input']>;
};

/** Self-employed status */
export enum SelfEmployedStatus {
  Accepted = 'ACCEPTED',
  None = 'NONE',
  Pending = 'PENDING',
  Wish = 'WISH'
}

export type SendFreeShiftByRequestShiftIdInput = {
  /** Дата */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Идентификатор объекта */
  facilityId: Scalars['ID']['input'];
  /** Идентификатор смены заявки */
  requestShiftId: Scalars['ID']['input'];
  /** Сортировка по статусам заявки */
  show?: InputMaybe<ZayavkaByFacilityDisplay>;
};

export type SendFreeShiftsByRequestIdsInput = {
  /** Дата */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Идентификатор объекта */
  facilityId: Scalars['ID']['input'];
  requestIds: Array<Scalars['ID']['input']>;
  /** Сортировка по статусам заявки */
  show?: InputMaybe<ZayavkaByFacilityDisplay>;
};

export type SendFreeShiftsByRequestScheduleIdInput = {
  /** Дата */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** Идентификатор объекта */
  facilityId: Scalars['ID']['input'];
  /** Идентификатор графика заявки */
  requestScheduleId: Scalars['ID']['input'];
  /** Сортировка по статусам заявки */
  show?: InputMaybe<ZayavkaByFacilityDisplay>;
};

export type SendUserDataToNaimixArrivalNoticeInput = {
  arrivalNoticeRegistrationDate: Scalars['String']['input'];
  arrivalNoticeResidenceAddress: Scalars['String']['input'];
  arrivalNoticeValidToDate: Scalars['String']['input'];
};

export type SendUserDataToNaimixInput = {
  arrivalNotice?: InputMaybe<SendUserDataToNaimixArrivalNoticeInput>;
  birthDate: Scalars['String']['input'];
  birthPlace: Scalars['String']['input'];
  citizenshipId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Sex;
  inn: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  migrationCardInfo?: InputMaybe<SendUserDataToNaimixMigrationCardInfoInput>;
  migrationStatus: MigrationStatusNaimixEnum;
  passport: SendUserDataToNaimixPassportInput;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  registrationAddress?: InputMaybe<Scalars['String']['input']>;
};

export type SendUserDataToNaimixMigrationCardInfoInput = {
  migrationCardIssueDate: Scalars['String']['input'];
  migrationCardNumber: Scalars['String']['input'];
  migrationCardSeries: Scalars['String']['input'];
  migrationCardValidToDate?: InputMaybe<Scalars['String']['input']>;
};

export type SendUserDataToNaimixPassportInput = {
  identificationNumber?: InputMaybe<Scalars['String']['input']>;
  passportIssueDate: Scalars['String']['input'];
  passportIssuedBy: Scalars['String']['input'];
  passportIssuerCode?: InputMaybe<Scalars['String']['input']>;
  passportNumber: Scalars['String']['input'];
  passportSeries?: InputMaybe<Scalars['String']['input']>;
  passportType?: InputMaybe<PassportTypeNaimixEnum>;
  passportValidToDate?: InputMaybe<Scalars['String']['input']>;
};

export type SetCityForUserInput = {
  /** dadata fias id */
  fiasId: Scalars['String']['input'];
  /** Широта */
  latitude: Scalars['String']['input'];
  /** Долгота */
  longitude: Scalars['String']['input'];
  /** Населенный пункт */
  settlement: Scalars['String']['input'];
};

export type SetReferralProgramPaymentDatetimeInput = {
  leadId: Scalars['String']['input'];
  setFor: ReferralProgramRoleEnum;
};

export type SetScheduleOutput = {
  __typename?: 'SetScheduleOutput';
  /** Смены которые были изменены при  */
  intersectShifts?: Maybe<Array<Shift>>;
  /** Объект графика */
  schedule: Schedule;
};

export type SetStatusModerationInput = {
  /** Id Табелей модервации */
  reportIds: Array<Scalars['String']['input']>;
  /** Статус модерации */
  status?: ModerationStatus;
};

export type SetUserTokenInput = {
  androidToken?: InputMaybe<Scalars['String']['input']>;
  browserToken?: InputMaybe<Scalars['String']['input']>;
  huaweiToken?: InputMaybe<Scalars['String']['input']>;
  iosToken?: InputMaybe<Scalars['String']['input']>;
};

export type Setting = {
  __typename?: 'Setting';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Имя */
  name: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Значение */
  value: Scalars['String']['output'];
};

/** Пол */
export enum Sex {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type Shift = {
  __typename?: 'Shift';
  /** Id автора */
  authorId: Scalars['String']['output'];
  /** комментарий к смене */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарии бригадиров к смене */
  comments: Array<CommentEntity>;
  /** Размер оплаты по смене */
  cost: Scalars['Float']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время конца */
  dateEnd: Scalars['Date']['output'];
  /** Дата и время начала */
  dateFrom: Scalars['Date']['output'];
  deletedDate: Scalars['Date']['output'];
  /** Длительность смены в минутах */
  duration: Scalars['String']['output'];
  empty: Scalars['Boolean']['output'];
  /** Объект */
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Является ли смена стажировочной */
  isProbation: Scalars['Boolean']['output'];
  /** длительность обеда в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Чекины/Чекауты */
  marks: Array<Mark>;
  /** Объект модерации */
  moderation?: Maybe<Moderation>;
  /** Тип выплаты за работу */
  payout: PayoutType;
  /** Штраф на смене */
  penalties?: Maybe<Array<ShiftPenaltyEntity>>;
  /** Объект должности */
  position?: Maybe<Position>;
  /** Id должности на смене */
  positionId: Scalars['String']['output'];
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  rejectedById?: Maybe<Scalars['String']['output']>;
  /** График */
  schedule?: Maybe<Schedule>;
  /** Id графика */
  scheduleId?: Maybe<Scalars['String']['output']>;
  selfEmployedRate?: Maybe<Scalars['Int']['output']>;
  stage: ShiftStage;
  status: ShiftStatus;
  /** Единицы измерения для оплаты */
  unit: UnitType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  /** Значение для смен по сдельной оплате */
  value?: Maybe<Scalars['Float']['output']>;
  /** Заявка, если смена относится к Заявке */
  zayavka?: Maybe<Zayavka>;
  /** Id заявки если смена привязана к заявке */
  zayavkaId?: Maybe<Scalars['String']['output']>;
  zayavkaShifts: Array<ZayavkaShift>;
};

export type ShiftArrestedPaymentEntity = {
  __typename?: 'ShiftArrestedPaymentEntity';
  /** Причина удержания */
  cause: Scalars['String']['output'];
  /** Комментарий к удержанию */
  comment: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Сумма удержания */
  sum: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ShiftCommentEntity = {
  __typename?: 'ShiftCommentEntity';
  /** Автор коммента */
  author: UserEntity;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  message: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ShiftEntity = {
  __typename?: 'ShiftEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время окончания */
  endDatetime: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Это пробная смена? */
  isProbation: Scalars['Boolean']['output'];
  /** Продолжительность обеденного перерыва */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Модерация смены */
  moderation?: Maybe<ShiftModerationEntity>;
  /** Прогресс выполнения условий бонусных программ */
  objectPromotionProgress: Array<ShiftObjectPromotionProgressEntity>;
  /** Общая сумма выплаты */
  payout: Scalars['Float']['output'];
  /** Ставка */
  payoutRate: Scalars['Float']['output'];
  /** Тип выплаты */
  payoutType: PayoutTypeEnum;
  /** Единица измерения типа выплаты */
  payoutTypeUnit: PayoutTypeUnitEnum;
  /** Количество единиц измерения типа выплаты */
  payoutTypeValue: Scalars['Int']['output'];
  /** Штрафы */
  penalties?: Maybe<Array<ShiftPenaltyEntity>>;
  /** Стадия смены */
  stage: ShiftStageEnum;
  /** Дата и время начала */
  startDatetime: Scalars['Date']['output'];
  /** Статус смены */
  status: ShiftStatusEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** модель смены дополненная данными факт. и факт. */
export type ShiftFact = {
  __typename?: 'ShiftFact';
  /** Id автора */
  authorId: Scalars['String']['output'];
  /** комментарий к смене */
  comment?: Maybe<Scalars['String']['output']>;
  /** Комментарии бригадиров к смене */
  comments: Array<CommentEntity>;
  /** Размер оплаты по смене */
  cost: Scalars['Float']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время конца */
  dateEnd: Scalars['Date']['output'];
  /** Дата и время начала */
  dateFrom: Scalars['Date']['output'];
  deletedDate: Scalars['Date']['output'];
  /** Длительность смены в минутах */
  duration: Scalars['String']['output'];
  /** Фактическая! Длительность смены в минутах по отметкам чекина и чекаута */
  durationFact: Scalars['Float']['output'];
  /** Плановая! Длительность смены в минутах с учетом вычета обеда */
  durationPlan: Scalars['Float']['output'];
  empty: Scalars['Boolean']['output'];
  /** Объект */
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  finalBonus: Scalars['Int']['output'];
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  /** Является ли смена стажировочной */
  isProbation: Scalars['Boolean']['output'];
  /** длительность обеда в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Чекины/Чекауты */
  marks: Array<Mark>;
  /** Объект модерации */
  moderation?: Maybe<Moderation>;
  /** Число непрочитанных комментариев */
  newCommentsNum: Scalars['Int']['output'];
  /** Тип выплаты за работу */
  payout: PayoutType;
  /** Штраф на смене */
  penalties?: Maybe<Array<ShiftPenaltyEntity>>;
  /** Объект должности */
  position?: Maybe<Position>;
  /** Id должности на смене */
  positionId: Scalars['String']['output'];
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  promotionResults?: Maybe<Array<PromotionResult>>;
  rejectedById?: Maybe<Scalars['String']['output']>;
  /** График */
  schedule?: Maybe<Schedule>;
  /** Id графика */
  scheduleId?: Maybe<Scalars['String']['output']>;
  selfEmployedRate?: Maybe<Scalars['Int']['output']>;
  stage: ShiftStage;
  status: ShiftStatus;
  /** Единицы измерения для оплаты */
  unit: UnitType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  /** Значение для смен по сдельной оплате */
  value?: Maybe<Scalars['Float']['output']>;
  /** Плановая! Длительность смены в минутах с учетом вычета обеда */
  valuePlan?: Maybe<Scalars['Float']['output']>;
  /** Заявка, если смена относится к Заявке */
  zayavka?: Maybe<Zayavka>;
  /** Id заявки если смена привязана к заявке */
  zayavkaId?: Maybe<Scalars['String']['output']>;
  zayavkaShifts: Array<ZayavkaShift>;
};

/** Объект доставки бригадиру изменений смены по подписке */
export type ShiftForemanSubOutput = {
  __typename?: 'ShiftForemanSubOutput';
  /** Дата и время создания объекта */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор объекта */
  id: Scalars['ID']['output'];
  /** Смена которую надо доставить бригадиру */
  shift: Shift;
  /** Дата и время обновления объекта */
  updatedAt: Scalars['Date']['output'];
  /** Id бригадира */
  userId: Scalars['String']['output'];
};

export type ShiftMarkEntity = {
  __typename?: 'ShiftMarkEntity';
  /** Точность координат в метрах */
  accuracy: Scalars['Int']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  distance: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isGood: Scalars['Boolean']['output'];
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
  note: Scalars['String']['output'];
  /** Тип отметки */
  type: ShiftMarkTypeEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Тип отметки */
export enum ShiftMarkTypeEnum {
  /** Отметка о начале */
  Checkin = 'CHECKIN',
  /** Отметка об окончании */
  Checkout = 'CHECKOUT'
}

export type ShiftModerationEntity = {
  __typename?: 'ShiftModerationEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Общая сумма выплаты */
  payment: Scalars['Float']['output'];
  /** Ставка */
  payoutRate: Scalars['Float']['output'];
  /** Количество единиц измерения типа выплаты */
  payoutTypeValue: Scalars['Int']['output'];
  /** Разрешить выплату за смену? */
  toPayment: Scalars['Boolean']['output'];
  /** Разрешить выплату за бонусы? */
  toPaymentBonus: Scalars['Boolean']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ShiftObjectPromotionProgressEntity = {
  __typename?: 'ShiftObjectPromotionProgressEntity';
  /** Количество плохих смен */
  badShiftCount: Scalars['Int']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Количество хороших смен */
  goodShiftCount: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Бонусная программа */
  promotion: ObjectPromotionEntity;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type ShiftPenaltyEntity = {
  __typename?: 'ShiftPenaltyEntity';
  /** Стоимость штрафа (в руб.) */
  amount: Scalars['Float']['output'];
  /** Комментарий штрафа */
  comment?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Комментарий штрафа */
  note?: Maybe<Scalars['String']['output']>;
  /** Смена */
  shift: ShiftEntity;
  /** Статус штрафа */
  status: ShiftPenaltyStatusEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Статус штрафа */
export enum ShiftPenaltyStatus {
  Approved = 'APPROVED',
  New = 'NEW',
  Rejected = 'REJECTED'
}

/** Статус штрафа */
export enum ShiftPenaltyStatusEnum {
  /** Подтверждён */
  Approved = 'APPROVED',
  /** Новый */
  New = 'NEW',
  /** Отклонён */
  Rejected = 'REJECTED'
}

export type ShiftSalaryPaymentEntity = {
  __typename?: 'ShiftSalaryPaymentEntity';
  /** Причина надбавки */
  cause: Scalars['String']['output'];
  /** Комментарий к надбавке */
  comment: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Сумма надбавки */
  sum: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Shift NEW statuses */
export enum ShiftStage {
  Accepted = 'ACCEPTED',
  Finished = 'FINISHED',
  Ineligible = 'INELIGIBLE',
  New = 'NEW',
  Refused = 'REFUSED',
  Wasted = 'WASTED',
  Working = 'WORKING'
}

/** Стадия в которой находится смена */
export enum ShiftStageEnum {
  /** После модерации смена помечена как плохая */
  BadModeration = 'BAD_MODERATION',
  /** Завершена */
  Finished = 'FINISHED',
  /** После модерации смена помечена как хорошая */
  GoodModeration = 'GOOD_MODERATION',
  /** На модерации */
  InModeration = 'IN_MODERATION',
  /** Ожидание */
  Pending = 'PENDING',
  /** В работе */
  Working = 'WORKING'
}

/** Shift OLD status */
export enum ShiftStatus {
  PartAbsenteeism = 'PART_ABSENTEEISM',
  PartAccepted = 'PART_ACCEPTED',
  PartDefault = 'PART_DEFAULT',
  PartRefused = 'PART_REFUSED',
  PartRejected = 'PART_REJECTED',
  ShiftAbsenteeism = 'SHIFT_ABSENTEEISM',
  ShiftDefault = 'SHIFT_DEFAULT',
  ShiftPending = 'SHIFT_PENDING',
  ShiftRefused = 'SHIFT_REFUSED',
  ShiftRejected = 'SHIFT_REJECTED'
}

/** Текущий статус смены */
export enum ShiftStatusEnum {
  /** Принята */
  Accepted = 'ACCEPTED',
  /** Отменена */
  Cancelled = 'CANCELLED',
  /** Новая */
  New = 'NEW',
  /** Проигнорирована пользователем */
  NotAccepted = 'NOT_ACCEPTED',
  /** Отклонена после принятия */
  Rejected = 'REJECTED',
  /** Не выполнена */
  Wasted = 'WASTED'
}

/** Выбор смены: дневная или Ночная */
export enum ShiftTime {
  Day = 'DAY',
  Night = 'NIGHT',
  Undefined = 'UNDEFINED'
}

export type SignEditUserPaymentInfoInNaimixInput = {
  cardNumber: Scalars['String']['input'];
  smsCode: Scalars['String']['input'];
};

export type SignLoginMobileInput = {
  /** Код для подтверждения номера телефона */
  code: Scalars['String']['input'];
  /** Номер телефона пользователя */
  phone: Scalars['String']['input'];
};

export type SignRegisterUserInput = {
  /** Код для подтверждения номера телефона */
  code: Scalars['String']['input'];
  /** Номер телефона пользователя */
  phone: Scalars['String']['input'];
};

export type SignUserAgencyContractNaimixInput = {
  smsCode: Scalars['String']['input'];
};

export type SignUserFrameContractNaimixInput = {
  smsCode: Scalars['String']['input'];
  userContractId: Scalars['String']['input'];
};

/** DEPRECATED! DTO для создания одного экземпляра смены */
export type SingleShiftInput = {
  /** Дата и время начала смены в формате ISO */
  dateFrom: Scalars['DateTime']['input'];
  duration?: InputMaybe<Scalars['String']['input']>;
  /** id объекта, на который ставится смена */
  facilityId: Scalars['String']['input'];
  /** Длительность обеда в минутах */
  lunchDuration: Scalars['Int']['input'];
  /** id должности на которую ставится смена */
  positionId: Scalars['String']['input'];
  /** Дата и время окончания смены в формате ISO */
  shiftEndDate: Scalars['DateTime']['input'];
  /** id пользователя, на которого создается смена */
  userId: Scalars['String']['input'];
};

/** направление сортировки */
export enum SortingWay {
  Asc = 'asc',
  Desc = 'desc'
}

/** Шаг для фильтрации по периоду */
export enum StatisticPeriod {
  AllTime = 'ALL_TIME',
  Day = 'DAY',
  HalfYear = 'HALF_YEAR',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK',
  Year = 'YEAR'
}

/** Период агрегации метрик статистики */
export enum StatsAggregationPeriod {
  Day = 'DAY',
  Hour = 'HOUR',
  Month = 'MONTH',
  Week = 'WEEK'
}

/** сторис (как в instagram) */
export type Story = {
  __typename?: 'Story';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Group Id in ERP */
  erpGroupId?: Maybe<Scalars['String']['output']>;
  /** Source Id in ERP */
  erpSourceId?: Maybe<Scalars['String']['output']>;
  /** Информация о миниатюре "истории" */
  icon?: Maybe<File>;
  /** Цвет фона миниатюры */
  iconBackgroundColor: Scalars['String']['output'];
  /** Заголовок миниатюры */
  iconTitle?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Цифровой ID */
  number: Scalars['Int']['output'];
  /** Условия публикации */
  publicCondition?: Maybe<PublicCondition>;
  /** Дата начала публикации */
  publishFrom?: Maybe<Scalars['Date']['output']>;
  /** Текст уведомления */
  pushMessage?: Maybe<Scalars['String']['output']>;
  /** Заголовок уведомления */
  pushTitle?: Maybe<Scalars['String']['output']>;
  /** Реферальная программа, к которой привязана история */
  referralProgram?: Maybe<NewReferralProgramEntity>;
  /** Статус */
  stage?: Maybe<StoryStage>;
  storySlides?: Maybe<Array<StorySlide>>;
  storyViews?: Maybe<Array<StoryView>>;
  /** Название */
  title: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Количество просмотров истории */
  viewsCount: Scalars['Int']['output'];
};

/** поле по которому будет работать сортировка ((publishFrom = Дата начала публикации) */
export enum StoryFieldsSorting {
  PublishFrom = 'publishFrom',
  UpdatedAt = 'updatedAt'
}

export type StoryListInput = {
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<StoryFieldsSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Статус */
  stage?: InputMaybe<StoryStage>;
};

/** DTO для сохранения параметров публикации "Истории" */
export type StoryPublicConditionInput = {
  /** Массив ID городов */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Group Id in ERP */
  erpGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Source Id in ERP */
  erpSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Массив ID объектов */
  facilities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID групп объектов */
  facilityGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Бессрочность публикации */
  indefinitely?: InputMaybe<Scalars['Boolean']['input']>;
  /** Интервал для повторения рассылки */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Массив ID позиций (профессий) */
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Дата начала публикации */
  publishFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Дата окончания публикации */
  publishTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Текст уведомления */
  pushMessage?: InputMaybe<Scalars['String']['input']>;
  /** Заголовок уведомления */
  pushTitle?: InputMaybe<Scalars['String']['input']>;
  /** Фильтр по открепленным исполнителям */
  pushToUnassigned: PushToUnassignedFilter;
  /** Массив Ролей */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID "Истории" */
  storyId: Scalars['String']['input'];
  /** Показать группе пользователей да/нет */
  useCondition?: Scalars['Boolean']['input'];
};

/** Слайд "Истории" */
export type StorySlide = {
  __typename?: 'StorySlide';
  /** Id автора  */
  authorId: Scalars['String']['output'];
  /** Цвет фона слайда */
  backgroundColor: Scalars['String']['output'];
  /** Ссылка / Route / Мутация "кнопка 1" */
  buttonOneAction: Scalars['String']['output'];
  /** Текст на "кнопке 1" */
  buttonOneLabel: Scalars['String']['output'];
  /** Тип действия "кнопка 1" */
  buttonOneType?: Maybe<StorySlideButtonType>;
  /** Ссылка / Route / Мутация "кнопка 2" */
  buttonTwoAction: Scalars['String']['output'];
  /** Текст на "кнопке 2" */
  buttonTwoLabel: Scalars['String']['output'];
  /** Тип действия "кнопка 2" */
  buttonTwoType?: Maybe<StorySlideButtonType>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Информация о миниатюре "Истории" */
  image?: Maybe<File>;
  /** Файл миниатюры */
  imageId?: Maybe<Scalars['String']['output']>;
  /** Порядковый номер в "Истории" */
  index: Scalars['Int']['output'];
  /** Текст слайда */
  message: Scalars['String']['output'];
  /** Лейбл "вопрос 1" */
  questionOne: Scalars['String']['output'];
  /** Лейбл "вопрос 3" */
  questionThree: Scalars['String']['output'];
  /** Лейбл "вопрос 2" */
  questionTwo: Scalars['String']['output'];
  story: Story;
  /** Id "Истории", в которой будет показан слайд */
  storyId: Scalars['String']['output'];
  /** Заголовок слайда */
  title: Scalars['String']['output'];
  /** Статус */
  type?: Maybe<StorySlideType>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Types of Story Slide buttons */
export enum StorySlideButtonType {
  Link = 'LINK',
  Mutation = 'MUTATION',
  Route = 'ROUTE'
}

/** Types of Story Slide */
export enum StorySlideType {
  Button = 'BUTTON',
  Feedback = 'FEEDBACK',
  Image = 'IMAGE',
  TitleText = 'TITLE_TEXT',
  TitleTextButton = 'TITLE_TEXT_BUTTON',
  TitleTextFeedback = 'TITLE_TEXT_FEEDBACK',
  TitleTextTwoButtons = 'TITLE_TEXT_TWO_BUTTONS',
  TwoButtons = 'TWO_BUTTONS'
}

/** Story Life Cycle Statuses */
export enum StoryStage {
  Await = 'AWAIT',
  New = 'NEW',
  Published = 'PUBLISHED',
  Removed = 'REMOVED'
}

/** Таблица просмотра "Истории" */
export type StoryView = {
  __typename?: 'StoryView';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  story: Story;
  /** Id "Истории" */
  storyId: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Id "Пользователя" */
  userId: Scalars['String']['output'];
};

export type Subscribers = {
  __typename?: 'Subscribers';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  facility: Facility;
  /** Дата и время обновления */
  updatedAt: Scalars['Date']['output'];
  user: User;
};

export type Subscription = {
  __typename?: 'Subscription';
  bonusAndRateSub: BonusAndRate;
  /** Подписка для уведомления бригадиру о том, что работник начал или окончил смену */
  checkMarkForForeman: ForemanShift;
  contactPhoneSub: User;
  /** Подписка на удаление горячей смены */
  deleteTemporaryShift: TemporaryShiftUserId;
  /** Подписка на назначение горячей смены */
  deliveryAssignTemporaryShiftToForeman: TemporaryShiftUserId;
  /** Подписка для обновления лида на экране мои друзья */
  leadOutputSub: LeadOutput;
  /** Подписка для пользователя о том, что у него есть новое уведомление */
  newNotificationSub: Notification;
  newPartSub: Shift;
  /** Подписка на создание горячей смены */
  newTemporaryShift: TemporaryShiftUserId;
  /** "Подписка для обновления прогресса по акции "Двадцать одно" на экране мои друзья" */
  ochkoProgressSub: OchkoProgressOutput;
  /** Подписка о изменениях анкетных данных работника */
  questionnaireSub: Questionnaire;
  /** Подписка для уведомления бригадиру о том, что обновился список профессий */
  refreshForemanProfessions: CasingsForemanSubscriptionOutput;
  refreshRequestsList: ZayavkaProgress;
  refreshVacanciesOnMap: Array<Vacancy>;
  requisiteChangeSub: RatingUser;
  /** Подписка о изменениях графика для доставки бригадиру */
  scheduleForemanSub: ScheduleSubOutput;
  /** Подписка о изменениях графика для доставки работнику */
  scheduleWorkerSub: ScheduleSubOutput;
  /** Подписка о изменениях смены для доставки бригадиру */
  shiftForemanSub: ShiftForemanSubOutput;
  /** Подписка о изменениях смены для доставки работнику */
  shiftPenaltySub: ShiftPenaltyEntity;
  /** Подписка о изменениях смены для доставки работнику */
  shiftWorkerSub: Shift;
  /** Подписка об изменении истории */
  storyChangeSub: Story;
  /** Подписка для поднятия истории в списке */
  storyRaiseUpSub: Story;
  updateMobileApp: Scalars['String']['output'];
  /** Подписка о изменениях профессии на объекте для доставки бригадиру */
  workPostForemanSub: WorkPostForemanSubOutput;
  /** Подписка о изменениях графика для доставки работнику */
  workPostWorkerSub: WorkPostWorkerSubOutput;
  zayavkaChangesSub: ZayavkaProgress;
};


export type SubscriptionBonusAndRateSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionCheckMarkForForemanArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionContactPhoneSubArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionDeleteTemporaryShiftArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionDeliveryAssignTemporaryShiftToForemanArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionLeadOutputSubArgs = {
  referrerId: Scalars['ID']['input'];
};


export type SubscriptionNewNotificationSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionNewPartSubArgs = {
  facilityId: Scalars['ID']['input'];
};


export type SubscriptionNewTemporaryShiftArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionOchkoProgressSubArgs = {
  referrerId: Scalars['ID']['input'];
};


export type SubscriptionQuestionnaireSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionRefreshForemanProfessionsArgs = {
  foremanId: Scalars['ID']['input'];
};


export type SubscriptionRequisiteChangeSubArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionScheduleForemanSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionScheduleWorkerSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionShiftForemanSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionShiftPenaltySubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionShiftWorkerSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionStoryChangeSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionStoryRaiseUpSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionWorkPostForemanSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionWorkPostWorkerSubArgs = {
  userId: Scalars['ID']['input'];
};


export type SubscriptionZayavkaChangesSubArgs = {
  id: Scalars['ID']['input'];
};

export type Supervisors = {
  __typename?: 'Supervisors';
  A: Scalars['String']['output'];
  B: Scalars['String']['output'];
  facility: Facility;
  user: User;
};

/** Статус проверки самозанятости в Наймикс */
export enum TaxPartnerInfo {
  Confirmed = 'CONFIRMED',
  NotChecked = 'NOT_CHECKED',
  NotConfirmed = 'NOT_CONFIRMED'
}

export type TemporaryShift = {
  __typename?: 'TemporaryShift';
  /** Id автора смены */
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время конца */
  dateEnd: Scalars['Date']['output'];
  /** Дата начала смены */
  dateFrom: Scalars['Date']['output'];
  /** Объект смены */
  facility: Facility;
  /** Id объекта смены */
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** длительность обеда в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Тип выплаты за работу */
  payout?: Maybe<PayoutType>;
  /** Позиция смены */
  position: Position;
  /** Id позиции смены */
  positionId: Scalars['String']['output'];
  /** Id смены которая назначена работнику */
  shiftId?: Maybe<Scalars['String']['output']>;
  /** Единицы измерения для оплаты */
  unit?: Maybe<UnitType>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Модель для доставки подписок о подработках ("горячих" смен) */
export type TemporaryShiftUserId = {
  __typename?: 'TemporaryShiftUserID';
  /** Смена которую надо доставить бригадиру */
  shift?: Maybe<Shift>;
  /** Тип выплаты за работу */
  temporaryShift?: Maybe<TemporaryShift>;
  /** Id пользователя которому нужно доставить подписку */
  userId: Scalars['String']['output'];
};

export type Token = {
  __typename?: 'Token';
  /** JWT access token */
  accessToken: Scalars['String']['output'];
  /** JWT refresh token */
  refreshToken: Scalars['String']['output'];
};

export type UnassignUserOnWorkPostInput = {
  /** Идентификатор объекта на котором пользователя нужно разжаловать */
  objectId?: InputMaybe<Scalars['ID']['input']>;
  /** Идентификатор пользователя */
  userId?: InputMaybe<Scalars['ID']['input']>;
  /** Идентификатор рабочего места пользователя */
  workPostId?: InputMaybe<Scalars['ID']['input']>;
};

export type UnassignWorkerFromFacilityGroupInput = {
  /** ID группы объектов */
  facilityGroupId: Scalars['String']['input'];
  /** Дата увольнения */
  unassignAt: Scalars['DateTime']['input'];
  /** Комментарий при увольнении работника */
  unassignComment?: InputMaybe<Scalars['String']['input']>;
  /** ID исполнителя */
  userId: Scalars['String']['input'];
};

export type UnassignWorkerFromFacilityInput = {
  /** ID объекта */
  facilityId: Scalars['String']['input'];
  /** Дата увольнения */
  unassignAt: Scalars['DateTime']['input'];
  /** Комментарий при увольнении работника */
  unassignComment?: InputMaybe<Scalars['String']['input']>;
  /** ID исполнителя */
  userId: Scalars['String']['input'];
};

export type UnassignWorkerFromPositionInput = {
  /** ID объекта */
  facilityId: Scalars['String']['input'];
  /** ID профессии */
  positionId: Scalars['String']['input'];
  /** Дата увольнения */
  unassignAt: Scalars['DateTime']['input'];
  /** Комментарий при увольнении работника */
  unassignComment?: InputMaybe<Scalars['String']['input']>;
  /** ID исполнителя */
  userId: Scalars['String']['input'];
};

/** Единицы измерения для оплаты */
export enum UnitType {
  Hour = 'HOUR',
  Piece = 'PIECE',
  Point = 'POINT'
}

export type UpdateFacilitiesActivityInput = {
  /** Массив идентификаторов объектов */
  facilitiesIds: Array<Scalars['String']['input']>;
  /** Флаг активности */
  is_active: Scalars['Boolean']['input'];
};

export type UpdateFacilitiesLegalEntitiesInput = {
  /** Массив идентификаторов объектов */
  facilitiesIds: Array<Scalars['String']['input']>;
  /** Идентификатор юр. лица */
  legalEntityId: Scalars['String']['input'];
};

export type UpdateLeadInput = {
  date: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  isProcessed?: Scalars['Boolean']['input'];
  status?: LeadStatus;
};

/** Параметры для обновления push-уведомления */
export type UpdateNotifyLetterInput = {
  /** Текст уведомления */
  body?: InputMaybe<Scalars['String']['input']>;
  /** Массив ID городов */
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID объектов */
  facilities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Массив ID групп объектов */
  facilityGroups?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID уведомления */
  id: Scalars['String']['input'];
  /** Бессрочность публикации */
  indefinitely?: InputMaybe<Scalars['Boolean']['input']>;
  /** Интервал для повторения рассылки */
  interval?: InputMaybe<Scalars['Int']['input']>;
  /** Название уведомления */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Массив ID позиций (профессий) */
  positions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ID параметров публикации */
  publicConditionId: Scalars['String']['input'];
  /** Дата начала публикации */
  publishFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Дата окончания публикации */
  publishTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Фильтр по открепленным исполнителям */
  pushToUnassigned: PushToUnassignedFilter;
  /** Массив Ролей */
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Ссылка для перенаправления */
  route?: InputMaybe<PushRoute>;
  /** Статус пуш уведомления */
  status?: InputMaybe<NotifyLetterStatus>;
  /** Заголовок уведомления */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Показать группе пользователей да/нет */
  useCondition?: Scalars['Boolean']['input'];
};

export type UpdateShiftModerationInput = {
  /** Идентификатор смены */
  shiftId: Scalars['ID']['input'];
  /** Отправить бонус к оплате? */
  toPaymentBonus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStoryInput = {
  /** Group Id in ERP */
  erpGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Source Id in ERP */
  erpSourceId?: InputMaybe<Scalars['String']['input']>;
  /** Цвет фона миниатюры */
  iconBackgroundColor?: Scalars['String']['input'];
  /** Название "истории" (в мобильном приложении поверх миниатюры */
  iconTitle: Scalars['String']['input'];
  id: Scalars['String']['input'];
  /** Название "истории" (внутри dashboard) */
  title: Scalars['String']['input'];
};

export type UpdateStorySlideInput = {
  /** Цвет фона слайда */
  backgroundColor?: Scalars['String']['input'];
  buttonOneAction?: Scalars['String']['input'];
  buttonOneLabel?: Scalars['String']['input'];
  /** Тип действия "кнопка 1" */
  buttonOneType?: InputMaybe<StorySlideButtonType>;
  buttonTwoAction?: Scalars['String']['input'];
  buttonTwoLabel?: Scalars['String']['input'];
  /** Тип действия "кнопка 2" */
  buttonTwoType?: InputMaybe<StorySlideButtonType>;
  id: Scalars['String']['input'];
  message?: Scalars['String']['input'];
  questionOne?: Scalars['String']['input'];
  questionThree?: Scalars['String']['input'];
  questionTwo?: Scalars['String']['input'];
  title?: Scalars['String']['input'];
};

export type UpdateUserEmailInput = {
  /** Email пользователя */
  email: Scalars['String']['input'];
  /** Идентификатор пользователя */
  userId: Scalars['String']['input'];
};

export type UpdateUserInput = {
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix?: InputMaybe<Scalars['Boolean']['input']>;
  /** Дата рождения */
  birthDate?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор страны, гражданином которой является пользователь */
  citizenshipId?: InputMaybe<Scalars['String']['input']>;
  /** id города пользователя */
  cityFiasId?: InputMaybe<Scalars['String']['input']>;
  /** id города пользователя */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Название города пользователя */
  cityName?: InputMaybe<Scalars['String']['input']>;
  /** Email адрес */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Id Пользователя в ERP */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** Имя пользователя */
  firstname: Scalars['String']['input'];
  /** Идентификатор пользователя */
  id: Scalars['String']['input'];
  /** Фамилия пользователя */
  lastname: Scalars['String']['input'];
  /** Отчество пользователя */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  /** Номер телефона пользователя */
  phone: Scalars['String']['input'];
  /** Роль пользователя в системе */
  role?: InputMaybe<Role>;
  /** Пол */
  sex?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserNaimixWorkStatusInput = {
  /** Разрешить пользователю работу без Наймикс? */
  allowWorkWithoutNaimix: Scalars['Boolean']['input'];
  /** Идентификатор пользователя */
  userId: Scalars['String']['input'];
};

export type UpdateUserNameAndCitizenshipInput = {
  /** Идентификатор гражданства пользователя */
  citizenshipId: Scalars['String']['input'];
  /** Имя пользователя */
  firstname: Scalars['String']['input'];
  /** Фамилия пользователя */
  lastname: Scalars['String']['input'];
  /** Отчество пользователя */
  patronymic?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор пользователя */
  userId: Scalars['String']['input'];
};

export type UpdateUserVersionInput = {
  currentVersion: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UploadPhotoInObjectPhotoGalleryInput = {
  /** Идентификатор объекта */
  objectId: Scalars['ID']['input'];
  /** Фотография */
  photo: Scalars['Upload']['input'];
};

export type UploadPhotoInObjectProfessionPhotoGalleryInput = {
  /** Идентификатор профессии объекта */
  objectProfessionId: Scalars['ID']['input'];
  /** Фотография */
  photo: Scalars['Upload']['input'];
};

export type User = {
  __typename?: 'User';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

export type UserActivityLog = {
  __typename?: 'UserActivityLog';
  action: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  entity: Scalars['String']['output'];
  entityId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  user: User;
  userId: Scalars['String']['output'];
  values: Scalars['String']['output'];
};

/** DTO логирования действий пользователей */
export type UserActivityLogInput = {
  /** совершенное действие UPPERCASE !!! */
  action: Scalars['String']['input'];
  /** Тип сущности с которой совершено действие UPPERCASE !!! */
  entity: Scalars['String']['input'];
  /** id сущности с которой совершено действие */
  entityId?: InputMaybe<Scalars['String']['input']>;
  /** Необязательное поле */
  userId?: InputMaybe<Scalars['String']['input']>;
  /** JSON с объектом действия пользователя */
  values: Scalars['String']['input'];
};

export type UserArrivalNoticeInfoEntity = {
  __typename?: 'UserArrivalNoticeInfoEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата постановки на учёт */
  registrationDate: Scalars['String']['output'];
  /** Адрес пребывания */
  residenceAddress: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания срока действия */
  validToDate: Scalars['String']['output'];
};

/** Договора исполнителя */
export type UserContract = {
  __typename?: 'UserContract';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Объект, к которому относится договор */
  legalEntity?: Maybe<LegalEntity>;
  legalEntityId?: Maybe<Scalars['String']['output']>;
  /** Статус договора */
  status: UserContractStatus;
  /** Тип договора */
  type: UserContractType;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Ссылка на скачивание договора */
  url?: Maybe<Scalars['String']['output']>;
  user: User;
  /** Id пользователя */
  userId: Scalars['String']['output'];
};

/** Статус подписания договора */
export enum UserContractNaimixStatusEnum {
  /** Архивирован */
  Archived = 'ARCHIVED',
  /** Подписан */
  Signed = 'SIGNED',
  /** Не подписан */
  Unsigned = 'UNSIGNED'
}

/** Поля сортировки списка договоров */
export enum UserContractSorting {
  CreatedAt = 'createdAt',
  Lastname = 'lastname',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

/** Статус договора */
export enum UserContractStatus {
  Archived = 'Archived',
  Signed = 'Signed',
  Unsigned = 'Unsigned'
}

/** Тип договора */
export enum UserContractType {
  /** Агентский договор */
  AgentContract = 'AgentContract',
  /** Рамочный договор НПД */
  FrameContract = 'FrameContract',
  /** Согласие на обработку ПД */
  ProcessPersonalInfoContract = 'ProcessPersonalInfoContract'
}

/** Постраничный вывод списка договоров */
export type UserContractsPaginatedOutput = {
  __typename?: 'UserContractsPaginatedOutput';
  /** Список договоров */
  contracts: Array<UserContract>;
  /** Всего элементов' */
  count: Scalars['Int']['output'];
  /** Количество страниц */
  pages: Scalars['Int']['output'];
};

/** Модель устройства пользователя */
export type UserDevice = {
  __typename?: 'UserDevice';
  /** Поддержка Google сервисов */
  hasGoogleServices: Scalars['Boolean']['output'];
  /** Поддержка Huawei сервисов */
  hasHuaweiServices: Scalars['Boolean']['output'];
  /** Модель устройства */
  model: Scalars['String']['output'];
  user: User;
  /** Id пользователя */
  userId: Scalars['String']['output'];
};

export type UserDeviceEntity = {
  __typename?: 'UserDeviceEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Текущая версия приложения */
  currentApplicationVersion: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Модель телефона */
  model: Scalars['String']['output'];
  /** Тип ОС */
  type: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user: User;
};

export type UserDeviceInput = {
  /** Поддерживает ли Google сервисы */
  hasGoogleServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Поддерживает ли Huawei сервисы */
  hasHuaweiServices?: InputMaybe<Scalars['Boolean']['input']>;
  /** Название устройства пользователя */
  model?: InputMaybe<Scalars['String']['input']>;
};

/** Тип ОС пользователя */
export enum UserDeviceTypeEnum {
  /** Андроид */
  Android = 'ANDROID',
  /** Хуавей */
  Huawei = 'HUAWEI',
  /** АйОс */
  Ios = 'IOS'
}

export type UserDocumentEntity = {
  __typename?: 'UserDocumentEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Документ */
  file: File;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  reviewer: UserEntity;
  /** Статус проверки документа */
  status?: Maybe<UserDocumentStatusEnum>;
  /** Тип документа */
  type: UserDocumentTypeEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Владелец документа */
  user: UserEntity;
};

/** Статус проверки документа */
export enum UserDocumentStatusEnum {
  /** Принято */
  Accepted = 'ACCEPTED',
  /** Отклонено */
  Rejected = 'REJECTED'
}

/** Тип загружаемого документа */
export enum UserDocumentTypeEnum {
  /** Уведомление о прибытии первая сторона */
  ArrivalNotificationFirstSide = 'ARRIVAL_NOTIFICATION_FIRST_SIDE',
  /** Уведомление о прибытии вторая сторона */
  ArrivalNotificationSecondSide = 'ARRIVAL_NOTIFICATION_SECOND_SIDE',
  /** Место рождения в иностранном паспорте */
  ForeignPassportBirthPlace = 'FOREIGN_PASSPORT_BIRTH_PLACE',
  /** Информация о иностранном паспорте */
  ForeignPassportPersonalInformation = 'FOREIGN_PASSPORT_PERSONAL_INFORMATION',
  /** Задняя сторона внутреннего паспорта */
  InternalPassportBackSide = 'INTERNAL_PASSPORT_BACK_SIDE',
  /** Главная страница паспорта */
  MainPage = 'MAIN_PAGE',
  /** Медицинская справка */
  MedicalInvoice = 'MEDICAL_INVOICE',
  /** Миграционная карта */
  MigrationCard = 'MIGRATION_CARD',
  /** Задняя сторона миграционной карты */
  MigrationCardBackSide = 'MIGRATION_CARD_BACK_SIDE',
  /** 2-3 страницы медицинской книжки */
  Page2_3 = 'PAGE2_3',
  /** 28-29 страницы медицинской книжки */
  Page28_29 = 'PAGE28_29',
  /** Скан нотариально завершенного перевода паспорта */
  PassportTranslationNotarizationScan = 'PASSPORT_TRANSLATION_NOTARIZATION_SCAN',
  /** Скан перевода паспорта */
  PassportTranslationScan = 'PASSPORT_TRANSLATION_SCAN',
  /** Страница регистрации паспорта */
  Registration = 'REGISTRATION',
  /** Селфи с паспортом */
  Selfie = 'SELFIE'
}

export type UserEntity = {
  __typename?: 'UserEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Устройства */
  devices: Array<UserDeviceEntity>;
  /** Документы пользователя */
  documents: UserDocumentEntity;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Подтверждён ли номер телефона */
  isPhoneApproved: Scalars['Boolean']['output'];
  /** Договора */
  naimixContracts: Array<UserNaimixContractEntity>;
  /** Прогресс прохождения регистрации в Наймикс */
  naimixRegistrationState?: Maybe<UserNaimixRegistrationStateEntity>;
  /** Номер телефона */
  phone: Scalars['String']['output'];
  /** Профиль пользователя */
  profile: UserProfileEntity;
  /** Рейтинг пользователя */
  rating: UserRatingEntity;
  /** Запись о текущем пользователе, как реферале */
  referral?: Maybe<UserReferralEntity>;
  /** Реквизиты пользователя */
  requisite?: Maybe<UserRequisiteEntity>;
  /** На каких объектах пользователь назначен ответственным */
  responsibleAtObjects: Array<ObjectEntity>;
  /** Роль */
  role: UserRoleEnum;
  /** Настройки пользователя */
  settings: UserSettingEntity;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Должности */
  workPosts: Array<WorkPostEntity>;
};

/** Хранение истории опыта работника */
export type UserExperience = {
  __typename?: 'UserExperience';
  /** Дата назначения работника на должность */
  assignedAt?: Maybe<Scalars['Date']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facility?: Maybe<Facility>;
  /** Id объекта */
  facilityId: Scalars['String']['output'];
  /** Дата первой смены на должности */
  firstShiftAt?: Maybe<Scalars['Date']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  lastShiftAt?: Maybe<Scalars['Date']['output']>;
  position?: Maybe<Position>;
  /** Id должности (из справочника позиций) */
  positionId: Scalars['String']['output'];
  /** Дата снятия работника с должности */
  unassignAt?: Maybe<Scalars['Date']['output']>;
  /** Комментарий при увольнении */
  unassignComment?: Maybe<Scalars['String']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
  /** Id пользователя */
  userId: Scalars['String']['output'];
};

/** поле по которому будет работать сортировка */
export enum UserFieldsForSorting {
  ActiveShifts = 'activeShifts',
  CreatedAt = 'createdAt',
  CurrentVersion = 'currentVersion',
  LastLoginAt = 'lastLoginAt',
  Lastname = 'lastname',
  PaymentInfo = 'paymentInfo',
  PersonalInfo = 'personalInfo',
  Phone = 'phone',
  Rating = 'rating',
  RequisiteUpdatedAt = 'requisiteUpdatedAt',
  TaxPartnerInfo = 'taxPartnerInfo',
  UpdatedAt = 'updatedAt'
}

export type UserFinanceInfoEntity = {
  __typename?: 'UserFinanceInfoEntity';
  /** Номер счёта */
  accountNumber: Scalars['String']['output'];
  /** Название банка */
  bankName: Scalars['String']['output'];
  /** Банковский идентификационный код (БИК) */
  bic: Scalars['String']['output'];
  /** Держатель карты */
  cardholderName: Scalars['String']['output'];
  /** Корр. счёт */
  correspondentAccount: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Действительна до, месяц */
  validThruMonth: Scalars['Int']['output'];
  /** Действительна до, год */
  validThruYear: Scalars['Int']['output'];
};

export type UserGrade = {
  __typename?: 'UserGrade';
  /** Автор оценки */
  author: User;
  character: Scalars['Int']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  position?: Maybe<Position>;
  positionId: Scalars['String']['output'];
  responsiveness: Scalars['Int']['output'];
  speed: Scalars['Int']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user: User;
  userId: Scalars['String']['output'];
};

/** отображение пользователя с пересечениями его смен */
export type UserIntersect = {
  __typename?: 'UserIntersect';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Смены пользователя c которыми найдено пересечения */
  intersect?: Maybe<Array<Shift>>;
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

export type UserListInput = {
  citizenshipId?: InputMaybe<Scalars['String']['input']>;
  /** Статус подписания договоров */
  contractStatus?: InputMaybe<UserContractStatus>;
  /** Статус проверки документов */
  documentsStatus?: InputMaybe<DocumentsStatus>;
  facilityGroupId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Фильтр по активности пользователя */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Фильтр по сотрудничают/не сотрудничают с объектом */
  isCooperateWithGroup?: InputMaybe<Scalars['Boolean']['input']>;
  /** номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Заполненены ли платежные данные */
  paymentInfo?: InputMaybe<PaymentInfoEnum>;
  /** Статус заполнения персональной информации */
  personalInfo?: InputMaybe<UserPersonalInfoStatus>;
  /** Роль пользователя */
  role?: InputMaybe<Role>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<UserFieldsForSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Добавлено ли приложение "Мой налог" в партнеры */
  taxPartnerInfo?: InputMaybe<TaxPartnerInfo>;
};

export type UserMedicalInfoEntity = {
  __typename?: 'UserMedicalInfoEntity';
  /** Дата конца аттестации */
  attestationEnd: Scalars['String']['output'];
  /** Дата начала аттестации */
  attestationStart: Scalars['String']['output'];
  /** Дата выдачи медицинской справки о прохождении осмотра перед получением медицинской книжки */
  certificateIssueDate: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Ожидаемая дата выдачи после получения справки */
  expectedReceiptDate: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Номер */
  number: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserMigrationCardInfoEntity = {
  __typename?: 'UserMigrationCardInfoEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата выдачи */
  issueDate: Scalars['String']['output'];
  /** Номер */
  number: Scalars['String']['output'];
  /** Серия */
  series: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Действительна до */
  validToDate: Scalars['String']['output'];
};

export type UserNaimixContractEntity = {
  __typename?: 'UserNaimixContractEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Ссылка на договор */
  link?: Maybe<Scalars['String']['output']>;
  /** Статус подписания договора */
  status: UserContractNaimixStatusEnum;
  /** Тип договора */
  type: UserNaimixContractTypeEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user: UserEntity;
};

/** Тип контракта */
export enum UserNaimixContractTypeEnum {
  /** Агентский договор */
  AgentContract = 'AGENT_CONTRACT',
  /** Рамочный договор */
  FrameContract = 'FRAME_CONTRACT',
  /** Договор о персональных данных */
  ProcessPersonalInfoContract = 'PROCESS_PERSONAL_INFO_CONTRACT'
}

export type UserNaimixRegistrationStateEntity = {
  __typename?: 'UserNaimixRegistrationStateEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Статус подписания АД и ПД */
  isAdAndPdSigned: Scalars['Boolean']['output'];
  /** Статус проверки платёжных данных */
  paymentInfo: NaimixRegistrationCheckStatusEnum;
  /** Статус проверки персональной информации */
  personalInfo: NaimixRegistrationPersonalInfoStatusEnum;
  /** Причина отклонения данных пользователя при регистрации */
  personalInfoDeclineReason?: Maybe<Scalars['String']['output']>;
  /** Статус прогресса регистрации пользователя */
  progress: UserNaimixRegistrationStateProgressEnum;
  /** Статус проверки самозанятости */
  taxPartnerInfo: NaimixRegistrationCheckStatusEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Настройки пользователя */
  user: UserEntity;
};

/** Статус прогресса регистрации в Наймикс */
export enum UserNaimixRegistrationStateProgressEnum {
  /** Полная регистрация */
  FullRegistration = 'FULL_REGISTRATION',
  /** Неполная регистрация */
  IncompleteRegistration = 'INCOMPLETE_REGISTRATION',
  /** Не проверялось */
  NotChecked = 'NOT_CHECKED',
  /** Не зарегистрирован */
  NotRegistered = 'NOT_REGISTERED'
}

export type UserPassportInfoEntity = {
  __typename?: 'UserPassportInfoEntity';
  /** Дата рождения */
  birthDate: Scalars['String']['output'];
  /** Место рождения */
  birthPlace: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Идентификационный номер */
  identificationNumber: Scalars['String']['output'];
  /** Кем выдан */
  issuedBy: Scalars['String']['output'];
  /** Когда выдан */
  issuedDate: Scalars['String']['output'];
  /** Код подразделения */
  issuerCode: Scalars['String']['output'];
  /** Номер */
  number: Scalars['String']['output'];
  /** Прописка */
  registrationAddress: Scalars['String']['output'];
  /** Серия */
  series: Scalars['String']['output'];
  /** Тип паспорта */
  type: PassportTypeEnum;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Действителен до */
  validToDate: Scalars['String']['output'];
};

/** Статус проверки персональных данных в Наймикс */
export enum UserPersonalInfoStatus {
  PersonalDataNotSent = 'PERSONAL_DATA_NOT_SENT',
  PersonalDataNotVerified = 'PERSONAL_DATA_NOT_VERIFIED',
  PersonalDataSent = 'PERSONAL_DATA_SENT',
  PersonalDataVerified = 'PERSONAL_DATA_VERIFIED'
}

export type UserPhysicalInfoEntity = {
  __typename?: 'UserPhysicalInfoEntity';
  /** Размер одежды */
  clothingSize: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Размер ноги */
  footSize: Scalars['Int']['output'];
  /** Пол */
  gender: GenderEnum;
  /** Рост */
  growth: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserProfileEntity = {
  __typename?: 'UserProfileEntity';
  /** Гражданство */
  citizenship?: Maybe<CountryEntity>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** Имя */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Фамилия */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Отчество */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserRatingEntity = {
  __typename?: 'UserRatingEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Исполнительность */
  diligence: Scalars['Int']['output'];
  /** Дисциплина работника */
  discipline: Scalars['Int']['output'];
  /** Заполненность документов работником */
  documents: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Насколько часто работник получает штрафы */
  penalization: Scalars['Int']['output'];
  /** Работоспособность */
  performance: Scalars['Int']['output'];
  /** Рейтинг работника */
  rating: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Работник к которому относится оценка */
  user?: Maybe<UserEntity>;
};

export type UserReferralEntity = {
  __typename?: 'UserReferralEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  executionReferralProgramDatetime: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  referralPaymentDatetime: Scalars['Date']['output'];
  /** Реферальная программа, по которой был приглашён пользователь */
  referralProgram: ReferralProgramEntity;
  referrerPaymentDatetime: Scalars['Date']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserRegistrationState = {
  __typename?: 'UserRegistrationState';
  /** Статус подписания АД и согласия на обработку ПД */
  adAndPdState: ApAndPdStateEnum;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  deletedAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Заполнены ли платежные данные */
  paymentInfo: PaymentInfoEnum;
  /** Статус заполнения персональной информации */
  personalInfo: UserPersonalInfoStatus;
  /** Причина отклонения персональных данных */
  personalInfoDeclineReason?: Maybe<Scalars['String']['output']>;
  /** Статус регистрации в Наймикс */
  registrationInNaimixState: RegistrationInNaimixStateEnum;
  /** Добавлено ли приложение "Мой налог" в партнеры */
  taxPartnerInfo: TaxPartnerInfo;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user: User;
  userId: Scalars['String']['output'];
};

export type UserRequisiteEntity = {
  __typename?: 'UserRequisiteEntity';
  /** Информация об уведомлении о прибытии пользователя */
  arrivalNoticeInfo: UserArrivalNoticeInfoEntity;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Платёжная информация пользователя */
  financeInfo: UserFinanceInfoEntity;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Информация о медкнижке пользователя */
  medicalInfo: UserMedicalInfoEntity;
  /** Информация о миграционной карте пользователя */
  migrationCardInfo: UserMigrationCardInfoEntity;
  /** Паспортная информация пользователя */
  passportInfo: UserPassportInfoEntity;
  /** Информация о физических параметрах пользователя */
  physicalInfo: UserPhysicalInfoEntity;
  /** Информация о самозанятости пользователя */
  taxInfo: UserTaxInfoEntity;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserReview = {
  __typename?: 'UserReview';
  /** Автор отзыва */
  author: User;
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isGood?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Position>;
  positionId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId: Scalars['String']['output'];
};

/** Роль пользователя */
export enum UserRoleEnum {
  /** Администратор */
  Admin = 'ADMIN',
  /** Директор на стороне клиента */
  ClientDirector = 'CLIENT_DIRECTOR',
  /** Менеджер на стороне клиента */
  ClientManager = 'CLIENT_MANAGER',
  /** Бригадир */
  Foreman = 'FOREMAN',
  /** Ньюби (новый пустой пользователь) */
  Newbie = 'NEWBIE',
  /** Супервайзер */
  Supervisor = 'SUPERVISOR',
  /** Работник */
  Worker = 'WORKER'
}

export type UserScheduleStatusInput = {
  /** Статус, который будет установлен для графика */
  confirmedSchedule: ScheduleStage;
  /** id графика, если не передается, то статус изменится у всех графиков */
  scheduleId: Scalars['String']['input'];
};

export type UserSettingEntity = {
  __typename?: 'UserSettingEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Пользователь дал согласие на отправку ему email? */
  isAllowSendEmail: Scalars['Boolean']['output'];
  /** Пользователь дал согласие на отправку ему мобильных пушей? */
  isAllowSendMobilePush: Scalars['Boolean']['output'];
  /** Пользователь дал согласие на отправку ему смс? */
  isAllowSendSms: Scalars['Boolean']['output'];
  /** Пользователь может работать без Наймикс? */
  isAllowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type UserStatusInput = {
  isActive: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};

export type UserTaxInfoEntity = {
  __typename?: 'UserTaxInfoEntity';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** ИНН */
  inn: Scalars['String']['output'];
  /** Самозанятый? */
  isSelfEmployed: Scalars['Boolean']['output'];
  /** Дата становления самозанятым */
  selfEmployedDate: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type Vacancy = {
  __typename?: 'Vacancy';
  /** Средняя стоимость оплаты по смене */
  averageCost: Scalars['Float']['output'];
  /** Массив IDs стран */
  citizenshipsIds?: Maybe<Array<Scalars['String']['output']>>;
  coverPhoto?: Maybe<File>;
  coverPhotoId?: Maybe<Scalars['String']['output']>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Описание */
  description?: Maybe<Scalars['String']['output']>;
  /** Примечание к документам */
  documentsNotes?: Maybe<Scalars['String']['output']>;
  /** Group Id in ERP */
  erpGroupId?: Maybe<Scalars['String']['output']>;
  /** Инстанс ERP */
  erpInstance?: Maybe<ErpInstanceEntity>;
  /** Source Id in ERP */
  erpSourceId?: Maybe<Scalars['String']['output']>;
  facility: Facility;
  facilityId: Scalars['String']['output'];
  /** Возможность образования */
  hasEducation?: Maybe<Scalars['Boolean']['output']>;
  /** Ставка в час */
  hourRate: Scalars['Float']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Публиковать ли стоимость смены */
  isPublishCostOfShift: Scalars['Boolean']['output'];
  /** Отображать в вакансии диапазон стоимости ОТ-ДО */
  isRangeCost: Scalars['Boolean']['output'];
  /** Вакансия активна/не активна */
  is_active: Scalars['Boolean']['output'];
  /** Длительность обеденного перерыва в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Максимальный возраст */
  maxAge?: Maybe<Scalars['Int']['output']>;
  /** Минимальный возраст */
  minAge?: Maybe<Scalars['Int']['output']>;
  /** Примечание */
  notes?: Maybe<Scalars['String']['output']>;
  /** Тип выплаты за работу */
  payout?: Maybe<PayoutType>;
  /** Частота выплат */
  payoutFrequency?: Maybe<PayoutFrequency>;
  /** Ночь или день */
  period: ShiftTime;
  position?: Maybe<Position>;
  positionId: Scalars['String']['output'];
  /** Кол-во дней стажировки */
  probationPeriod?: Maybe<Scalars['Int']['output']>;
  /** Необходимые документы */
  requiredDocuments: Array<CasingDocumentType>;
  /** Требования */
  requirements?: Maybe<Scalars['String']['output']>;
  responders?: Maybe<Array<User>>;
  /** Обязанности */
  responsibilities?: Maybe<Scalars['String']['output']>;
  /**
   * ID типов графиков
   * @deprecated Отказываемся от этого поля
   */
  scheduleTypesIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Отдел или секция */
  section?: Maybe<Scalars['String']['output']>;
  /** Пол */
  sex?: Maybe<Sex>;
  /** Минимальная стоимость оплаты по смене от */
  shiftCostFrom: Scalars['Float']['output'];
  /** Максимальная стоимость оплаты по смене до */
  shiftCostUpTo: Scalars['Float']['output'];
  /** Продолжительность смены в часах */
  shiftDuration?: Maybe<Scalars['Int']['output']>;
  /** Конец смены */
  timeEnd: Scalars['String']['output'];
  /** Начало смены */
  timeStart: Scalars['String']['output'];
  /** Транспорт */
  transport?: Maybe<Scalars['String']['output']>;
  /** Единицы измерения для оплаты */
  unit?: Maybe<UnitType>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Документы одобренные у пользователя */
  userDocuments?: Maybe<Array<CasingDocumentType>>;
  /** Спец. одежда */
  workwear: Scalars['Boolean']['output'];
};

/** поле по которому будет работать сортировка (publishFrom = Дата начала публикации) */
export enum VacancyFieldsSorting {
  City = 'city',
  Facility = 'facility',
  FacilityGroup = 'facilityGroup',
  Position = 'position',
  Schedule = 'schedule',
  TimeStart = 'timeStart',
  UpdatedAt = 'updatedAt'
}

export type VacancyGallery = {
  __typename?: 'VacancyGallery';
  casingGallery: Array<CasingGalleryEntity>;
  facilityGallery: Array<FacilityGalleryEntity>;
};

export type VacancyInput = {
  /** Средняя стоимость оплаты по смене */
  averageCost?: Scalars['Float']['input'];
  /** IDs стран */
  citizenshipsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Идентификатор фотографии альбома */
  coverPhotoId?: InputMaybe<Scalars['ID']['input']>;
  /** Описание */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Примечание к документам */
  documentsNotes?: InputMaybe<Scalars['String']['input']>;
  /** Group Id in ERP */
  erpGroupId?: InputMaybe<Scalars['String']['input']>;
  /** Идентификатор нстанса для отправки в ERP */
  erpInstanceId?: InputMaybe<Scalars['String']['input']>;
  /** Source Id in ERP */
  erpSourceId?: InputMaybe<Scalars['String']['input']>;
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Возможность образования */
  hasEducation?: InputMaybe<Scalars['Boolean']['input']>;
  hourRate: Scalars['Float']['input'];
  isActive?: Scalars['Boolean']['input'];
  isDeleted?: Scalars['Boolean']['input'];
  /** публиковать стоимость смены */
  isPublishCostOfShift?: Scalars['Boolean']['input'];
  /** Отображать в вакансии диапазон стоимости ОТ-ДО */
  isRangeCost?: Scalars['Boolean']['input'];
  /** Длительность обеденного перерыва в минутах */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** Максимальный возраст */
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  /** Минимальный возраст */
  minAge?: InputMaybe<Scalars['Int']['input']>;
  /** Примечание */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Тип выплаты за работу */
  payout?: InputMaybe<PayoutType>;
  /** Частота выплат */
  payoutFrequency?: InputMaybe<PayoutFrequency>;
  /** День / Ночь */
  period: ShiftTime;
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Кол-во дней стажировки */
  probationPeriod?: InputMaybe<Scalars['Int']['input']>;
  /** Необходимые документы */
  requiredDocuments?: Array<CasingDocumentType>;
  /** Требования */
  requirements?: InputMaybe<Scalars['String']['input']>;
  /** Обязанности */
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  /** IDs типов графиков */
  scheduleTypesIds?: InputMaybe<Array<Scalars['String']['input']>>;
  section?: InputMaybe<Scalars['String']['input']>;
  /** Пол */
  sex?: InputMaybe<Sex>;
  /** Минимальная стоимость оплаты по смене от */
  shiftCostFrom?: Scalars['Float']['input'];
  /** Максимальная стоимость оплаты по смене до */
  shiftCostUpTo?: Scalars['Float']['input'];
  timeEnd?: InputMaybe<Scalars['String']['input']>;
  timeStart?: InputMaybe<Scalars['String']['input']>;
  /** Транспорт */
  transport?: InputMaybe<Scalars['String']['input']>;
  /** Единицы измерения для оплаты */
  unit?: InputMaybe<UnitType>;
  /** Спец. одежда */
  workwear?: Scalars['Boolean']['input'];
};

export type VacancyListInput = {
  /** Город в котором находится вакансия */
  cityId?: InputMaybe<Scalars['String']['input']>;
  /** Объект на котором находится вакансия */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Группа объектов к которой относится вакансия */
  groupId?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Ночь или день */
  period?: InputMaybe<ShiftTime>;
  /** Профессия */
  positionId?: InputMaybe<Scalars['String']['input']>;
  /** Массив строк с значением возможных графиков (прим: [2/2, 5/2]) */
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<VacancyFieldsSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
};

/** Тип адреса */
export enum VacancySearchType {
  Metro = 'Metro',
  Point = 'Point'
}

/** Модель объектов с учетом возможности ожидания получения мед.книжки работником */
export type WaitingFacility = {
  __typename?: 'WaitingFacility';
  /** Адрес объекта */
  address?: Maybe<Address>;
  /** @deprecated Адрес храним в поле addressString */
  addressId?: Maybe<Scalars['String']['output']>;
  /** Адрес объекта */
  addressString?: Maybe<Scalars['String']['output']>;
  /** Массив содержащий список профессий на объекте со ставками по ним */
  casings?: Maybe<Array<Casing>>;
  checkInMeasurement: Scalars['Int']['output'];
  checkOutMeasurement: Scalars['Int']['output'];
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  /** Менеджеры объекта */
  clientManagers?: Maybe<Array<User>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Расчетное поле для расстояния от гео точки в километрах */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Включен или выключен "Всё Возможно Бонус" на объекте */
  everythingIsPossibleBonus: Scalars['Boolean']['output'];
  /** Id объекта в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Галерея фотографий профессии объекта */
  facilityGallery?: Maybe<Array<FacilityGalleryEntity>>;
  facilityGroup?: Maybe<FacilityGroup>;
  facilityGroupId?: Maybe<Scalars['String']['output']>;
  facilitySupervisors: Array<Supervisors>;
  foremen?: Maybe<Array<User>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Есть ли на объекте возможность работать по справке без мед.книжки n-дней */
  isMedInvoiceAllowed: Scalars['Boolean']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** Показывать ли пользователям на объекте бонусы */
  is_bonus_active: Scalars['Boolean']['output'];
  /** Показывать ли пользователям на объекте начисления */
  is_finance_active: Scalars['Boolean']['output'];
  latitude: Scalars['String']['output'];
  legalEntity?: Maybe<LegalEntity>;
  /** Идетнтификатор юр. лица */
  legalEntityId?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['String']['output'];
  manualAccruals: Array<ManualAccrual>;
  metro?: Maybe<Scalars['String']['output']>;
  /** Станции метро */
  metroStations?: Maybe<Array<MetroStation>>;
  /** IDs станций метро */
  metroStationsIds?: Maybe<Array<Scalars['String']['output']>>;
  moderationReports: Array<ModerationReport>;
  /** Идентификатор объекта в Наймикс */
  naimixObjectId?: Maybe<Scalars['String']['output']>;
  /** Название объекта в Наймикс */
  naimixObjectName?: Maybe<Scalars['String']['output']>;
  /** Номер сценария Наймикс */
  naimixScenarioNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** количество дней ожидания медицинской книжки (количество дней действия справки о прохождении осмотра перед получением медицинской книжки) */
  numberDaysWaitMedical: Scalars['Int']['output'];
  /** Массив содержащий список штрафов на объекте */
  penalty?: Maybe<Array<Penalty>>;
  /** Сумма для выплат с учетом % налога 'Всё Возможно Бонус' на объекте */
  possibleBonusPaymentSum: Scalars['Float']['output'];
  /** Количество смен для достижения бонуса "Всё Возможно Бонус" на объекте */
  possibleBonusShiftCount: Scalars['Float']['output'];
  /** Сумма для выплат с учетом % налога "Всё Возможно Бонус" на объекте */
  possibleBonusViewSum: Scalars['Float']['output'];
  publicConditions?: Maybe<Array<PublicCondition>>;
  radius: Scalars['Int']['output'];
  /** Реферальные программы привязанные к объекту */
  referralPrograms?: Maybe<Array<ReferralProgramEntity>>;
  schedules: Array<Schedule>;
  shifts: Array<Shift>;
  /** Показывать ли пользователям заработок до модерации */
  showSalaryBeforeModeration: Scalars['Boolean']['output'];
  subscribers?: Maybe<Array<User>>;
  supervisors?: Maybe<Array<User>>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userExperiences: Array<UserExperience>;
  userGrades: Array<UserGrade>;
  userReviews: Array<UserReview>;
  vacancies?: Maybe<Array<Vacancy>>;
  /** Статус может ли работник работать сегодня на объекте по справке о мед.книжке */
  waitingMedicalStatus: Scalars['Boolean']['output'];
  workPosts?: Maybe<Array<WorkPost>>;
  /** Список заблокированных периодов на объекте */
  workSheetLockedPeriods?: Maybe<Array<WorkSheetLockedPeriodEntity>>;
  zayavkaSchedules: Array<ZayavkaSchedule>;
  zayavkaShifts: Array<ZayavkaShift>;
  zayavkas: Array<Zayavka>;
};

export type WorkPost = {
  __typename?: 'WorkPost';
  /** Когда назначен на рабочее место */
  assignedAt: Scalars['Date']['output'];
  assignedBy: Scalars['String']['output'];
  /** Экземпляр модели объекта, на котором пользователь занимает конкретную должность */
  casing?: Maybe<Facility>;
  /** Экземпляр модели объекта, на котором пользователь занимает конкретную должность */
  facility?: Maybe<Facility>;
  /** id объекта, на котором пользователь занимает конкретную должность */
  facilityId: Scalars['String']['output'];
  /** Возможность стажировки */
  hasProbation: Scalars['Boolean']['output'];
  /** Признак есть ли хотя бы одна отработанная смена после стажировки */
  hasWorkedShift?: Maybe<Scalars['Boolean']['output']>;
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Признак пройдена ли стажировка */
  isProbationFinished?: Maybe<Scalars['Boolean']['output']>;
  /** Тип выплаты за работу */
  payout?: Maybe<PayoutType>;
  /** Объект должности, которую занимает пользователь на объекте (рабочем месте) */
  position?: Maybe<Position>;
  /** id должности, которую занимает пользователь на объекте (рабочем месте) */
  positionId: Scalars['String']['output'];
  /** Дата окончания стажировки в формате YYYY-MM-DD */
  probationEnd?: Maybe<Scalars['String']['output']>;
  /** Период стажировки в календарных днях */
  probationPeriod?: Maybe<Scalars['Int']['output']>;
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  /** Дата начала стажировки в формате YYYY-MM-DD */
  probationStart?: Maybe<Scalars['String']['output']>;
  /** Статус рабочего места */
  status: WorkPostStatus;
  /** Единицы измерения для оплаты */
  unit?: Maybe<UnitType>;
  /** Дата и время создания рабочего места */
  updatedAt: Scalars['Date']['output'];
  /** Объект пользователя, который связан с рабочим местом (должность + объект) */
  user?: Maybe<User>;
  /** Id пользователя, который связан с рабочим местом (должность + объект) */
  userId: Scalars['String']['output'];
};

export type WorkPostAssignHistoryEntity = {
  __typename?: 'WorkPostAssignHistoryEntity';
  /** Когда назначен на должность */
  assignedAt: Scalars['Date']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Когда снят с должности */
  unassignedAt: Scalars['Date']['output'];
  /** Комментарий к снятию с должности */
  unassingComment: Scalars['String']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type WorkPostEntity = {
  __typename?: 'WorkPostEntity';
  /** История сотрудничества */
  assignHistories: Array<WorkPostAssignHistoryEntity>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Есть пробный период? */
  hasProbation: Scalars['Boolean']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Статус активности */
  isActive: Scalars['Boolean']['output'];
  /** Пробный период завершён? */
  isProbationFinished: Scalars['Boolean']['output'];
  /** Объект */
  object: ObjectEntity;
  /** Профессия объекта */
  objectProfession: ObjectProfessionEntity;
  /** Выплата за единицу типа пробного периода */
  probationPayoutType: ProbationPayoutTypeEnum;
  /** Количество типа пробного периода */
  probationPayoutValue: Scalars['Int']['output'];
  /** Тип пробного периода */
  probationPeriodType: ProbationPeriodTypeEnum;
  /** Смены */
  shifts: ShiftEntity;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Пользователь */
  user: UserEntity;
};

/** Должность исполнителя с историей сотрудничества */
export type WorkPostExperienceOutput = {
  __typename?: 'WorkPostExperienceOutput';
  /** Когда назначен на рабочее место */
  assignedAt: Scalars['Date']['output'];
  assignedBy: Scalars['String']['output'];
  /** Экземпляр модели объекта, на котором пользователь занимает конкретную должность */
  casing?: Maybe<Facility>;
  /** Экземпляр модели объекта, на котором пользователь занимает конкретную должность */
  facility?: Maybe<Facility>;
  /** id объекта, на котором пользователь занимает конкретную должность */
  facilityId: Scalars['String']['output'];
  /** Возможность стажировки */
  hasProbation: Scalars['Boolean']['output'];
  /** Признак есть ли хотя бы одна отработанная смена после стажировки */
  hasWorkedShift?: Maybe<Scalars['Boolean']['output']>;
  /** размер оплаты в час */
  hourRate?: Maybe<Scalars['Float']['output']>;
  /** Признак пройдена ли стажировка */
  isProbationFinished?: Maybe<Scalars['Boolean']['output']>;
  /** Тип выплаты за работу */
  payout?: Maybe<PayoutType>;
  /** Объект должности, которую занимает пользователь на объекте (рабочем месте) */
  position?: Maybe<Position>;
  /** id должности, которую занимает пользователь на объекте (рабочем месте) */
  positionId: Scalars['String']['output'];
  /** Дата окончания стажировки в формате YYYY-MM-DD */
  probationEnd?: Maybe<Scalars['String']['output']>;
  /** Период стажировки в календарных днях */
  probationPeriod?: Maybe<Scalars['Int']['output']>;
  /** Ставка за смену на период стажировки */
  probationRate?: Maybe<Scalars['Float']['output']>;
  /** Дата начала стажировки в формате YYYY-MM-DD */
  probationStart?: Maybe<Scalars['String']['output']>;
  /** Статус рабочего места */
  status: WorkPostStatus;
  /** Единицы измерения для оплаты */
  unit?: Maybe<UnitType>;
  /** Дата и время создания рабочего места */
  updatedAt: Scalars['Date']['output'];
  /** Объект пользователя, который связан с рабочим местом (должность + объект) */
  user?: Maybe<User>;
  /** История сотрудничества по профессии на объекте */
  userExperience: Array<UserExperience>;
  /** Id пользователя, который связан с рабочим местом (должность + объект) */
  userId: Scalars['String']['output'];
};

/** Объект доставки бригадиру изменений рабочего места по подписке */
export type WorkPostForemanSubOutput = {
  __typename?: 'WorkPostForemanSubOutput';
  /** Id бригадира */
  userId: Scalars['String']['output'];
  /** Объект рабочего места */
  workPost: WorkPost;
};

/** WorkPost statuses */
export enum WorkPostStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Объект доставки работника изменений рабочего места по подписке */
export type WorkPostWorkerSubOutput = {
  __typename?: 'WorkPostWorkerSubOutput';
  /** Id работника */
  userId: Scalars['String']['output'];
  /** Объект рабочего места */
  workPost: WorkPost;
};

export type WorkSheetLockedPeriodEntity = {
  __typename?: 'WorkSheetLockedPeriodEntity';
  /** Объект */
  author?: Maybe<User>;
  /** Идентификатор пользователя создавшего период */
  authorId: Scalars['String']['output'];
  /** Максимальное количество платежей к выплате */
  countPayments: Scalars['Int']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата исполнения периода */
  dateOfExecution?: Maybe<Scalars['Date']['output']>;
  /** Дата окончания периода */
  endDate: Scalars['Date']['output'];
  /** Идентификатор периода в ERP */
  erpId: Scalars['String']['output'];
  /** Объект */
  facility?: Maybe<Facility>;
  /** Идентификатор объекта периода */
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Слепок табеля */
  snapshot: Array<GetSupervisorWorkSheetDataModel>;
  /** Дата начала периода */
  startDate: Scalars['Date']['output'];
  /** Статус периода */
  status: WorkSheetLockedPeriodStatusEnum;
  /** Общая сумма выплат */
  totalAmount: Scalars['Float']['output'];
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

/** Статусы периодов */
export enum WorkSheetLockedPeriodStatusEnum {
  /** Утверждён */
  Approved = 'APPROVED',
  /** Отменён */
  Cancelled = 'CANCELLED',
  /** Исполнен */
  Executed = 'EXECUTED',
  /** В процессе */
  InProgress = 'IN_PROGRESS',
  /** Отклонён */
  Rejected = 'REJECTED',
  /** Отправлен */
  Sent = 'SENT'
}

/** Объект со списком должностей исполнителя */
export type WorkerFacilityWorkPostsOutput = {
  __typename?: 'WorkerFacilityWorkPostsOutput';
  /** Адрес объекта */
  address?: Maybe<Address>;
  /** @deprecated Адрес храним в поле addressString */
  addressId?: Maybe<Scalars['String']['output']>;
  /** Адрес объекта */
  addressString?: Maybe<Scalars['String']['output']>;
  /** Массив содержащий список профессий на объекте со ставками по ним */
  casings?: Maybe<Array<Casing>>;
  checkInMeasurement: Scalars['Int']['output'];
  checkOutMeasurement: Scalars['Int']['output'];
  city?: Maybe<City>;
  cityId?: Maybe<Scalars['String']['output']>;
  /** Менеджеры объекта */
  clientManagers?: Maybe<Array<User>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Расчетное поле для расстояния от гео точки в километрах */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Включен или выключен "Всё Возможно Бонус" на объекте */
  everythingIsPossibleBonus: Scalars['Boolean']['output'];
  /** Id объекта в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Галерея фотографий профессии объекта */
  facilityGallery?: Maybe<Array<FacilityGalleryEntity>>;
  facilityGroup?: Maybe<FacilityGroup>;
  facilityGroupId?: Maybe<Scalars['String']['output']>;
  facilitySupervisors: Array<Supervisors>;
  foremen?: Maybe<Array<User>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Есть ли на объекте возможность работать по справке без мед.книжки n-дней */
  isMedInvoiceAllowed: Scalars['Boolean']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  /** Показывать ли пользователям на объекте бонусы */
  is_bonus_active: Scalars['Boolean']['output'];
  /** Показывать ли пользователям на объекте начисления */
  is_finance_active: Scalars['Boolean']['output'];
  latitude: Scalars['String']['output'];
  legalEntity?: Maybe<LegalEntity>;
  /** Идетнтификатор юр. лица */
  legalEntityId?: Maybe<Scalars['String']['output']>;
  longitude: Scalars['String']['output'];
  manualAccruals: Array<ManualAccrual>;
  metro?: Maybe<Scalars['String']['output']>;
  /** Станции метро */
  metroStations?: Maybe<Array<MetroStation>>;
  /** IDs станций метро */
  metroStationsIds?: Maybe<Array<Scalars['String']['output']>>;
  moderationReports: Array<ModerationReport>;
  /** Идентификатор объекта в Наймикс */
  naimixObjectId?: Maybe<Scalars['String']['output']>;
  /** Название объекта в Наймикс */
  naimixObjectName?: Maybe<Scalars['String']['output']>;
  /** Номер сценария Наймикс */
  naimixScenarioNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** количество дней ожидания медицинской книжки (количество дней действия справки о прохождении осмотра перед получением медицинской книжки) */
  numberDaysWaitMedical: Scalars['Int']['output'];
  /** Массив содержащий список штрафов на объекте */
  penalty?: Maybe<Array<Penalty>>;
  /** Сумма для выплат с учетом % налога 'Всё Возможно Бонус' на объекте */
  possibleBonusPaymentSum: Scalars['Float']['output'];
  /** Количество смен для достижения бонуса "Всё Возможно Бонус" на объекте */
  possibleBonusShiftCount: Scalars['Float']['output'];
  /** Сумма для выплат с учетом % налога "Всё Возможно Бонус" на объекте */
  possibleBonusViewSum: Scalars['Float']['output'];
  publicConditions?: Maybe<Array<PublicCondition>>;
  radius: Scalars['Int']['output'];
  /** Реферальные программы привязанные к объекту */
  referralPrograms?: Maybe<Array<ReferralProgramEntity>>;
  schedules: Array<Schedule>;
  shifts: Array<Shift>;
  /** Показывать ли пользователям заработок до модерации */
  showSalaryBeforeModeration: Scalars['Boolean']['output'];
  subscribers?: Maybe<Array<User>>;
  supervisors?: Maybe<Array<User>>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userExperiences: Array<UserExperience>;
  userGrades: Array<UserGrade>;
  userReviews: Array<UserReview>;
  vacancies?: Maybe<Array<Vacancy>>;
  workPosts?: Maybe<Array<WorkPost>>;
  /** Список заблокированных периодов на объекте */
  workSheetLockedPeriods?: Maybe<Array<WorkSheetLockedPeriodEntity>>;
  /** Должности исполнителя на объекте */
  workposts: Array<WorkPostExperienceOutput>;
  zayavkaSchedules: Array<ZayavkaSchedule>;
  zayavkaShifts: Array<ZayavkaShift>;
  zayavkas: Array<Zayavka>;
};

/** Юзер с полями: даты мед.книжки, корешок, апрув на мед.книжку, апрув на корешок */
export type WorkerWithMedical = {
  __typename?: 'WorkerWithMedical';
  /** Объекты, на которых пользователь является Бригадиром */
  Facility_FOREMAN?: Maybe<Array<Facility>>;
  /** Объекты в которых пользователь Супервайзер */
  Facility_SUPERVISOR?: Maybe<Array<Facility>>;
  /** Документы, которые пользователь рассматривает */
  allDocumentsReviews: Array<DocumentReview>;
  /** Разрешить работать без Наймикс */
  allowWorkWithoutNaimix: Scalars['Boolean']['output'];
  /** Гражданство */
  citizenship?: Maybe<Country>;
  citizenshipId?: Maybe<Scalars['String']['output']>;
  /** Город */
  city?: Maybe<City>;
  /** Id города */
  cityId?: Maybe<Scalars['String']['output']>;
  /** Комментарии к сменам */
  comments: Array<CommentEntity>;
  contactPhones?: Maybe<Array<ContactPhone>>;
  /** Контракты пользователя */
  contracts?: Maybe<Array<UserContract>>;
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  currentVersion?: Maybe<Scalars['String']['output']>;
  deletedAt: Scalars['Date']['output'];
  documentReviewMedicalBook: Scalars['Boolean']['output'];
  documentReviewMedicalInvoice: Scalars['Boolean']['output'];
  /** Файлы документов загруженные пользователю */
  documents: Array<UserDocumentEntity>;
  /** Статус проверки документов */
  documentsStatus: DocumentsStatus;
  /** Email address */
  email?: Maybe<Scalars['String']['output']>;
  /** Id пользователя в ERP */
  externalId?: Maybe<Scalars['String']['output']>;
  /** Объекты в которых пользователь Менеджер */
  facilitiesManager?: Maybe<Array<Facility>>;
  /** Имя */
  firstname: Scalars['String']['output'];
  /** Количество хороших смен пользователя */
  goodShiftCount?: Maybe<Scalars['Int']['output']>;
  groupManagers: Array<GroupManager>;
  /** Группы в которых пользователь Директор */
  groupsDirector?: Maybe<Array<FacilityGroup>>;
  /** Группы в которых пользователь назначен как Менеджер */
  groupsManager?: Maybe<Array<FacilityGroup>>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['Date']['output']>;
  /** Фамилия */
  lastname: Scalars['String']['output'];
  /** Лид */
  lead?: Maybe<Lead>;
  legalEntities: Array<LegalEntity>;
  manualAccrualItems: Array<ManualAccrualItem>;
  manualUserAccruals: Array<ManualUserAccrual>;
  marks?: Maybe<Array<Mark>>;
  /** Даты конца аттестации строка даты YYYY-MM-DD */
  medicalAttestationEnd?: Maybe<Scalars['String']['output']>;
  /** Даты начала аттестации строка даты YYYY-MM-DD */
  medicalAttestationStart?: Maybe<Scalars['String']['output']>;
  /** Дата выдачи медицинской справки (о прохождении осмотра перед получением медицинской книжки) */
  medicalInvoiceIssueDate?: Maybe<Scalars['Date']['output']>;
  /** Документы пользователя на рассмотрении */
  myDocumentsReviews: Array<DocumentReview>;
  notifications: Array<Notification>;
  /** Отчество */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** Телефон */
  phone: Scalars['String']['output'];
  /** Id должности */
  positionId?: Maybe<Scalars['String']['output']>;
  /** Анкета */
  questionnaire?: Maybe<Questionnaire>;
  referrals?: Maybe<Array<User>>;
  referrer?: Maybe<User>;
  referrerId?: Maybe<Scalars['String']['output']>;
  /** Состояние регистрации пользователя в Наймикс */
  registrationState?: Maybe<UserRegistrationState>;
  reports: Array<Report>;
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реквизиты пользователя (отельная модель) */
  requisite?: Maybe<Requisite>;
  respondedVacancies?: Maybe<Array<Vacancy>>;
  /** Роль */
  role: Role;
  schedule?: Maybe<Array<Schedule>>;
  /** Смены пользователя */
  shifts?: Maybe<Array<Shift>>;
  /** подписка на объекты, о желании на них работать */
  subscribedFacility?: Maybe<Array<Facility>>;
  subscribers: Array<Subscribers>;
  supervisors: Array<Supervisors>;
  temporaryShifts: Array<TemporaryShift>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userActivityLogs: Array<UserActivityLog>;
  /** Автоматический рейтинг пользователя */
  userAutoRating?: Maybe<UserRatingEntity>;
  userDevice: UserDevice;
  /** История опыта работника */
  userExperience?: Maybe<Array<UserExperience>>;
  /** История опыта работника */
  userGrade?: Maybe<Array<UserGrade>>;
  userGradeAuthor?: Maybe<Array<UserGrade>>;
  /** История опыта работника */
  userReview?: Maybe<Array<UserReview>>;
  userReviewAuthor: Array<UserReview>;
  /** Рабочие места пользователя */
  workposts?: Maybe<Array<WorkPost>>;
};

export type Zayavka = {
  __typename?: 'Zayavka';
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Даты окончания заявки в формате Date object / ISO Datetime */
  dateFrom: Scalars['Date']['output'];
  /** Дата начала заявки в формате Date object / ISO Datetime */
  dateTimeFrom: Scalars['Date']['output'];
  /** Даты окончания заявки в формате Date object / ISO Datetime */
  dateTimeTo: Scalars['Date']['output'];
  dateTo: Scalars['String']['output'];
  /** Объект на который назначена заявка */
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  plans: Array<ZayavkaPlan>;
  shifts: Array<Shift>;
  /** Статус заявки */
  status: ZayavkaStage;
  /** Статус заявки */
  toCancel: ZayavkaToCancelStatus;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Изменения заявки */
  zayavkaChanges?: Maybe<Array<ZayavkaChanges>>;
  /** Массив с графиками заявки */
  zayavkaSchedule?: Maybe<Array<ZayavkaSchedule>>;
  /** Массив со сменами заявки */
  zayavkaShift?: Maybe<Array<ZayavkaShift>>;
};

/** Sub statuses statuses of Zayavka */
export enum ZayavkaByFacilityDisplay {
  /** Новые и открытые */
  Active = 'ACTIVE',
  /** Все */
  All = 'ALL',
  /** Выполненные и закрытые */
  Finished = 'FINISHED'
}

export type ZayavkaCardInput = {
  /** Дата начала заявки в формате YYYY-MM-DD */
  dateFrom: Scalars['String']['input'];
  /** Даты окончания заявки в формате YYYY-MM-DD */
  dateTo: Scalars['String']['input'];
  /** Идентификатор объекта */
  facilityId: Scalars['String']['input'];
  /** Массив с должностями и планом количества смен/часов в заявке */
  plans: Array<ZayavkaPlanInput>;
};

export type ZayavkaChanges = {
  __typename?: 'ZayavkaChanges';
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Прогресс согласования заявки */
  stage: ZayavkaChangesStatus;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Заявка к которой относится этот экземпляр плана в заявке */
  zayavka?: Maybe<Zayavka>;
  zayavkaId: Scalars['String']['output'];
};

/** Sub statuses statuses of Zayavka */
export enum ZayavkaChangesStatus {
  /** Изменения подтверждены, ожидают отправки супервайзеру */
  Accepted = 'ACCEPTED',
  /** Изменения внесены, не отправлены и не подтверждены */
  Draft = 'DRAFT',
  /** Изменения в заявке отклонены директором */
  Ineligible = 'INELIGIBLE',
  /** Заявка одобрена, ждет одобрения супервайзером */
  New = 'NEW',
  /** Супервайзер не одобрил изменения */
  Refused = 'REFUSED',
  /** Изменения ожидают подтверждения директором */
  Waiting = 'WAITING'
}

/** поле по которому произойдет сортировка в заявках */
export enum ZayavkaFieldsSorting {
  DateFrom = 'dateFrom',
  Number = 'number',
  UpdatedAt = 'updatedAt'
}

export type ZayavkaListInput = {
  /** Дата начала заявки в формате YYYY-MM-DD */
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  /** Даты окончания заявки в формате YYYY-MM-DD */
  dateTo?: InputMaybe<Scalars['String']['input']>;
  /** Объект по которому отфильтровать заявки */
  facilityId?: InputMaybe<Scalars['String']['input']>;
  /** Id группы объектов для фильтрации */
  groupId?: InputMaybe<Scalars['String']['input']>;
  /** Номер заявки который требуется найти */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Номер страницы */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Строка поиска */
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  /** Количество элементов на странице */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** поле по которому сортировка, по умолчанию updatedAt */
  sortBy?: InputMaybe<ZayavkaFieldsSorting>;
  /** Направление сортировки */
  sortWay?: InputMaybe<SortingWay>;
  /** Статус заявки */
  status?: InputMaybe<Scalars['String']['input']>;
};

/** Модель для плана в заявке по каждой должности */
export type ZayavkaPlan = {
  __typename?: 'ZayavkaPlan';
  countWorkers: Scalars['Int']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  hours: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Позиция по которой нужны смены в заявке */
  position: Position;
  positionId: Scalars['String']['output'];
  shiftCount: Scalars['Int']['output'];
  shiftDuration: Scalars['Int']['output'];
  timesOfDay: ShiftTime;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Заявка к которой относится этот экземпляр плана в заявке */
  zayavka?: Maybe<Zayavka>;
  zayavkaId: Scalars['String']['output'];
};

/** Плановые значения по должностям заявки */
export type ZayavkaPlanInput = {
  /** Количество работников */
  countWorkers?: Scalars['Int']['input'];
  /** Продолжительность смены */
  hours?: Scalars['Int']['input'];
  /** Идентификатор профессии */
  positionId: Scalars['String']['input'];
  /** Количество смен */
  shiftCount?: Scalars['Int']['input'];
  /** Продолжительность перерыва */
  shiftDuration?: Scalars['Int']['input'];
  /** Время дня */
  timesOfDay?: ShiftTime;
};

export type ZayavkaProgress = {
  __typename?: 'ZayavkaProgress';
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Даты окончания заявки в формате Date object / ISO Datetime */
  dateFrom: Scalars['Date']['output'];
  /** Дата начала заявки в формате Date object / ISO Datetime */
  dateTimeFrom: Scalars['Date']['output'];
  /** Даты окончания заявки в формате Date object / ISO Datetime */
  dateTimeTo: Scalars['Date']['output'];
  dateTo: Scalars['String']['output'];
  /** Объект на который назначена заявка */
  facility?: Maybe<Facility>;
  facilityId: Scalars['String']['output'];
  /** Сколько всего часов запланировано в заявке */
  hoursPlanCount: Scalars['Int']['output'];
  /** Сколько часов в заявке проставлено в графики */
  hoursScheduleCount: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  number: Scalars['Int']['output'];
  plans: Array<ZayavkaPlan>;
  shifts: Array<Shift>;
  /** Сколько всего смен запланировано в заявке */
  shiftsPlanCount: Scalars['Int']['output'];
  /** Сколько смен в заявке проставлено в графики */
  shiftsScheduleCount: Scalars['Int']['output'];
  /** Статус заявки */
  status: ZayavkaStage;
  /** Статус заявки */
  toCancel: ZayavkaToCancelStatus;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Изменения заявки */
  zayavkaChanges?: Maybe<Array<ZayavkaChanges>>;
  /** Массив с графиками заявки */
  zayavkaSchedule?: Maybe<Array<ZayavkaSchedule>>;
  /** Массив со сменами заявки */
  zayavkaShift?: Maybe<Array<ZayavkaShift>>;
};

export type ZayavkaSchedule = {
  __typename?: 'ZayavkaSchedule';
  /** Id автора графика в заявке */
  authorId: Scalars['String']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время подтверждения графика Работником которого назначил супервайзер */
  dateAccept?: Maybe<Scalars['Date']['output']>;
  /** Дата и время начала графика */
  dateFrom: Scalars['Date']['output'];
  /** Дата и время окончания графика */
  dateTo: Scalars['Date']['output'];
  /** Тип графика: 1 - 2/2; 2 - 4/2; 3 - 5/2; 4 - 6/1; 5 - 7/0 (рабочих дней / выходные) */
  dayInterleaving?: Maybe<Scalars['Int']['output']>;
  facility: Facility;
  /** Id объекта */
  facilityId: Scalars['String']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  isEdited: Scalars['Boolean']['output'];
  isNew: Scalars['Boolean']['output'];
  /** Длительность обедав графике */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Дата и время начала графика (Новое) */
  newDateFrom?: Maybe<Scalars['Date']['output']>;
  /** Дата и время окончания графика (Новое) */
  newDateTo?: Maybe<Scalars['Date']['output']>;
  /** Тип графика (Новое) */
  newDayInterleaving?: Maybe<Scalars['Int']['output']>;
  /** Длительность обеда в графике (Новое) */
  newLunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Новый тип графика */
  newScheduleType?: Maybe<ScheduleType>;
  /** Идентификатор нового типа графика */
  newScheduleTypeId?: Maybe<Scalars['String']['output']>;
  /** Длительность смены в графике, (Новое) */
  newShiftDuration?: Maybe<Scalars['Int']['output']>;
  /** Должность */
  position?: Maybe<Position>;
  /** Id должности */
  positionId: Scalars['String']['output'];
  /** Id графика назначенного пользователю */
  scheduleId?: Maybe<Scalars['String']['output']>;
  /** Тип графика */
  scheduleType?: Maybe<ScheduleType>;
  /** Идентификатор типа графика */
  scheduleTypeId?: Maybe<Scalars['String']['output']>;
  schedules: Array<Schedule>;
  /** Длительность смены в графике, необязательное */
  shiftDuration?: Maybe<Scalars['Int']['output']>;
  /** Время дня */
  timesOfDay: ShiftTime;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Заявка */
  zayavka?: Maybe<Zayavka>;
  /** Id заявки к которой относится график */
  zayavkaId: Scalars['String']['output'];
  zayavkaShift: Array<ZayavkaShift>;
};

export type ZayavkaScheduleInput = {
  /** Количество создаваемых графиков */
  countSchedules?: InputMaybe<Scalars['Int']['input']>;
  /** Обязательное! время окончания графика и последней смены */
  dateEnd: Scalars['DateTime']['input'];
  /** Обязательное! время начала графика и первой смены */
  dateStart: Scalars['DateTime']['input'];
  /** Тип графика: 1 - 2/2; 2 - 4/2; 3 - 5/2; 4 - 6/1; 5 - 7/0 (рабочих дней / выходные) */
  dayInterleaving?: InputMaybe<Scalars['Int']['input']>;
  /** Тип графика: 1 - 2/2; 2 - 4/2; 3 - 5/2; 4 - 6/1; 5 - 7/0 (рабочих дней / выходные) */
  dayInterleavingId?: InputMaybe<Scalars['String']['input']>;
  /** объект на который устанавливается график */
  facilityId: Scalars['String']['input'];
  /** длительность обеда в минутах */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
  /** позиция на которую устанавливается график */
  positionId: Scalars['String']['input'];
  /** Обязательное! Время окочания первой смены в графике для определения длительности смены */
  shiftEndDate: Scalars['DateTime']['input'];
  /** Время дня */
  timesOfDay?: ShiftTime;
  /** Id заявки к которой относится график */
  zayavkaId: Scalars['String']['input'];
};

/** Модель плана смен в заявке (смены графика заявки по шаблону которых будут создавать смены работникам) */
export type ZayavkaShift = {
  __typename?: 'ZayavkaShift';
  /** Id автора смены */
  authorId: Scalars['String']['output'];
  cost: Scalars['Int']['output'];
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Дата и время конца */
  dateEnd: Scalars['Date']['output'];
  /** Дата начала смены */
  dateFrom: Scalars['Date']['output'];
  /** длительность смены в минутах */
  duration: Scalars['Int']['output'];
  /** Объект к которому относится смена в заявке */
  facility?: Maybe<Facility>;
  /** Id объекта смены */
  facilityId: Scalars['String']['output'];
  hourRate: Scalars['Int']['output'];
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Помечено как к удалению? */
  isDeleted: Scalars['Boolean']['output'];
  /** Пометка о том, что смена редактировалась */
  isEdited: Scalars['Boolean']['output'];
  /** Смена в статусе "Свободная"? */
  isFree: Scalars['Boolean']['output'];
  /** Новая смена? */
  isNew: Scalars['Boolean']['output'];
  /** длительность обеда в минутах */
  lunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Дата и время конца (новая) */
  newDateEnd?: Maybe<Scalars['Date']['output']>;
  /** Дата начала смены (новая) */
  newDateFrom?: Maybe<Scalars['Date']['output']>;
  /** длительность обеда в минутах (новая) */
  newLunchDuration?: Maybe<Scalars['Int']['output']>;
  /** Тип выплаты за работу */
  payout?: Maybe<PayoutType>;
  /** Id позиции смены */
  positionId: Scalars['String']['output'];
  /** Массив содержащий список откликнувшихся на свободную смену пользователей */
  requestShiftSuggestions: Array<RequestShiftSuggestionEntity>;
  /** Реальная смена работника, через которую назначен работник на смену заявки */
  shift?: Maybe<Shift>;
  /** Id смены к которой относится смена в заявке */
  shiftId?: Maybe<Scalars['String']['output']>;
  /** Единицы измерения для оплаты */
  unit?: Maybe<UnitType>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  /** Заявка к которой относится смена */
  zayavka: Zayavka;
  /** Id заявки к которой относится смена */
  zayavkaId: Scalars['String']['output'];
  /** График к которому относится смена в заявке */
  zayavkaSchedule?: Maybe<ZayavkaSchedule>;
  /** Id графика заявки */
  zayavkaScheduleId: Scalars['String']['output'];
};

export type ZayavkaShiftByClientInput = {
  /** Дата и время конца */
  dateEnd: Scalars['DateTime']['input'];
  /** Дата начала смены */
  dateFrom: Scalars['DateTime']['input'];
  /** длительность обеда в минутах */
  lunchDuration?: InputMaybe<Scalars['Int']['input']>;
};

export enum ZayavkaShiftSuggestionsStatusEnum {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  New = 'NEW'
}

/** Статусы жизненного цикла заявки */
export enum ZayavkaStage {
  /** Новая созданная заявка без заполнения графиками */
  Blank = 'BLANK',
  /** заявка отменена клиентом */
  Canceled = 'CANCELED',
  /** В заявке проставлены графики, ожидает отправка супервайзеру */
  Draft = 'DRAFT',
  /** все смены по заявке отработаны */
  Finished = 'FINISHED',
  /** заявка отправлена супервайзеру, ждет одобрения */
  New = 'NEW',
  /** заявка отклонена супервайзером */
  Refused = 'REFUSED',
  /** заявка взята в работу супервайзером - смены назначаются */
  Working = 'WORKING'
}

/** Статусы использующиеся в случае отметки заявки к удалению */
export enum ZayavkaToCancelStatus {
  /** директор подтвердил удаление заявки */
  Accepted = 'ACCEPTED',
  /** директор отклонил удаление заявки */
  Ineligible = 'INELIGIBLE',
  /** заявка не отмечена к удалению */
  None = 'NONE',
  /** заявка помечена к удалению менеджером, ожидание действия директора */
  Waiting = 'WAITING'
}

/** Данные для непосредственно экрана табеля */
export type ResolveReportUserModel = {
  __typename?: 'resolveReportUserModel';
  /** Дата и время создания */
  createdAt: Scalars['Date']['output'];
  /** Исключить из отчета */
  disable: Scalars['Boolean']['output'];
  /** Фамилия и Имя */
  fio?: Maybe<Scalars['String']['output']>;
  /** Уникальный идентификатор */
  id: Scalars['ID']['output'];
  /** Телефон */
  phone?: Maybe<Scalars['String']['output']>;
  /** Дата и время обновления */
  updatedAt?: Maybe<Scalars['Date']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};
